
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8OcYi", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $bw5Pv = parcelRequire("bw5Pv");


var $kAdyG = parcelRequire("kAdyG");

const $133fea730ff32cc6$var$extractEntityEmbedUrl = (response)=>{
    const entity = (0, $8YE7G.extractEntity)(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $133fea730ff32cc6$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $133fea730ff32cc6$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $bw5Pv.extractPreview)(response?.data, 'web', iframeUrlType);
};
module.exports["extractSmartLinkEmbed"] = $133fea730ff32cc6$export$864b719baf5d744d;

});

parcelRegister("8YE7G", function(module, exports) {
const $2314486570b67846$export$8beff7405d020ddf = (response)=>response?.entityData;
module.exports["extractEntity"] = $2314486570b67846$export$8beff7405d020ddf;

});

parcelRegister("bw5Pv", function(module, exports) {

var $bnAp5 = parcelRequire("bnAp5");


var $1kPn4 = parcelRequire("1kPn4");

const $ba88b61fea6ab33b$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $bnAp5.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $1kPn4.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $1kPn4.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $ba88b61fea6ab33b$export$4b0d98b1b7f6d115;

});

parcelRegister("bnAp5", function(module, exports) {
const $8a5fa431dcdb46ea$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
module.exports["extractPlatformIsSupported"] = $8a5fa431dcdb46ea$export$3e8ad908070b68b2;

});

parcelRegister("1kPn4", function(module, exports) {
const $bf5386804c668b8a$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $bf5386804c668b8a$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
module.exports["extractUrlFromLinkJsonLd"] = $bf5386804c668b8a$export$396ba4ef2e37dc65;

});

parcelRegister("kAdyG", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");

const $6304996d67e1cd7c$export$c7168210b81d9383 = (response)=>Boolean((0, $8YE7G.extractEntity)(response));
module.exports["isEntityPresent"] = $6304996d67e1cd7c$export$c7168210b81d9383;

});

parcelRegister("jMcHR", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $04c77007239bb1c9$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $1kPn4.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $04c77007239bb1c9$export$63f54cf4c5883620;

});

parcelRegister("kzwaO", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

var $cXJjm = parcelRequire("cXJjm");

const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;


const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $ef9de7657ea9d2d2$export$7469f9cd9cda802c);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $ef9de7657ea9d2d2$export$e2b040f052407032) ? (0, $ef9de7657ea9d2d2$export$e2b040f052407032)[envKey] : (0, $ef9de7657ea9d2d2$export$7469f9cd9cda802c);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("4yccB", function(module, exports) {
var $09ebb3b1b19cd625$exports = {};
// Packages
var $f6da0fdbecad09df$exports = {};

$f6da0fdbecad09df$exports = (parcelRequire("4co4r"));


function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $f6da0fdbecad09df$exports.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
$09ebb3b1b19cd625$exports = $09ebb3b1b19cd625$var$retry;



var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");

var $7ac4702e317338af$exports = {};
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
$7ac4702e317338af$exports = $7ac4702e317338af$var$pThrottle;
$7ac4702e317338af$exports.AbortError = $7ac4702e317338af$var$AbortError;



var $ixC10 = parcelRequire("ixC10");

var $cXJjm = parcelRequire("cXJjm");

var $ggGdk = parcelRequire("ggGdk");
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}


var $2g31M = parcelRequire("2g31M");

var $j39Hd = parcelRequire("j39Hd");


var $iDrrr = parcelRequire("iDrrr");

const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};


const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};


const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7ac4702e317338af$exports)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $8165f67089b396cb$export$19fa02dd69bd4efd)(error);
        }
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        const isInlineOptEnabled = appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        // Include appearance in cache key when feature flag is enabled and appearance is specified
        const cacheKey = isInlineOptEnabled ? `${url}|${appearance}` : url;
        let responsePromise;
        responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined,
                // Pass appearance to ORS when feature flag is enabled
                ...isInlineOptEnabled ? {
                    appearance: appearance
                } : {}
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $d86f0936ed92dc7f$export$1b59fe731a28a49d)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $d86f0936ed92dc7f$export$1b59fe731a28a49d)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($09ebb3b1b19cd625$exports)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $d86f0936ed92dc7f$export$1b59fe731a28a49d)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $3cbc4520680d3a92$export$bea7bee8a87e7c52)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($09ebb3b1b19cd625$exports)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $d86f0936ed92dc7f$export$1b59fe731a28a49d)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $3cbc4520680d3a92$export$bea7bee8a87e7c52)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $3cbc4520680d3a92$export$bea7bee8a87e7c52)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $3cbc4520680d3a92$export$bea7bee8a87e7c52)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("4co4r", function(module, exports) {
var $636f7d2929f63478$exports = {};
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
$636f7d2929f63478$exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};


exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $636f7d2929f63478$exports(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("7qSpV", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $56952c3740bbf8b1$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ /**
 *
 * common
 *
 */ /** @private */ function $2f7c9f61bcd34c23$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a(val) {
    return $2f7c9f61bcd34c23$export$573326049e1b1c6b(val) === 'object';
}
function $2f7c9f61bcd34c23$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $2f7c9f61bcd34c23$export$92bd080471bc30f1(val) {
    return $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $2f7c9f61bcd34c23$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $2f7c9f61bcd34c23$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}


const $6285c63a1d0de0f5$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $6285c63a1d0de0f5$export$ec743af8bb66f3be = 'graphql-ws';
var $6285c63a1d0de0f5$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($6285c63a1d0de0f5$export$777128f41f6616ec || ($6285c63a1d0de0f5$export$777128f41f6616ec = {}));
var $6285c63a1d0de0f5$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($6285c63a1d0de0f5$export$80edbf15fa61a4db || ($6285c63a1d0de0f5$export$80edbf15fa61a4db = {}));
function $6285c63a1d0de0f5$export$c17861b159b1b673(val) {
    if (!(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.type)}`);
    switch(val.type){
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.ConnectionInit:
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.ConnectionAck:
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Ping:
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload.extensions)}`);
            break;
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.payload)}`);
            break;
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $2f7c9f61bcd34c23$export$e6262fbc2e92290)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $6285c63a1d0de0f5$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $2f7c9f61bcd34c23$export$573326049e1b1c6b)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $6285c63a1d0de0f5$export$9e0e49e75fa7d548(val) {
    try {
        $6285c63a1d0de0f5$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $6285c63a1d0de0f5$export$f2f615077a189f21(data, reviver) {
    return $6285c63a1d0de0f5$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $6285c63a1d0de0f5$export$77896e5b47bfd50b(msg, replacer) {
    $6285c63a1d0de0f5$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}



var $56952c3740bbf8b1$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $56952c3740bbf8b1$var$__await ? (this.v = v, this) : new $56952c3740bbf8b1$var$__await(v);
};
var $56952c3740bbf8b1$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $56952c3740bbf8b1$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $56952c3740bbf8b1$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $56952c3740bbf8b1$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$56952c3740bbf8b1$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $6285c63a1d0de0f5$export$5c0a4edfedc7c457));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $6285c63a1d0de0f5$export$77896e5b47bfd50b)({
                                    type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $56952c3740bbf8b1$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $6285c63a1d0de0f5$export$77896e5b47bfd50b)(payload ? {
                            type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $6285c63a1d0de0f5$export$777128f41f6616ec).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $6285c63a1d0de0f5$export$777128f41f6616ec).InternalClientError, (0, $2f7c9f61bcd34c23$export$2937fa0c8dddae54)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $6285c63a1d0de0f5$export$f2f615077a189f21)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $6285c63a1d0de0f5$export$77896e5b47bfd50b)(message.payload ? {
                                    type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $6285c63a1d0de0f5$export$777128f41f6616ec).BadResponse, (0, $2f7c9f61bcd34c23$export$2937fa0c8dddae54)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($56952c3740bbf8b1$var$isLikeCloseEvent(errOrCloseEvent) && ($56952c3740bbf8b1$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).InternalServerError,
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).InternalClientError,
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).BadRequest,
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).BadResponse,
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).SubscriberAlreadyExists,
            (0, $6285c63a1d0de0f5$export$777128f41f6616ec).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($56952c3740bbf8b1$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $6285c63a1d0de0f5$export$77896e5b47bfd50b)({
                    id: id,
                    type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $6285c63a1d0de0f5$export$77896e5b47bfd50b)({
                        id: id,
                        type: (0, $6285c63a1d0de0f5$export$80edbf15fa61a4db).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $56952c3740bbf8b1$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $56952c3740bbf8b1$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $56952c3740bbf8b1$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $56952c3740bbf8b1$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $56952c3740bbf8b1$export$f5b1bfead8e118a7());
        }
    };
}
class $56952c3740bbf8b1$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $56952c3740bbf8b1$var$isLikeCloseEvent(val) {
    return (0, $2f7c9f61bcd34c23$export$a6cdc56e425d0d0a)(val) && 'code' in val && 'reason' in val;
}
function $56952c3740bbf8b1$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $56952c3740bbf8b1$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});

parcelRegister("4hmAW", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");

/**
 * __Object base__
 *
 * An object represents an Atlassian-specific content type.
 *
 */ const $4e339a24fb8f95a8$var$ObjectBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectBase(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { label: t1, size: t2, testId: testId, color: color, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const t3 = size === "medium" ? "medium" : "small";
    let t4;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            size: t3,
            color: color,
            testId: testId
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function ObjectBase({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
};
var $4e339a24fb8f95a8$export$2e2bcd8739ae039 = $4e339a24fb8f95a8$var$ObjectBase;
module.exports["default"] = $4e339a24fb8f95a8$export$2e2bcd8739ae039;

});

parcelRegister("4wH3g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $34bb8bbd6b8f84d6$require$createLoadable = $jmjWc.createLoadable;

var $398ES = parcelRequire("398ES");

var $34bb8bbd6b8f84d6$require$LoadingPriority = $398ES.LoadingPriority;
function $34bb8bbd6b8f84d6$var$WrappedReactLoadable(opts) {
    const { overrideReactLoadablePriority: overrideReactLoadablePriority } = opts;
    const ReactLoadable = $34bb8bbd6b8f84d6$require$createLoadable(overrideReactLoadablePriority !== undefined ? overrideReactLoadablePriority : $34bb8bbd6b8f84d6$require$LoadingPriority.AFTER_PAINT);
    return ReactLoadable({
        ...opts,
        isReactLoadable: true
    });
}
module.exports = $34bb8bbd6b8f84d6$var$WrappedReactLoadable;

});

parcelRegister("iW3KC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $4hmAW = parcelRequire("4hmAW");

const $86310df99a0045fb$var$BlogObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BlogObject({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $86310df99a0045fb$export$2e2bcd8739ae039 = $86310df99a0045fb$var$BlogObject;
module.exports["default"] = $86310df99a0045fb$export$2e2bcd8739ae039;

});

parcelRegister("6zMm4", function(module, exports) {
async function $7241846434f3c9f6$var$toPromise(callback) {
    return callback();
}
function $7241846434f3c9f6$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $7241846434f3c9f6$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $7241846434f3c9f6$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("624XB")).then(()=>$7241846434f3c9f6$var$getScheduler(globalThis).postTask(callback, options));
        return $7241846434f3c9f6$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $7241846434f3c9f6$export$13c9d02ca54955a3;

});

parcelRegister("624XB", function(module, exports) {

let $4646c6fe7034d0c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4646c6fe7034d0c7$var$load("6fIcR").then(()=>parcelRequire('g5e7a'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("kTGj5", function(module, exports) {
// src/platform/site/types.ts
var $e750bfe4a8cffb59$export$2866935ccba4694c = "platform", $e750bfe4a8cffb59$export$c9ae8b227ea4b550 = "site";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/platform/site/manifest.ts
var $f369c2eff134948b$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $e750bfe4a8cffb59$export$2866935ccba4694c),
    resourceType: (0, $e750bfe4a8cffb59$export$c9ae8b227ea4b550),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $f369c2eff134948b$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f369c2eff134948b$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $f369c2eff134948b$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $f369c2eff134948b$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $f369c2eff134948b$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $f369c2eff134948b$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $f369c2eff134948b$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $f369c2eff134948b$export$62388e9e87e2e1c9;

});

parcelRegister("9EOlJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

'use client';
const $707ee7d44aafa1fc$export$b16d9fb1a22de840 = (0, $cozmU.createContext)(null);
const $707ee7d44aafa1fc$var$initialState = {
    didCatch: false,
    error: null
};
class $707ee7d44aafa1fc$export$e926676385687eaf extends (0, $cozmU.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($707ee7d44aafa1fc$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $707ee7d44aafa1fc$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($707ee7d44aafa1fc$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $cozmU.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $cozmU.createElement)($707ee7d44aafa1fc$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $707ee7d44aafa1fc$var$initialState;
    }
}
function $707ee7d44aafa1fc$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $707ee7d44aafa1fc$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $707ee7d44aafa1fc$export$c052f6604b7d51fe() {
    const context = (0, $cozmU.useContext)($707ee7d44aafa1fc$export$b16d9fb1a22de840);
    $707ee7d44aafa1fc$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $cozmU.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $cozmU.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $707ee7d44aafa1fc$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $cozmU.forwardRef)((props, ref)=>(0, $cozmU.createElement)($707ee7d44aafa1fc$export$e926676385687eaf, errorBoundaryProps, (0, $cozmU.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $707ee7d44aafa1fc$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $707ee7d44aafa1fc$export$f0c7a449e0cfaec7;

});

parcelRegister("d5gEx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $dyU9d = parcelRequire("dyU9d");


var $6tLhV = parcelRequire("6tLhV");

function $84248308b4e2dc22$export$6c22afad970ad5ac({ children: children }) {
    const existingRelayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    // If a compatible relay environment (one created via `createRelayEnvironment`) is already present
    // in the tree, reuse it instead of shadowing it with our own internal environment.
    if (existingRelayContext != null && (0, $dyU9d.isAtlassianRelayEnvironment)(existingRelayContext.environment) && (0, $iDrrr.fg)('relay_environment_-_reuse_product_env_when_exist')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    // Otherwise, fall back to providing the default internal relay environment.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
        environment: (0, $6tLhV.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $84248308b4e2dc22$export$43b1f3e917d65526 = $84248308b4e2dc22$export$6c22afad970ad5ac;
const $84248308b4e2dc22$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84248308b4e2dc22$export$6c22afad970ad5ac, null, children);
};
function $84248308b4e2dc22$export$e237a628f59c9f4e() {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    return (0, $cozmU.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $84248308b4e2dc22$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $84248308b4e2dc22$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $84248308b4e2dc22$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $84248308b4e2dc22$export$e237a628f59c9f4e;

});

parcelRegister("bR8ZK", function(module, exports) {
var $8a1b9f21670a9fd6$var$isProduction = true;
function $8a1b9f21670a9fd6$var$warning(condition, message) {
    if (!$8a1b9f21670a9fd6$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $8a1b9f21670a9fd6$export$2e2bcd8739ae039 = $8a1b9f21670a9fd6$var$warning;
module.exports["default"] = $8a1b9f21670a9fd6$export$2e2bcd8739ae039;

});

parcelRegister("dOgct", function(module, exports) {
const $408a1e49dfb7209e$var$OperationExtensionsMap = {};
const $408a1e49dfb7209e$export$8656ba3981c6f6c1 = (operationName)=>{
    $408a1e49dfb7209e$var$OperationExtensionsMap[operationName] = $408a1e49dfb7209e$var$OperationExtensionsMap[operationName] || [];
};
const $408a1e49dfb7209e$export$f16fa6040161f056 = (operationName)=>{
    $408a1e49dfb7209e$var$OperationExtensionsMap[operationName] = undefined;
};
const $408a1e49dfb7209e$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $408a1e49dfb7209e$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $408a1e49dfb7209e$export$7c6ea4184129ef74 = (operationName)=>$408a1e49dfb7209e$var$OperationExtensionsMap[operationName] || [];
module.exports["startCapturingExtensions"] = $408a1e49dfb7209e$export$8656ba3981c6f6c1;
module.exports["stopCapturingExtensions"] = $408a1e49dfb7209e$export$f16fa6040161f056;
module.exports["putExtensions"] = $408a1e49dfb7209e$export$17dc47fdf278de21;
module.exports["getExtensions"] = $408a1e49dfb7209e$export$7c6ea4184129ef74;

});

parcelRegister("6qzJ0", function(module, exports) {
const $64f1d34c72778c6b$var$OperationTraceIdMap = {};
const $64f1d34c72778c6b$export$a2bcb2fac360646c = (operationName)=>{
    $64f1d34c72778c6b$var$OperationTraceIdMap[operationName] = $64f1d34c72778c6b$var$OperationTraceIdMap[operationName] || [];
};
const $64f1d34c72778c6b$export$559128bdc4352001 = (operationName)=>{
    $64f1d34c72778c6b$var$OperationTraceIdMap[operationName] = undefined;
};
const $64f1d34c72778c6b$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $64f1d34c72778c6b$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $64f1d34c72778c6b$export$5113e470f5c95670 = (operationName)=>$64f1d34c72778c6b$var$OperationTraceIdMap[operationName] || [];
module.exports["startCapturingTraceIds"] = $64f1d34c72778c6b$export$a2bcb2fac360646c;
module.exports["stopCapturingTraceIds"] = $64f1d34c72778c6b$export$559128bdc4352001;
module.exports["addTraceId"] = $64f1d34c72778c6b$export$fcaa732775f12226;
module.exports["getTraceIds"] = $64f1d34c72778c6b$export$5113e470f5c95670;

});

parcelRegister("6tLhV", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dyU9d = parcelRequire("dyU9d");


var $lBg95 = parcelRequire("lBg95");


var $eqEJl = parcelRequire("eqEJl");

function $acc30678b4418c24$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $eqEJl.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $acc30678b4418c24$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $acc30678b4418c24$export$be21c283b097d175 extends (0, $eqEJl.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $acc30678b4418c24$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}


const $58470599bc5aafd2$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $58470599bc5aafd2$export$4a639ebead870a0c = new (0, $acc30678b4418c24$export$be21c283b097d175)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $58470599bc5aafd2$export$df54517d175e6d6b = (0, $dyU9d.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $58470599bc5aafd2$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $lBg95.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $iDrrr.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $lBg95.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $58470599bc5aafd2$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $58470599bc5aafd2$export$df54517d175e6d6b;

});

parcelRegister("hdBxM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $58cf721f500efe5b$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $58cf721f500efe5b$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload',
    'set-message-context',
    'jira-create-context-payload',
    'submit-rovo-remix',
    'rovo-remix-handoff-failed'
]);
const $58cf721f500efe5b$var$isIgnoredForTriggerLatest = (type)=>$58cf721f500efe5b$var$ignoredTriggerLatestEvents.has(type);
const $58cf721f500efe5b$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $58cf721f500efe5b$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$58cf721f500efe5b$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    const clearLatest = (topic)=>{
        delete publishQueue[topic];
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue,
        clearLatest: clearLatest
    };
};
const $58cf721f500efe5b$var$pubSub = $58cf721f500efe5b$var$createPubSub();
const $58cf721f500efe5b$export$89b472e03be495df = (topic, payload)=>{
    $58cf721f500efe5b$var$pubSub.publish(topic, payload);
};
const $58cf721f500efe5b$var$usePubSub = ()=>{
    return $58cf721f500efe5b$var$pubSub;
};
const $58cf721f500efe5b$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, clearLatestOnUnmount: clearLatestOnUnmount, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe, clearLatest: clearLatest } = $58cf721f500efe5b$var$usePubSub();
    const callbackRef = (0, $cozmU.useRef)(callback);
    callbackRef.current = callback;
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return ()=>{
            unsubscribe();
            if (clearLatestOnUnmount) clearLatest(topic);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        clearLatestOnUnmount,
        consumeOnceKey
    ]);
};
const $58cf721f500efe5b$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $58cf721f500efe5b$var$usePubSub();
    const callbackRef = (0, $cozmU.useRef)(callback);
    callbackRef.current = callback;
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $58cf721f500efe5b$var$useFlushOnUnmount = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const active = t0 === undefined ? false : t0;
    const { flushQueue: flushQueue } = $58cf721f500efe5b$var$usePubSub();
    let t1;
    let t2;
    if ($[0] !== active || $[1] !== flushQueue) {
        t1 = ()=>()=>{
                if (active) flushQueue();
            };
        t2 = [
            active,
            flushQueue
        ];
        $[0] = active;
        $[1] = flushQueue;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
} : (active = false)=>{
    const { flushQueue: flushQueue } = $58cf721f500efe5b$var$usePubSub();
    (0, $cozmU.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $58cf721f500efe5b$export$d55c81786220731c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (topic)=>{
    const $ = (0, $bDgLe.c)(3);
    const { publish: publish } = $58cf721f500efe5b$var$usePubSub();
    let t0;
    if ($[0] !== publish || $[1] !== topic) {
        t0 = (payload)=>publish(topic, payload);
        $[0] = publish;
        $[1] = topic;
        $[2] = t0;
    } else t0 = $[2];
    const publishFn = t0;
    return publishFn;
} : (topic)=>{
    const { publish: publish } = $58cf721f500efe5b$var$usePubSub();
    const publishFn = (0, $cozmU.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $58cf721f500efe5b$export$60959659b2c22881 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey } = t0;
    let t1;
    if ($[0] !== consumeOnceKey || $[1] !== topic || $[2] !== triggerLatest) {
        t1 = {
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        };
        $[0] = consumeOnceKey;
        $[1] = topic;
        $[2] = triggerLatest;
        $[3] = t1;
    } else t1 = $[3];
    $58cf721f500efe5b$export$d3d523392640272(t1, onEvent);
    $58cf721f500efe5b$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
} : ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $58cf721f500efe5b$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $58cf721f500efe5b$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};
module.exports["publish"] = $58cf721f500efe5b$export$89b472e03be495df;
module.exports["useSubscribe"] = $58cf721f500efe5b$export$d3d523392640272;
module.exports["useSubscribeAll"] = $58cf721f500efe5b$export$2570c8aa24b6d327;
module.exports["usePublish"] = $58cf721f500efe5b$export$d55c81786220731c;
module.exports["Subscriber"] = $58cf721f500efe5b$export$60959659b2c22881;

});

parcelRegister("6cFsl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e58ea01f5618da68$export$4203fb010fad9bf0 = new WeakMap();
const $e58ea01f5618da68$export$b8b9d90f9e5bd72b = 'react-magnetic-di';



const $f006cb985e49dd75$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $f006cb985e49dd75$export$7804429c45dff272 = {
    state: $f006cb985e49dd75$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $f006cb985e49dd75$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};


let $5926f07271da5d79$var$hasWarned = false;
function $5926f07271da5d79$export$5b28268982f175ba(message) {
    if (!$5926f07271da5d79$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $5926f07271da5d79$var$hasWarned = true;
    }
}
function $5926f07271da5d79$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $e58ea01f5618da68$export$4203fb010fad9bf0).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $f006cb985e49dd75$export$7804429c45dff272).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $5926f07271da5d79$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $e58ea01f5618da68$export$4203fb010fad9bf0).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $5926f07271da5d79$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $5926f07271da5d79$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $5926f07271da5d79$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $f006cb985e49dd75$export$7804429c45dff272).track(candidate);
    return candidate;
}


const $f46612702f4278b5$var$replacementMap = new Map();
const $f46612702f4278b5$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($f46612702f4278b5$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $5926f07271da5d79$export$7c436e151c3ee289)($f46612702f4278b5$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($f46612702f4278b5$var$replacementMap.size) throw new Error(`${(0, $e58ea01f5618da68$export$b8b9d90f9e5bd72b)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $5926f07271da5d79$export$7a7134bdd2f9ae2e)($f46612702f4278b5$var$replacementMap, inj));
    },
    clear () {
        $f46612702f4278b5$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $e58ea01f5618da68$export$4203fb010fad9bf0).get(inj).global) (0, $5926f07271da5d79$export$7a7134bdd2f9ae2e)($f46612702f4278b5$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $5926f07271da5d79$export$8057a2244a849b7b)($f46612702f4278b5$var$replacementMap, inj));
    }
};
function $f46612702f4278b5$export$b887ce09d70113f9(thunk, deps) {
    $f46612702f4278b5$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($f46612702f4278b5$export$a775919ebd7dd28a.clear, $f46612702f4278b5$export$a775919ebd7dd28a.clear);
        else $f46612702f4278b5$export$a775919ebd7dd28a.clear();
    }
}


const $76e2ecd314076920$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    getDependencies: (0, $f46612702f4278b5$export$a775919ebd7dd28a).getDependencies
});



function $4844056aa5883670$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $76e2ecd314076920$export$841858b892ce1f4c)._currentRenderer2 && (0, $76e2ecd314076920$export$841858b892ce1f4c)._currentValue2 || // grab value from default renderer
    (0, $76e2ecd314076920$export$841858b892ce1f4c)._currentValue || (0, $f46612702f4278b5$export$a775919ebd7dd28a);
    return getDependencies(deps, target);
}
module.exports["di"] = $4844056aa5883670$export$479d1ccc5f2ab701;

});

parcelRegister("ln34A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7lxF4 = parcelRequire("7lxF4");


var $a1L5E = parcelRequire("a1L5E");

const $f125ca51cf9188e6$var$GlobalModalErrorFallback = ({ closeModal: closeModal })=>{
    (0, $cozmU.useEffect)(()=>{
        closeModal();
    }, [
        closeModal
    ]);
    return null;
};
const $f125ca51cf9188e6$export$7ca620c75cbaadf0 = {
    PlaceholderComponent: (0, $7lxF4.default),
    UFOSegmentComponent: (0, $a1L5E.default),
    GlobalModalErrorFallback: $f125ca51cf9188e6$var$GlobalModalErrorFallback
};


const $2ac4c675f8be6059$export$ec2e992e3170c3c4 = (0, $f125ca51cf9188e6$export$7ca620c75cbaadf0);


function $cc72c031cd386caf$export$dfa96f26176fa91f() {
    return 0, $2ac4c675f8be6059$export$ec2e992e3170c3c4;
}
module.exports["useEntryPointConfig"] = $cc72c031cd386caf$export$dfa96f26176fa91f;

});

parcelRegister("bPFqZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $h6BA0 = parcelRequire("h6BA0");


var $iDrrr = parcelRequire("iDrrr");

const $c6e49809146a5df5$var$buffer = [];
let $c6e49809146a5df5$var$push = (payload)=>{
    $c6e49809146a5df5$var$buffer.push(payload);
};
function $c6e49809146a5df5$export$b33b857ad1d9900e(payload) {
    $c6e49809146a5df5$var$push(payload);
}
function $c6e49809146a5df5$export$abd5747ea77ecab9(handler) {
    if ((0, $iDrrr.fg)('moving_jira_entry-points_api_under_platform')) {
        $c6e49809146a5df5$var$push = handler;
        $c6e49809146a5df5$var$buffer.forEach((payload)=>handler(payload));
        $c6e49809146a5df5$var$buffer.length = 0;
    }
}



var $ln34A = parcelRequire("ln34A");

function $c2d345a1491c638e$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $ln34A.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $h6BA0.useUFOReportError)();
    const onError = (0, $cozmU.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $c6e49809146a5df5$export$b33b857ad1d9900e)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $cozmU.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PlaceholderComponent, {
        name: placeholderName ?? 'internal-internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    })));
}
function $c2d345a1491c638e$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $ln34A.useEntryPointConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(UFOSegmentComponent, {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c2d345a1491c638e$var$InternalEntryPointContainerInner, props));
}
module.exports["InternalEntryPointContainer"] = $c2d345a1491c638e$export$5d4dc37edd8a3adb;

});

parcelRegister("7qZTr", function(module, exports) {
function $e51a11befeec646f$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}


let $dc703828c4593b61$var$id = 100000;
function $dc703828c4593b61$export$567fc7097e064344() {
    $dc703828c4593b61$var$id += 1;
    return $dc703828c4593b61$var$id.toString();
}



var $dZaA2 = parcelRequire("dZaA2");

function $55deb99bbadfa3f6$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}


function $698cdc7a248fd251$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $dZaA2.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $dZaA2.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $dc703828c4593b61$export$567fc7097e064344)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $dZaA2.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $55deb99bbadfa3f6$export$3b514faac3ba993c)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}


function $90af393d1b70a04a$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $698cdc7a248fd251$export$148e45a6d4b4d65)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}



var $6zMm4 = parcelRequire("6zMm4");

const $2f059a56630e1d6d$var$cache = (0, $e51a11befeec646f$export$cf6fa0bbcc94b912)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $2f059a56630e1d6d$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $2f059a56630e1d6d$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$2f059a56630e1d6d$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    const { chain: chain } = opts ?? {};
    return $2f059a56630e1d6d$var$cache.get(opts.moduleId, ()=>(0, $90af393d1b70a04a$export$4fe5fba5bb1d3c09)(()=>(0, $6zMm4.postTask)(chain ? ()=>chain(Promise.resolve(loaderOrPath())) : loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $2f059a56630e1d6d$export$e83743682263315a;

});

parcelRegister("dZaA2", function(module, exports) {
function $c78824c77e3b4720$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $c78824c77e3b4720$export$10dc3edfc20c8ff = $c78824c77e3b4720$var$createEventEmitter();
module.exports["eventEmitter"] = $c78824c77e3b4720$export$10dc3edfc20c8ff;

});

parcelRegister("ONTtp", function(module, exports) {
/* eslint-disable @typescript-eslint/no-empty-object-type */ function $a5ae639d0f5195ca$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $a5ae639d0f5195ca$export$fa00dd5c1a75592f;

});

parcelRegister("c2Doe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lYpJw = parcelRequire("lYpJw");




var $662WV = parcelRequire("662WV");


var $jqaRm = parcelRequire("jqaRm");


var $e6HAR = parcelRequire("e6HAR");


var $k0XkQ = parcelRequire("k0XkQ");


var $eahqf = parcelRequire("eahqf");

parcelRequire("kil0h");

/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $970cf072d100125d$var$isCrushed() {}



var $8OcYi = parcelRequire("8OcYi");


var $fxYwc = parcelRequire("fxYwc");

var $ixC10 = parcelRequire("ixC10");

var $de3yk = parcelRequire("de3yk");


var $iDrrr = parcelRequire("iDrrr");


var $4yccB = parcelRequire("4yccB");


var $d32fb = parcelRequire("d32fb");




var $ggGdk = parcelRequire("ggGdk");

const $82bcae37cc9ffcd7$var$isCardAction = (action)=>{
    return [
        (0, $fxYwc.ACTION_PENDING),
        (0, $fxYwc.ACTION_RESOLVING),
        (0, $fxYwc.ACTION_RESOLVED),
        (0, $fxYwc.ACTION_RELOADING),
        (0, $fxYwc.ACTION_ERROR),
        (0, $fxYwc.ACTION_ERROR_FALLBACK),
        (0, $fxYwc.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $82bcae37cc9ffcd7$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $ggGdk.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $82bcae37cc9ffcd7$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $fxYwc.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $fxYwc.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $fxYwc.ACTION_RESOLVED:
            return $82bcae37cc9ffcd7$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $fxYwc.ACTION_RELOADING:
            return $82bcae37cc9ffcd7$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $fxYwc.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $fxYwc.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $fxYwc.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $82bcae37cc9ffcd7$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$82bcae37cc9ffcd7$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $82bcae37cc9ffcd7$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};



var $cMyWi = parcelRequire("cMyWi");

/**
 * Whether the error represents a URL the resolver does not support. This is an expected,
 * benign outcome (not a real failure) and must not be surfaced as an errored card.
 */ const $150ce1d88c7b4f41$var$isUnsupportedError = (error)=>error.type === 'UnsupportedError' || error.type === 'ResolveUnsupportedError' || error.type === 'SearchUnsupportedError';
const $150ce1d88c7b4f41$export$497ecb0280204df4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartCardProvider(t0) {
    const $ = (0, $bDgLe.c)(47);
    const { storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = t0;
    const parentContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const defaultInitialState = t1;
    let t2;
    if ($[1] !== storeOptions) {
        t2 = storeOptions || {
            initialState: defaultInitialState
        };
        $[1] = storeOptions;
        $[2] = t2;
    } else t2 = $[2];
    const { initialState: initialState } = t2;
    let t3;
    if ($[3] !== initialState) {
        t3 = (0, $662WV.default)((0, $82bcae37cc9ffcd7$export$3c7c3113a97b6492), initialState);
        $[3] = initialState;
        $[4] = t3;
    } else t3 = $[4];
    const store = t3;
    let t4;
    if ($[5] !== customClient) {
        t4 = customClient || new (0, $4yccB.default)();
        $[5] = customClient;
        $[6] = t4;
    } else t4 = $[6];
    const c = t4;
    if (product && c.setProduct) c.setProduct(product);
    const client = c;
    let t5;
    let t6;
    if ($[7] !== client || $[8] !== store) {
        t5 = ()=>{
            if (typeof window === "undefined" || !(0, $iDrrr.fg)("navx-smartcard-auth-event-listener-killswitch-fg")) return;
            const handler = (event)=>{
                const detail = event.detail;
                if (!detail?.extensionKeys?.length) return;
                const targetKeys = new Set(detail.extensionKeys);
                const state = store.getState();
                for (const url of Object.keys(state)){
                    const cardState = state[url];
                    if (!cardState || cardState.status !== "unauthorized") continue;
                    const cardExtensionKey = cardState.details?.meta?.key;
                    if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                    client.fetchData(url, true).then((response)=>{
                        store.dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RELOADING), {
                            url: url
                        }, response, undefined, undefined, true));
                    }, (err)=>{
                        if (err instanceof (0, $ixC10.APIError) && $150ce1d88c7b4f41$var$isUnsupportedError(err) && (0, $iDrrr.fg)("platform_lp_navx_5358_dont_throw_error")) return;
                        store.dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_ERROR), {
                            url: url
                        }, undefined, err, undefined, true));
                    });
                }
            };
            window.addEventListener((0, $d32fb.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
            return ()=>{
                window.removeEventListener((0, $d32fb.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
            };
        };
        t6 = [
            store,
            client
        ];
        $[7] = client;
        $[8] = store;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const authFlow = customAuthFlow || "oauth2";
    let t7;
    if ($[11] !== store) {
        t7 = (url_0, _platform)=>{
            const cardState_0 = (0, $de3yk.getUrl)(store, url_0);
            return cardState_0.details ? (0, $8OcYi.extractSmartLinkEmbed)(cardState_0.details) : undefined;
        };
        $[11] = store;
        $[12] = t7;
    } else t7 = $[12];
    const getPreview = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {};
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== client) {
        t9 = {
            client: client
        };
        $[14] = client;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== authFlow) {
        t10 = {
            authFlow: authFlow
        };
        $[16] = authFlow;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== getPreview) {
        t11 = {
            getPreview: getPreview
        };
        $[18] = getPreview;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== isPreviewRestricted) {
        t12 = (0, $iDrrr.fg)("preview_panel_unit_check") ? {
            isPreviewRestricted: isPreviewRestricted
        } : undefined;
        $[20] = isPreviewRestricted;
        $[21] = t12;
    } else t12 = $[21];
    let t13;
    if ($[22] !== bridgeProduct || $[23] !== isAdminHubAIEnabled || $[24] !== isPreviewPanelAvailable || $[25] !== openPreviewPanel || $[26] !== product || $[27] !== renderers || $[28] !== rovoOptions || $[29] !== shouldControlDataExport || $[30] !== store || $[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t9 || $[35] !== xpcProduct || $[36] !== xpcSubProduct) {
        t13 = {
            renderers: renderers,
            store: store,
            prefetchStore: t8,
            connections: t9,
            config: t10,
            extractors: t11,
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...t12,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
        $[22] = bridgeProduct;
        $[23] = isAdminHubAIEnabled;
        $[24] = isPreviewPanelAvailable;
        $[25] = openPreviewPanel;
        $[26] = product;
        $[27] = renderers;
        $[28] = rovoOptions;
        $[29] = shouldControlDataExport;
        $[30] = store;
        $[31] = t10;
        $[32] = t11;
        $[33] = t12;
        $[34] = t9;
        $[35] = xpcProduct;
        $[36] = xpcSubProduct;
        $[37] = t13;
    } else t13 = $[37];
    const providerValue = t13;
    let t14;
    if ($[38] !== isPreviewPanelAvailable || $[39] !== isPreviewRestricted || $[40] !== openPreviewPanel || $[41] !== parentContext || $[42] !== providerValue) {
        t14 = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)("preview_panel_unit_check") ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel
        });
        $[38] = isPreviewPanelAvailable;
        $[39] = isPreviewRestricted;
        $[40] = openPreviewPanel;
        $[41] = parentContext;
        $[42] = providerValue;
        $[43] = t14;
    } else t14 = $[43];
    const value = t14;
    let t15;
    if ($[44] !== children || $[45] !== value) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
            value: value
        }, children);
        $[44] = children;
        $[45] = value;
        $[46] = t15;
    } else t15 = $[46];
    return t15;
} : function SmartCardProvider({ storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct }) {
    const parentContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    const defaultInitialState = (0, $cozmU.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $cozmU.useMemo)(()=>{
        return (0, $662WV.default)((0, $82bcae37cc9ffcd7$export$3c7c3113a97b6492), initialState);
    }, [
        initialState
    ]);
    const client = (0, $cozmU.useMemo)(()=>{
        const c = customClient || new (0, $4yccB.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store.
    // Used as guardrail killswitch for synchronized-post-office-and-smartcard-auth-exp in Post Office
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined' || !(0, $iDrrr.fg)('navx-smartcard-auth-event-listener-killswitch-fg')) return;
        const handler = (event)=>{
            const detail = event.detail;
            if (!detail?.extensionKeys?.length) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = cardState.details?.meta?.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    // "Unsupported URL" is a benign, expected resolver outcome (ORS does not
                    // support this link), surfaced as a fatal APIError. Turning it into an
                    // errored card state causes non-flexible SmartLinks to re-throw it to their
                    // error boundary and report it to Sentry. Leave the card in its prior
                    // unauthorized state instead.
                    if (err instanceof (0, $ixC10.APIError) && $150ce1d88c7b4f41$var$isUnsupportedError(err) && (0, $iDrrr.fg)('platform_lp_navx_5358_dont_throw_error')) return;
                    store.dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener((0, $d32fb.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        return ()=>{
            window.removeEventListener((0, $d32fb.SMART_CARD_EXTERNAL_AUTH_EVENT), handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url_0, _platform)=>{
            const cardState_0 = (0, $de3yk.getUrl)(store, url_0);
            return cardState_0.details ? (0, $8OcYi.extractSmartLinkEmbed)(cardState_0.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
    }, [
        customAuthFlow,
        bridgeProduct,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store,
        xpcProduct,
        xpcSubProduct
    ]);
    const value = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cMyWi.SmartCardContext).Provider, {
        value: value
    }, children);
};
module.exports["SmartCardProvider"] = $150ce1d88c7b4f41$export$497ecb0280204df4;

});

parcelRegister("024FG", function(module, exports) {

var $eiLvb = parcelRequire("eiLvb");




/** Used for built-in method references. */ var $f0e1d9969818fb62$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0e1d9969818fb62$var$hasOwnProperty = $f0e1d9969818fb62$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f0e1d9969818fb62$var$nativeObjectToString = $f0e1d9969818fb62$var$objectProto.toString;
/** Built-in value references. */ var $f0e1d9969818fb62$var$symToStringTag = (0, $eiLvb.default) ? (0, $eiLvb.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f0e1d9969818fb62$var$getRawTag(value) {
    var isOwn = $f0e1d9969818fb62$var$hasOwnProperty.call(value, $f0e1d9969818fb62$var$symToStringTag), tag = value[$f0e1d9969818fb62$var$symToStringTag];
    try {
        value[$f0e1d9969818fb62$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f0e1d9969818fb62$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f0e1d9969818fb62$var$symToStringTag] = tag;
        else delete value[$f0e1d9969818fb62$var$symToStringTag];
    }
    return result;
}
var $f0e1d9969818fb62$export$2e2bcd8739ae039 = $f0e1d9969818fb62$var$getRawTag;


/** Used for built-in method references. */ var $46f24d3fa93bcb12$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $46f24d3fa93bcb12$var$nativeObjectToString = $46f24d3fa93bcb12$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $46f24d3fa93bcb12$var$objectToString(value) {
    return $46f24d3fa93bcb12$var$nativeObjectToString.call(value);
}
var $46f24d3fa93bcb12$export$2e2bcd8739ae039 = $46f24d3fa93bcb12$var$objectToString;


/** `Object#toString` result references. */ var $0063cfa0602336d5$var$nullTag = '[object Null]', $0063cfa0602336d5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $0063cfa0602336d5$var$symToStringTag = (0, $eiLvb.default) ? (0, $eiLvb.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $0063cfa0602336d5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $0063cfa0602336d5$var$undefinedTag : $0063cfa0602336d5$var$nullTag;
    return $0063cfa0602336d5$var$symToStringTag && $0063cfa0602336d5$var$symToStringTag in Object(value) ? (0, $f0e1d9969818fb62$export$2e2bcd8739ae039)(value) : (0, $46f24d3fa93bcb12$export$2e2bcd8739ae039)(value);
}
var $0063cfa0602336d5$export$2e2bcd8739ae039 = $0063cfa0602336d5$var$baseGetTag;
module.exports["default"] = $0063cfa0602336d5$export$2e2bcd8739ae039;

});

parcelRegister("eiLvb", function(module, exports) {

var $8pA2A = parcelRequire("8pA2A");

/** Built-in value references. */ var $a697980c91dec472$var$Symbol = (0, $8pA2A.default).Symbol;
var $a697980c91dec472$export$2e2bcd8739ae039 = $a697980c91dec472$var$Symbol;
module.exports["default"] = $a697980c91dec472$export$2e2bcd8739ae039;

});

parcelRegister("8pA2A", function(module, exports) {

var $dgWnT = parcelRequire("dgWnT");

/** Detect free variable `self`. */ var $61fc9d7b807e9577$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $61fc9d7b807e9577$var$root = (0, $dgWnT.default) || $61fc9d7b807e9577$var$freeSelf || Function('return this')();
var $61fc9d7b807e9577$export$2e2bcd8739ae039 = $61fc9d7b807e9577$var$root;
module.exports["default"] = $61fc9d7b807e9577$export$2e2bcd8739ae039;

});

parcelRegister("dgWnT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $9a9a0ee2302cb7b2$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $9a9a0ee2302cb7b2$export$2e2bcd8739ae039 = $9a9a0ee2302cb7b2$var$freeGlobal;
module.exports["default"] = $9a9a0ee2302cb7b2$export$2e2bcd8739ae039;

});

parcelRegister("iSseG", function(module, exports) {

var $aG5N3 = parcelRequire("aG5N3");

/** Built-in value references. */ var $dbe32c30f406e209$var$getPrototype = (0, $aG5N3.default)(Object.getPrototypeOf, Object);
var $dbe32c30f406e209$export$2e2bcd8739ae039 = $dbe32c30f406e209$var$getPrototype;
module.exports["default"] = $dbe32c30f406e209$export$2e2bcd8739ae039;

});

parcelRegister("aG5N3", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $7c62517412553aec$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $7c62517412553aec$export$2e2bcd8739ae039 = $7c62517412553aec$var$overArg;
module.exports["default"] = $7c62517412553aec$export$2e2bcd8739ae039;

});

parcelRegister("4nXqj", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $331767a2a864ec7e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $331767a2a864ec7e$export$2e2bcd8739ae039 = $331767a2a864ec7e$var$isObjectLike;
module.exports["default"] = $331767a2a864ec7e$export$2e2bcd8739ae039;

});

parcelRegister("fxYwc", function(module, exports) {
// TODO: eventually move this file to @atlaskit/link-actions
const $23521d18fdefc99d$export$6e470aad5ba8952e = 'pending';
const $23521d18fdefc99d$export$9a6a932a0a39498e = 'resolving';
const $23521d18fdefc99d$export$63ec8bc7a8a75482 = 'resolved';
const $23521d18fdefc99d$export$b8cfaa842c9ab487 = 'reloading';
const $23521d18fdefc99d$export$6d8ed3f9433dd372 = 'errored';
const $23521d18fdefc99d$export$cfbbb7126bc8a0c6 = 'fallback';
const $23521d18fdefc99d$export$76b5c1aca20759c6 = 'preload';
const $23521d18fdefc99d$export$2c5edb971b673330 = 'metadata';
const $23521d18fdefc99d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });
module.exports["ACTION_PENDING"] = $23521d18fdefc99d$export$6e470aad5ba8952e;
module.exports["ACTION_RESOLVING"] = $23521d18fdefc99d$export$9a6a932a0a39498e;
module.exports["ACTION_RESOLVED"] = $23521d18fdefc99d$export$63ec8bc7a8a75482;
module.exports["ACTION_RELOADING"] = $23521d18fdefc99d$export$b8cfaa842c9ab487;
module.exports["ACTION_ERROR"] = $23521d18fdefc99d$export$6d8ed3f9433dd372;
module.exports["ACTION_ERROR_FALLBACK"] = $23521d18fdefc99d$export$cfbbb7126bc8a0c6;
module.exports["ACTION_UPDATE_METADATA_STATUS"] = $23521d18fdefc99d$export$2c5edb971b673330;
module.exports["cardAction"] = $23521d18fdefc99d$export$a884a52152489cc3;

});

parcelRegister("de3yk", function(module, exports) {
const $aef0eb130344f15c$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $aef0eb130344f15c$export$94df0e59ebebf4a7;

});

parcelRegister("d32fb", function(module, exports) {
/**
 * This event is intended to be dispatched by code OUTSIDE the SmartCardProvider's React tree
 * (e.g. Post Office flags) when an external auth flow has completed and any matching unauthorized SmartLinks on the page should be refreshed.
 *
 * @example for usage from external source:
 *   window.dispatchEvent(new CustomEvent('atlaskit-smart-card:external-auth-completed', {
 *     detail: { extensionKeys: ['figma-object-provider'] },
 *   }));
 */ const $ffd660d90dbf2d8a$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';
module.exports["SMART_CARD_EXTERNAL_AUTH_EVENT"] = $ffd660d90dbf2d8a$export$97eec7ea3e925862;

});

parcelRegister("cMyWi", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");



var $bI14T = parcelRequire("bI14T");


var $9f1Yt = parcelRequire("9f1Yt");



const $6a3d54523157bf6c$export$156b523e63b4f63a = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
var $6a3d54523157bf6c$export$2e2bcd8739ae039 = $6a3d54523157bf6c$export$156b523e63b4f63a;
module.exports["SmartCardContext"] = $6a3d54523157bf6c$export$156b523e63b4f63a;

});

parcelRegister("bI14T", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $e9f93c1a61273356$export$e1d190b530cf0ee9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSmartLinkContext() {
    const context = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    if (!context) throw Error("useSmartCard() must be wrapped in <SmartCardProvider>");
    return context;
} : function useSmartLinkContext() {
    const context = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
};
module.exports["useSmartLinkContext"] = $e9f93c1a61273356$export$e1d190b530cf0ee9;

});

parcelRegister("9f1Yt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $ec1ab019c54e6386$var$useContextMemoized = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useContextMemoized(reactContext) {
    const $ = (0, $bDgLe.c)(4);
    const value = (0, $cozmU.useContext)(reactContext);
    let t0;
    if ($[0] !== reactContext.Consumer || $[1] !== reactContext.Provider || $[2] !== value) {
        t0 = {
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        };
        $[0] = reactContext.Consumer;
        $[1] = reactContext.Provider;
        $[2] = value;
        $[3] = t0;
    } else t0 = $[3];
    const context = t0;
    return context;
} : function useContextMemoized(reactContext) {
    const value = (0, $cozmU.useContext)(reactContext);
    const context = (0, $cozmU.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
};
const $ec1ab019c54e6386$export$10e9cca30e50f657 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
} : ()=>$ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
module.exports["useSmartCardContext"] = $ec1ab019c54e6386$export$10e9cca30e50f657;

});

parcelRegister("6GOAK", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

const $823fcbf6ec1c8340$export$85183a312807388d = 'media';
const $823fcbf6ec1c8340$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $823fcbf6ec1c8340$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $823fcbf6ec1c8340$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
module.exports["ANALYTICS_CHANNEL"] = $823fcbf6ec1c8340$export$85183a312807388d;
module.exports["context"] = $823fcbf6ec1c8340$export$a078c61943f9dbbe;
module.exports["TrackQuickActionType"] = $823fcbf6ec1c8340$export$72af824fa910c33e;
module.exports["TrackQuickActionFailureReason"] = $823fcbf6ec1c8340$export$c89e475f7f7174c2;

});

parcelRegister("6Vsq4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::ac0d75fa9e8d43c947e88f47ba1267aa>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $38ff462c03d81a86$export$3f072f06b90c3985 = 'media';


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::268e746266cde1271e40a794eb774cf3>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $c9475154678146c9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $c9475154678146c9$export$2e2bcd8739ae039 = $c9475154678146c9$var$createEventPayload;


const $83b6e26768687bd5$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $c9475154678146c9$export$2e2bcd8739ae039)(...params));
        event.fire((0, $38ff462c03d81a86$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $83b6e26768687bd5$export$5bf35293e545f20c;

});

parcelRegister("12fG9", function(module, exports) {

var $jdqmT = parcelRequire("jdqmT");

const $32a96acca9fb2950$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = (0, $jdqmT.ufoExperiences)[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
module.exports["failUfoExperience"] = $32a96acca9fb2950$export$8dda83bafca11b77;

});

parcelRegister("kSkO7", function(module, exports) {

var $jdqmT = parcelRequire("jdqmT");

const $fa84a829dfce3a4d$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = (0, $jdqmT.ufoExperiences)[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
module.exports["startUfoExperience"] = $fa84a829dfce3a4d$export$5e9287b6a10f8075;

});

parcelRegister("3KHpl", function(module, exports) {

var $k92Y1 = parcelRequire("k92Y1");


var $6GOAK = parcelRequire("6GOAK");

const $54cd1b0f0ba88c33$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $k92Y1.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $54cd1b0f0ba88c33$export$5732565218b28467 = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $54cd1b0f0ba88c33$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $6GOAK.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
module.exports["getSmartLinkAnalyticsContext"] = $54cd1b0f0ba88c33$export$5732565218b28467;

});

parcelRegister("k92Y1", function(module, exports) {

var $ggGdk = parcelRequire("ggGdk");

const $513def52db66386f$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};



var $iDrrr = parcelRequire("iDrrr");

const $d94c3fbf24fae120$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $ggGdk.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $513def52db66386f$export$28ddbae335bd80b5)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $iDrrr.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};
module.exports["getResolvedAttributes"] = $d94c3fbf24fae120$export$7243431f5325a7b;

});

parcelRegister("6gRyu", function(module, exports) {
const $a8fcf17f5d6e24f1$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};


const $22c63f344e5d34cc$export$8dfeb9778591bc94 = (0, $a8fcf17f5d6e24f1$export$b5717a625dd4a3eb)();
module.exports["hasPerformanceAPIAvailable"] = $22c63f344e5d34cc$export$8dfeb9778591bc94;

});

parcelRegister("4yYAm", function(module, exports) {
const $cf934164e34abcf8$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $cf934164e34abcf8$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $cf934164e34abcf8$export$c36142a78ab570c5 = 'https://www.atlassian.com/trust/ai';
const $cf934164e34abcf8$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $cf934164e34abcf8$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $cf934164e34abcf8$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $cf934164e34abcf8$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $cf934164e34abcf8$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $cf934164e34abcf8$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $cf934164e34abcf8$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $cf934164e34abcf8$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $cf934164e34abcf8$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $cf934164e34abcf8$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $cf934164e34abcf8$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $cf934164e34abcf8$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    ActionName["RovoChatAction"] = "RovoChatAction";
    return ActionName;
}({});
var $cf934164e34abcf8$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $cf934164e34abcf8$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $cf934164e34abcf8$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $cf934164e34abcf8$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $cf934164e34abcf8$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
var $cf934164e34abcf8$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});
module.exports["CONTENT_URL_SECURITY_AND_PERMISSIONS"] = $cf934164e34abcf8$export$5c881701926acbef;
module.exports["CONTENT_URL_3P_ACCOUNT_AUTH"] = $cf934164e34abcf8$export$93d67ab022d9f8d2;
module.exports["CONTENT_URL_ROVO"] = $cf934164e34abcf8$export$c36142a78ab570c5;
module.exports["CONTENT_URL_AI_TROUBLESHOOTING"] = $cf934164e34abcf8$export$a3ed5c4e9d9599b7;
module.exports["CONTENT_URL_ACCEPTABLE_USE_POLICY"] = $cf934164e34abcf8$export$73b198e73554a323;
module.exports["SmartLinkAlignment"] = $cf934164e34abcf8$export$8910bf86027fe6be;
module.exports["SmartLinkDirection"] = $cf934164e34abcf8$export$60831686b0574c86;
module.exports["SmartLinkPosition"] = $cf934164e34abcf8$export$d58e6377644d1dcf;
module.exports["SmartLinkSize"] = $cf934164e34abcf8$export$51f13ced115cbdae;
module.exports["SmartLinkStatus"] = $cf934164e34abcf8$export$61cff06be26816f;
module.exports["SmartLinkTheme"] = $cf934164e34abcf8$export$aed0f1e801ad691f;
module.exports["SmartLinkInternalTheme"] = $cf934164e34abcf8$export$9aafec380d7005da;
module.exports["SmartLinkWidth"] = $cf934164e34abcf8$export$19c60054ee783de6;
module.exports["ElementName"] = $cf934164e34abcf8$export$d65b168331104a46;
module.exports["ActionName"] = $cf934164e34abcf8$export$9c95d6e1614bad84;
module.exports["InternalActionName"] = $cf934164e34abcf8$export$4871a84b35cf8eb9;
module.exports["IconType"] = $cf934164e34abcf8$export$13ff1290a9e22e77;
module.exports["MediaType"] = $cf934164e34abcf8$export$483c11740a902fcd;
module.exports["MediaPlacement"] = $cf934164e34abcf8$export$f9f4737e25ab90fa;
module.exports["CardAction"] = $cf934164e34abcf8$export$f40b7e0b762b928b;
module.exports["CardDisplay"] = $cf934164e34abcf8$export$6ca4ef8b3dc2c804;

});

parcelRegister("eTTRx", function(module, exports) {

var $3tPPd = parcelRequire("3tPPd");

const $6a2de616b33681ee$var$isNotLeftClick = (event)=>event.button !== 0;
const $6a2de616b33681ee$export$df67f318ded0283c = (onMouseDown)=>{
    return (0, $3tPPd.useLinkClicked)(onMouseDown, $6a2de616b33681ee$var$isNotLeftClick);
};
module.exports["useMouseDownEvent"] = $6a2de616b33681ee$export$df67f318ded0283c;

});

parcelRegister("3tPPd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $pRou6 = parcelRequire("pRou6");

var $a8802b95269182ba$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $a8802b95269182ba$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $pRou6.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
module.exports["useLinkClicked"] = $a8802b95269182ba$export$5993d3ca6c85f774;

});

parcelRegister("pRou6", function(module, exports) {
parcelRequire("cozmU");


var $6GOAK = parcelRequire("6GOAK");

parcelRequire("cozmU");

const $c3723fc6f236213f$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);


parcelRequire("cozmU");

const $2570d5c40fd6aafe$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};


parcelRequire("cozmU");


var $a3Cph = parcelRequire("a3Cph");

const $4cc95ea97b5aea92$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $4cc95ea97b5aea92$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $a3Cph.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($4cc95ea97b5aea92$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}


const $0e61853502f2bbf4$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $0e61853502f2bbf4$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : (0, $c3723fc6f236213f$export$cfb45d54e1604f6c).get(event.button);
    if (!clickType) return;
    const clickOutcome = (0, $4cc95ea97b5aea92$export$d2a83e3b34be812b)(event, clickType);
    const keysHeld = (0, $2570d5c40fd6aafe$export$74743eda5dda3ccf)(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $0e61853502f2bbf4$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};


const $51c39d1a9334ddec$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = (0, $0e61853502f2bbf4$export$7fedc699766c16de)(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
    };
module.exports["fireLinkClickedEvent"] = $51c39d1a9334ddec$export$7987de3055fbdcb0;

});

parcelRegister("a3Cph", function(module, exports) {
const $1db585e295c4ba26$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $1db585e295c4ba26$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $1db585e295c4ba26$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $1db585e295c4ba26$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $1db585e295c4ba26$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $1db585e295c4ba26$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $1db585e295c4ba26$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $1db585e295c4ba26$var$result.android = /Android \d/.test(navigator.userAgent);
    $1db585e295c4ba26$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $1db585e295c4ba26$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $1db585e295c4ba26$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $1db585e295c4ba26$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $1db585e295c4ba26$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $1db585e295c4ba26$export$3f2684e5d7cb1006() {
    return $1db585e295c4ba26$var$result;
}
module.exports["browser"] = $1db585e295c4ba26$export$3f2684e5d7cb1006;

});

parcelRegister("dM7c5", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $262f8068420e66d2$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    actions: {
        id: "fabric.linking.actions",
        defaultMessage: "Actions"
    },
    add_account: {
        id: "fabric.linking.add_account",
        defaultMessage: "Add account"
    },
    ai_summarize: {
        id: "fabric.linking.ai_summarize",
        defaultMessage: "Summarize"
    },
    ai_summarized_abbreviation: {
        id: "fabric.linking.ai_summarized_abbreviation",
        defaultMessage: "Summarized by AI"
    },
    ai_summarized_info: {
        id: "fabric.linking.ai_summarized_info",
        defaultMessage: "Information quality may vary. <a>Learn more</a>"
    },
    ai_summarized_info_short: {
        id: "fabric.linking.ai_summarized_info_short",
        defaultMessage: "Content quality may vary"
    },
    ai_summary_error_generic_rebrand: {
        id: "fabric.linking.ai_summary_error_generic_rebrand",
        defaultMessage: "Rovo isn\u2019t responding. Try again later or <a>check the status of AI</a>."
    },
    ai_summary_error_acceptable_use_violation: {
        id: "fabric.linking.ai_summary_error_acceptable_use_violation",
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>."
    },
    ai_summary_error_hipaa_content_detected: {
        id: "fabric.linking.ai_summary_error_hipaa_content_detected",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content."
    },
    ai_summary_error_exceeding_context_length_error: {
        id: "fabric.linking.ai_summary_error_exceeding_context_length_error",
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize."
    },
    assigned_to: {
        id: "fabric.linking.assigned_to",
        defaultMessage: "Assigned to {context}"
    },
    change_status: {
        id: "fabric.linking.change_status",
        defaultMessage: "Change status: {status}"
    },
    automation_action_title: {
        id: "fabric.linking.automation-action.title",
        defaultMessage: "View automation rules"
    },
    automation_action_icon_label: {
        id: "fabric.linking.automation-action.icon.label",
        defaultMessage: "Automation icon"
    },
    automation_action_tooltip: {
        id: "fabric.linking.automation-action.tooltip",
        defaultMessage: "Select an automation rule to run"
    },
    automation_action_confluence_page_modal_title: {
        id: "fabric.linking.automation-action.confluence.page.modal.title",
        defaultMessage: "Page automations"
    },
    automation_action_confluence_page_modal_description: {
        id: "fabric.linking.automation-action.confluence.page.modal.description",
        defaultMessage: "Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators."
    },
    cancel: {
        id: "fabric.linking.cancel",
        defaultMessage: "Cancel"
    },
    beta: {
        id: "fabric.linking.beta",
        defaultMessage: "Beta"
    },
    cannot_connect: {
        id: "fabric.linking.cannot_connect",
        defaultMessage: "Can't connect, try again"
    },
    cannot_find_link: {
        id: "fabric.linking.cannot_find_link",
        defaultMessage: "Can't find link"
    },
    click_to_join: {
        id: "fabric.linking.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.linking.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    close: {
        id: "fabric.linking.close",
        defaultMessage: "Close"
    },
    check_this_link: {
        id: "fabric.linking.check_this_link",
        defaultMessage: "Check this link"
    },
    compass_applied_components_count: {
        id: "compass.applied_components_count.non-final",
        defaultMessage: "Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}"
    },
    connect_to: {
        id: "fabric.linking.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.linking.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.linking.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.linking.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.linking.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_preview: {
        id: "fabric.linking.connect_link_account_preview-nonfinal",
        defaultMessage: "Preview"
    },
    connect_link_account_card_description: {
        id: "fabric.linking.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    connect_link_account_embed_carousel_dot_label: {
        id: "fabric.linking.connect_link_account_embed_carousel_dot_label.non-final",
        defaultMessage: "Go to slide {index} of {total}"
    },
    connect_link_account_embed_carousel_dot_row_label: {
        id: "fabric.linking.connect_link_account_embed_carousel_dot_row_label.non-final",
        defaultMessage: "Slides"
    },
    connect_link_account_embed_carousel_button_next: {
        id: "fabric.linking.connect_link_account_embed_carousel_button_next.non-final",
        defaultMessage: "Next"
    },
    connect_link_account_embed_carousel_sl_description: {
        id: "fabric.linking.connect_link_account_embed_carousel_sl_description.non-final",
        defaultMessage: "Embed live previews of {context, select,\n\t\t\t\tGoogle {Google Docs, Sheets, and Slides}\n\t\t\t\tother {{context}}} {product, select,\n\t\t\t\tBITBUCKET {right inside Bitbucket}\n\t\t\t\tCONFLUENCE {right inside Confluence and Jira}\n\t\t\t\tJIRA {right inside Confluence and Jira}\n\t\t\t\tTRELLO {right inside Trello}\n\t\t\t\tother {across Atlassian}}."
    },
    connect_link_account_embed_carousel_sl_title: {
        id: "fabric.linking.connect_link_account_embed_carousel_sl_title.non-final",
        defaultMessage: "Turn smart links into rich previews"
    },
    connect_link_account_embed_carousel_rovo_title: {
        id: "fabric.linking.connect_link_account_embed_carousel_rovo_title.non-final",
        defaultMessage: "Find everything in one search"
    },
    connect_link_account_embed_carousel_rovo_description: {
        id: "fabric.linking.connect_link_account_embed_carousel_rovo_description.non-final",
        defaultMessage: "Access {context} files alongside your work in {product, select,\n\t\t\t\tBITBUCKET {Bitbucket}\n\t\t\t\tCONFLUENCE {Confluence and Jira}\n\t\t\t\tJIRA {Confluence and Jira}\n\t\t\t\tTRELLO {Trello}\n\t\t\t\tother {Atlassian}}. We'll always respect your {context} permissions."
    },
    connect_link_account_embed_carousel_rovochat_title: {
        id: "fabric.linking.connect_link_account_embed_carousel_rovochat_title.non-final",
        defaultMessage: "Get help from Rovo"
    },
    connect_link_account_embed_carousel_rovochat_description: {
        id: "fabric.linking.connect_link_account_embed_carousel_rovochat_description.non-final",
        defaultMessage: "Rovo uses your {context} content to answer questions, summarise docs, and draft updates using the work you\u2019ve already done."
    },
    connect_link_account_success_flag_description: {
        id: "fabric.linking.connect_link_account_success_flag_description",
        defaultMessage: "Shared links now display rich previews."
    },
    connect_link_account_success_flag_title: {
        id: "fabric.linking.connect_link_account_success_flag_title",
        defaultMessage: "{context} is connected"
    },
    connect_link_account_success_flag_title_default: {
        id: "fabric.linking.connect_link_account_success_flag_title_default",
        defaultMessage: "Smart Link"
    },
    connect_unauthorised_account_action: {
        id: "fabric.linking.connect_unauthorised_account_action",
        defaultMessage: "Connect to {context}"
    },
    connect_3p_account: {
        id: "fabric.linking.connect_3p_account.non-final",
        defaultMessage: "Connect {context}"
    },
    connect_inline_social_proof: {
        id: "fabric.linking.connect_inline_social_proof",
        defaultMessage: "Connect"
    },
    social_proof_inline_cta_tag_high_with_context: {
        id: "fabric.linking.social_proof_inline_cta_tag_high_with_context",
        defaultMessage: "<b>{connectedPct}%</b> of your team sees {context} previews"
    },
    social_proof_inline_cta_tag_high_no_context: {
        id: "fabric.linking.social_proof_inline_cta_tag_high_no_context",
        defaultMessage: "<b>{connectedPct}%</b> of your team sees richer previews"
    },
    social_proof_inline_cta_tag_low_with_context: {
        id: "fabric.linking.social_proof_inline_cta_tag_low_with_context",
        defaultMessage: "Your team sees richer {context} previews"
    },
    social_proof_inline_cta_tag_low_no_context: {
        id: "fabric.linking.social_proof_inline_cta_tag_low_no_context",
        defaultMessage: "Your team sees richer previews"
    },
    connect_unauthorised_account_description: {
        id: "fabric.linking.connect_unauthorised_account_description",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian products."
    },
    connect_unauthorised_account_description_no_provider: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider",
        defaultMessage: "Connect your account to collaborate on work across Atlassian products."
    },
    continue: {
        id: "fabric.linking.continue",
        defaultMessage: "Continue"
    },
    copy_url_to_clipboard: {
        id: "fabric.linking.copy_url_to_clipboard",
        defaultMessage: "Copy link"
    },
    copied_url_to_clipboard: {
        id: "fabric.linking.copied_url_to_clipboard",
        defaultMessage: "Copied!"
    },
    could_not_load_link: {
        id: "fabric.linking.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    created_by: {
        id: "fabric.linking.created_by",
        defaultMessage: "Created by {context}"
    },
    created_on_relative: {
        id: "fabric.linking.create_on_relative",
        defaultMessage: "Created {context}"
    },
    created_on_absolute: {
        id: "fabric.linking.create_on_absolute",
        defaultMessage: "Created on {context}"
    },
    delete: {
        id: "fabric.linking.delete",
        defaultMessage: "Delete"
    },
    download: {
        id: "fabric.linking.download",
        defaultMessage: "Download"
    },
    download_description: {
        id: "fabric.linking.download_description",
        defaultMessage: "Download this file into your local storage"
    },
    download_file: {
        id: "fabric.linking.download_file",
        defaultMessage: "Download file"
    },
    ai_summary_action_rebrand: {
        id: "fabric.linking.ai_summary_action_rebrand",
        defaultMessage: "Summarize with Rovo"
    },
    ai_summary_action_description: {
        id: "fabric.linking.ai_summary_action_description",
        defaultMessage: "Summarize the content of this link using Atlassian Intelligence."
    },
    ai_summary_action_description_rebrand: {
        id: "fabric.linking.ai_summary_action_description_rebrand",
        defaultMessage: "Summarize the content of this link using Rovo."
    },
    copy_summary_action: {
        id: "fabric.linking.copy_summary_action",
        defaultMessage: "Copy summary"
    },
    copy_summary_action_description: {
        id: "fabric.linking.copy_summary_action_description",
        defaultMessage: "Copy summary"
    },
    copied_summary_action_description: {
        id: "fabric.linking.copied_summary_action_description",
        defaultMessage: "Copied summary to clipboard"
    },
    edit: {
        id: "fabric.linking.edit",
        defaultMessage: "Edit"
    },
    follow: {
        id: "fabric.linking.follow",
        defaultMessage: "Follow"
    },
    follow_project_description: {
        id: "fabric.linking.follow_project_description",
        defaultMessage: "Follow to get notifications on this project"
    },
    follow_project: {
        id: "fabric.linking.follow_project",
        defaultMessage: "Follow project"
    },
    follow_project_error: {
        id: "fabric.linking.follow_project_error",
        defaultMessage: "We encountered an error while trying to follow the project. Check your connection or refresh the page and try again."
    },
    follow_goal_description: {
        id: "fabric.linking.follow_goal_description",
        defaultMessage: "Follow this goal to get notifications on updates"
    },
    follow_goal: {
        id: "fabric.linking.follow_goal",
        defaultMessage: "Follow goal"
    },
    follow_goal_error: {
        id: "fabric.linking.follow_goal_error",
        defaultMessage: "We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again."
    },
    go_back: {
        id: "fabric.linking.go_back",
        defaultMessage: "Go back"
    },
    invalid_permissions: {
        id: "fabric.linking.invalid_permissions",
        defaultMessage: "Restricted content"
    },
    invalid_permissions_description: {
        id: "fabric.linking.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    join_to_view: {
        id: "fabric.linking.join_to_view",
        defaultMessage: "Join {context} to view this issue"
    },
    learn_more_about_smart_links: {
        id: "fabric.linking.learn_more_about_smart_links",
        defaultMessage: "Learn more about Smart Links."
    },
    learn_more_about_connecting_account: {
        id: "fabric.linking.learn_more_about_connecting_account",
        defaultMessage: "Learn more about connecting your account to Atlassian products."
    },
    loading: {
        id: "fabric.linking.loading",
        defaultMessage: "Loading..."
    },
    modified_by: {
        id: "fabric.linking.updated_by",
        defaultMessage: "Modified by {context}"
    },
    modified_on_relative: {
        id: "fabric.linking.modified_on_relative",
        defaultMessage: "Updated {context}"
    },
    modified_on_absolute: {
        id: "fabric.linking.modified_on_absolute",
        defaultMessage: "Updated on {context}"
    },
    more_actions: {
        id: "fabric.linking.more_actions",
        defaultMessage: "More actions"
    },
    open_issue_in_jira: {
        id: "fabric.linking.open_issue_in_jira",
        defaultMessage: "Open issue in Jira"
    },
    open_link_in_a_new_tab: {
        id: "fabric.linking.open_link_in_a_new_tab",
        defaultMessage: "Open link in a new tab"
    },
    owned_by: {
        id: "fabric.linking.owned_by",
        defaultMessage: "Owned by {context}"
    },
    owned_by_override: {
        id: "fabric.linking.owned_by_override",
        defaultMessage: "By {context}"
    },
    preview_description: {
        id: "fabric.linking.preview_description",
        defaultMessage: "Open a full screen preview of this link"
    },
    preview_improved: {
        id: "fabric.linking.preview_improved",
        defaultMessage: "Open preview"
    },
    preview_modal: {
        id: "fabric.linking.preview_modal",
        defaultMessage: "Open preview modal"
    },
    preview_panel: {
        id: "fabric.linking.preview_panel",
        defaultMessage: "Open preview panel"
    },
    preview_close: {
        id: "fabric.linking.preview_close",
        defaultMessage: "Close preview"
    },
    preview_max_size: {
        id: "fabric.linking.preview_max_size",
        defaultMessage: "View full screen"
    },
    preview_min_size: {
        id: "fabric.linking.preview_min_size",
        defaultMessage: "Close full screen"
    },
    priority_blocker: {
        id: "fabric.linking.priority_blocker",
        defaultMessage: "Blocker"
    },
    priority_critical: {
        id: "fabric.linking.priority_critical",
        defaultMessage: "Critical"
    },
    priority_high: {
        id: "fabric.linking.priority_high",
        defaultMessage: "High"
    },
    priority_highest: {
        id: "fabric.linking.priority_highest",
        defaultMessage: "Highest"
    },
    priority_low: {
        id: "fabric.linking.priority_low",
        defaultMessage: "Low"
    },
    priority_lowest: {
        id: "fabric.linking.priority_lowest",
        defaultMessage: "Lowest"
    },
    priority_major: {
        id: "fabric.linking.priority_major",
        defaultMessage: "Major"
    },
    priority_medium: {
        id: "fabric.linking.priority_medium",
        defaultMessage: "Medium"
    },
    priority_minor: {
        id: "fabric.linking.priority_minor",
        defaultMessage: "Minor"
    },
    priority_trivial: {
        id: "fabric.linking.priority_trivial",
        defaultMessage: "Trivial"
    },
    priority_undefined: {
        id: "fabric.linking.priority_undefined",
        defaultMessage: "Undefined"
    },
    forbidden_access: {
        id: "fabric.linking.forbidden_access",
        defaultMessage: "Your access is forbidden"
    },
    pending_request: {
        id: "fabric.linking.pending_request",
        defaultMessage: "Your access request is pending"
    },
    read_time: {
        id: "fabric.linking.read_time",
        defaultMessage: "{context} min read"
    },
    restricted_link: {
        id: "fabric.linking.restricted_link",
        defaultMessage: "Restricted link, try another account"
    },
    request_access_to_view: {
        id: "fabric.linking.request_access_to_view",
        defaultMessage: "Request access to {context} to view this issue"
    },
    request_denied: {
        id: "fabric.linking.request_denied",
        defaultMessage: "Your access request was denied"
    },
    retry: {
        id: "fabric.linking.retry",
        defaultMessage: "Retry"
    },
    save: {
        id: "fabric.linking.save",
        defaultMessage: "Save"
    },
    sent_on_relative: {
        id: "fabric.linking.sent_on_relative",
        defaultMessage: "Sent {context}"
    },
    sent_on_absolute: {
        id: "fabric.linking.sent_on_absolute",
        defaultMessage: "Sent on {context}"
    },
    status_change_load_error: {
        id: "fabric.linking.status_change_load_error",
        defaultMessage: "We couldn\u2019t load the statuses and transitions"
    },
    status_change_permission_error: {
        id: "fabric.linking.status_change_permission_error",
        defaultMessage: "You don\u2019t have permission to transition this issue. "
    },
    status_change_update_error: {
        id: "fabric.linking.status_change_update_error",
        defaultMessage: "We couldn\u2019t update the status"
    },
    try_again: {
        id: "fabric.linking.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.linking.try_another_account",
        defaultMessage: "Try another account"
    },
    link_safety_warning_message: {
        id: "fabric.linking.link_safety_warning_message",
        defaultMessage: "The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>"
    },
    unauthorised_account_description: {
        id: "fabric.linking.unauthorised_account_description",
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_description_no_provider: {
        id: "fabric.linking.unauthorised_account_description_no_provider",
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_name: {
        id: "fabric.linking.unauthorised_account_name",
        defaultMessage: "We can't display private pages from {context}"
    },
    unauthorised_account_name_no_provider: {
        id: "fabric.linking.unauthorised_account_name_no_provider",
        defaultMessage: "We can't display private pages"
    },
    rovo_actions_explore: {
        id: "fabric.linking.rovo_actions_explore-non-final",
        defaultMessage: "Explore"
    },
    unassigned: {
        id: "fabric.linking.unassigned",
        defaultMessage: "Unassigned"
    },
    unfollow: {
        id: "fabric.linking.unfollow",
        defaultMessage: "Unfollow"
    },
    unfollow_project_description: {
        id: "fabric.linking.unfollow_project_description",
        defaultMessage: "Unfollow to stop receiving project notifications"
    },
    unfollow_project: {
        id: "fabric.linking.unfollow_project",
        defaultMessage: "Unfollow project"
    },
    unfollow_project_error: {
        id: "fabric.linking.unfollow_project_error",
        defaultMessage: "We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again."
    },
    unfollow_goal_description: {
        id: "fabric.linking.unfollow_goal_description",
        defaultMessage: "Unfollow to stop receiving notifications for this goal"
    },
    unfollow_goal: {
        id: "fabric.linking.unfollow_goal",
        defaultMessage: "Unfollow goal"
    },
    unfollow_goal_error: {
        id: "fabric.linking.unfollow_goal_error",
        defaultMessage: "We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again."
    },
    unlink_account: {
        id: "fabric.linking.unlink_account",
        defaultMessage: "Unlink Account"
    },
    view: {
        id: "fabric.linking.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.linking.srclink",
        defaultMessage: "View in"
    },
    viewInProvider: {
        id: "fabric.linking.viewinprovider",
        defaultMessage: "View in {providerName}"
    },
    viewOriginal: {
        id: "fabric.linking.srclinkunknown",
        defaultMessage: "View Original"
    },
    default_no_access_title: {
        id: "fabric.linking.no_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_title: {
        id: "fabric.linking.direct_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_description: {
        id: "fabric.linking.direct_access_description",
        defaultMessage: "Your team uses {product} to collaborate and you can start using it right away!"
    },
    direct_access: {
        id: "fabric.linking.direct_access",
        defaultMessage: "Join now"
    },
    request_access_description: {
        id: "fabric.linking.request_access_description",
        defaultMessage: "Your team uses {product} to collaborate. Send your admin a request for access."
    },
    request_access: {
        id: "fabric.linking.request_access",
        defaultMessage: "Request access"
    },
    request_access_pending_title: {
        id: "fabric.linking.request_access_pending_title",
        defaultMessage: "Access to {product} is pending"
    },
    request_access_pending_description: {
        id: "fabric.linking.request_access_pending_description",
        defaultMessage: "Your request to access {hostname} is awaiting admin approval."
    },
    request_access_pending: {
        id: "fabric.linking.request_access_pending",
        defaultMessage: "Pending approval"
    },
    request_denied_description: {
        id: "fabric.linking.request_denied_description",
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}."
    },
    access_exists_description: {
        id: "fabric.linking.access_exists_description",
        defaultMessage: "Request access to view this content from {hostname}."
    },
    not_found_description: {
        id: "fabric.linking.not_found_description",
        defaultMessage: "The page doesn't exist or it may have changed after this link was added."
    },
    not_found_title: {
        id: "fabric.linking.not_found_title",
        defaultMessage: "We can't show you this {product} page"
    },
    forbidden_title: {
        id: "fabric.linking.forbidden_title",
        defaultMessage: "You don't have access to this content"
    },
    forbidden_description: {
        id: "fabric.linking.forbidden_description",
        defaultMessage: "Contact your admin to request access to {hostname}."
    },
    related: {
        id: "fabric.linking.related",
        defaultMessage: "Related"
    },
    generic_error_message: {
        id: "fabric.linking.generic_error_message",
        defaultMessage: "An error occurred"
    },
    related_links_modal_title: {
        id: "fabric.linking.related_links_modal_title",
        defaultMessage: "Related links"
    },
    related_links_view_related_urls: {
        id: "fabric.linking.related_links_view_related_urls",
        defaultMessage: "View recent links"
    },
    related_links_view_related_links: {
        id: "fabric.linking.related_links_view_related_links",
        defaultMessage: "View related links"
    },
    related_links_found_in: {
        id: "fabric.linking.related_links_found_in",
        defaultMessage: "Found in"
    },
    related_links_not_found: {
        id: "fabric.linking.related_links_not_found",
        defaultMessage: "We didn't find any links to show here."
    },
    related_links_includes_links_to: {
        id: "fabric.linking.related_links_includes_links_to",
        defaultMessage: "Includes links to"
    },
    related_links_modal_error_title: {
        id: "fabric.linking.related_links_modal_error_title",
        defaultMessage: "We're having trouble loading related links"
    },
    related_links_modal_unavailable_title: {
        id: "fabric.linking.related_links_modal_unavailable_title",
        defaultMessage: "We couldn't find any related links"
    },
    related_links_modal_error_description: {
        id: "fabric.linking.related_links_modal_error_description",
        defaultMessage: "Check your connection or refresh the page to try again"
    },
    related_links_modal_unavailable_description: {
        id: "fabric.linking.related_links_modal_unavailable_description",
        defaultMessage: "We continuously review and add related links for updated pages or other content types"
    },
    join_to_viewIssueTermRefresh: {
        id: "fabric.linking.join_to_view-issue-term-refresh",
        defaultMessage: "Join {context} to view this work item"
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: "fabric.linking.open_issue_in_jira-issue-term-refresh",
        defaultMessage: "Open work item in Jira"
    },
    request_access_to_viewIssueTermRefresh: {
        id: "fabric.linking.request_access_to_view-issue-term-refresh",
        defaultMessage: "Request access to {context} to view this work item"
    },
    status_change_permission_errorIssueTermRefresh: {
        id: "fabric.linking.status_change_permission_error-issue-term-refresh",
        defaultMessage: "You don\u2019t have permission to transition this work item. "
    },
    team_members_count: {
        id: "fabric.linking.team_members_count",
        defaultMessage: "{context} members"
    },
    user_attributes: {
        id: "fabric.linking.user_attributes",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{context}"
    },
    follow_project_descriptionGalaxia: {
        id: "fabric.linking.follow_project_description-galaxia",
        defaultMessage: "Follow to get notifications on this space"
    },
    follow_project_errorGalaxia: {
        id: "fabric.linking.follow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to follow the space. Check your connection or refresh the page and try again."
    },
    unfollow_project_descriptionGalaxia: {
        id: "fabric.linking.unfollow_project_description-galaxia",
        defaultMessage: "Unfollow to stop receiving space notifications"
    },
    unfollow_project_errorGalaxia: {
        id: "fabric.linking.unfollow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again."
    },
    connect_unauthorised_account_description_appify: {
        id: "fabric.linking.connect_unauthorised_account_description-appify",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian apps."
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider-appify",
        defaultMessage: "Connect your account to collaborate on work across Atlassian apps."
    },
    learn_more_about_connecting_account_appify: {
        id: "fabric.linking.learn_more_about_connecting_account-appify",
        defaultMessage: "Learn more about connecting your account to Atlassian apps."
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: "fabric.linking.learn_more_about_connecting_account_experiment_short",
        defaultMessage: "Turn your URLs into rich, interactive previews."
    },
    rovo_summary_loading: {
        id: "fabric.linking.rovo_summary.loading.non-final",
        defaultMessage: "Rovo is thinking"
    },
    ai_disclaimer: {
        id: "fabric.linking.rovo_summary.ai_disclaimer.non-final",
        defaultMessage: "Uses AI. Verify Results."
    },
    rovo_unauthorised_title: {
        id: "fabric.linking.rovo_unauthorised.title",
        defaultMessage: "Get smarter workflows by connecting your {context} account"
    },
    rovo_unauthorised_title_no_provider: {
        id: "fabric.linking.rovo_unauthorised.title_no_provider",
        defaultMessage: "Get smarter workflows by connecting your account"
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: "fabric.linking.rovo_unauthorised.feature.clear_link_names",
        defaultMessage: "Turn long URLs into clear link names"
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: "fabric.linking.rovo_unauthorised.feature.understand_linked_docs",
        defaultMessage: "Understand linked docs in seconds"
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: "fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions",
        defaultMessage: "Go deeper with smart suggestions"
    },
    rovo_unauthorised_connect_account: {
        id: "fabric.linking.rovo_unauthorised.connect_account",
        defaultMessage: "Connect"
    },
    rovo_unauthorised_not_now: {
        id: "fabric.linking.rovo_unauthorised.not_now",
        defaultMessage: "Maybe later"
    },
    rovo_prompt_context_generic: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "page"
    },
    rovo_prompt_context_generic_plural: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "pages"
    },
    rovo_prompt_context_confluence_page: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "Confluence page"
    },
    rovo_prompt_context_jira_work_item: {
        id: "fabric.linking.rovo_prompt_context_jira_work_item.non-final",
        defaultMessage: "Jira work item"
    },
    rovo_prompt_message_summarize: {
        id: "fabric.linking.rovo_prompt_message_summarize.non-final",
        defaultMessage: "<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete bullet points (markdown list).</p><p>Preserve important details such as names, dates, and key decisions.</p>"
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: "fabric.linking.rovo_prompt_button_ask_rovo.non-final",
        defaultMessage: "Ask Rovo"
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: "fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final",
        defaultMessage: "`I have a question about this linked item` {url}"
    },
    rovo_prompt_button_highlight_relevant_content: {
        id: "fabric.linking.rovo_prompt_button_highlight_relevant_content",
        defaultMessage: "Highlight what's relevant"
    },
    rovo_prompt_message_highlight_relevant_content: {
        id: "fabric.linking.rovo_prompt_message_highlight_relevant_content",
        defaultMessage: "<p>Based on this linked item (<a>{url}</a>) and the {context} I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>"
    },
    rovo_prompt_button_identify_key_trends: {
        id: "fabric.linking.rovo_prompt_button_identify_key_trends",
        defaultMessage: "Identify key trends"
    },
    rovo_prompt_message_identify_key_trends: {
        id: "fabric.linking.rovo_prompt_message_identify_key_trends",
        defaultMessage: "<p>From this <a>{url}</a>, identify the key trends, anomalies, and headline numbers. Call out anything increasing/decreasing significantly, noteworthy comparisons, and any risks or opportunities the data suggests.</p>"
    },
    rovo_prompt_button_identify_key_points: {
        id: "fabric.linking.rovo_prompt_button_identify_key_points",
        defaultMessage: "Identify key points"
    },
    rovo_prompt_message_identify_key_points: {
        id: "fabric.linking.rovo_prompt_message_identify_key_points",
        defaultMessage: "<p>From this <a>{url}</a>, identify the key points, proposals, and decisions. Focus on what someone skimming the deck should know in order to understand the main message.</p>"
    },
    rovo_prompt_button_find_open_questions: {
        id: "fabric.linking.rovo_prompt_button_find_open_questions",
        defaultMessage: "Find open questions"
    },
    rovo_prompt_message_find_open_questions: {
        id: "fabric.linking.rovo_prompt_message_find_open_questions",
        defaultMessage: "<p>Look at this <a>{url}</a> and list any open questions, unresolved decisions, or asks that still need follow\u2011up. Group them by owner if possible and keep it concise.</p>"
    },
    rovo_prompt_button_key_highlights: {
        id: "fabric.linking.rovo_prompt_button_key_highlights",
        defaultMessage: "Key highlights"
    },
    rovo_prompt_message_key_highlights: {
        id: "fabric.linking.rovo_prompt_message_key_highlights",
        defaultMessage: "<p>Based on this <a>{url}</a> and the page or ticket I\u2019m currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>"
    },
    rovo_chat_action_section_header: {
        id: "fabric.linking.rovo_chat_action_section_header.non-final",
        defaultMessage: "Ask Rovo"
    },
    rovo_prompt_button_summarize_this: {
        id: "fabric.linking.rovo_prompt_button_summarize_this.non-final",
        defaultMessage: "Summarize this for me"
    },
    rovo_prompt_button_ask_a_specific_question: {
        id: "fabric.linking.rovo_prompt_button_ask_a_specific_question.non-final",
        defaultMessage: "Ask a specific question"
    },
    rovo_prompt_button_show_me_whats_relevant: {
        id: "fabric.linking.rovo_prompt_button_show_me_whats_relevant.non-final",
        defaultMessage: "Show me what's relevant"
    },
    rovo_prompt_message_summarize_document: {
        id: "fabric.linking.rovo_prompt_message_summarize_document",
        defaultMessage: "<p>Summarize this doc <a>{url}</a> into a concise, easy-to-scan overview. Adapt to whatever the content is and focus on the main ideas, important decisions, key updates, and next steps, only include these if they exist; don't mention their absence. Avoid unnecessary detail, repetition, or formatting commentary. Write in plain language and optimize for a quick 5\u201310 second read</p>"
    },
    rovo_prompt_message_summarize_presentation: {
        id: "fabric.linking.rovo_prompt_message_summarize_presentation",
        defaultMessage: "<p>Summarize this Google Slides deck <a>{url}</a> into a concise executive overview. Focus on the tldr, key findings, decisions, metrics, risks, and next steps, if there are any. Use a short executive summary followed by 2-3 bullet points. Avoid slide-by-slide narration, design details, repetition, and filler.</p>"
    },
    rovo_prompt_button_explain_code: {
        id: "fabric.linking.rovo_prompt_button_explain_code",
        defaultMessage: "Explain"
    },
    rovo_prompt_message_explain_code: {
        id: "fabric.linking.rovo_prompt_message_explain_code",
        defaultMessage: "<p>Explain this code, pull request, or commit <a>{url}</a> in clear, plain language for a non-technical audience.</p><p>Cover:</p><ol><li><strong>Purpose</strong> \u2014 What problem does it solve or what goal does it achieve?</li><li><strong>How it works</strong> \u2014 High-level mechanics (no implementation detail unless critical to understanding).</li><li><strong>Why</strong> \u2014 Motivation for the change or design choice.</li><li><strong>Impact</strong> \u2014 Key behavior changes, risks, or downstream effects worth noting.</li></ol><p>Constraints:</p><ul><li>3\u20135 sentences or 100\u2013150 words max.</li><li>Omit sections with nothing meaningful to say.</li><li>Prefer concrete language over abstract descriptions (e.g., \"speeds up page load by caching results\" over \"improves performance\").</li></ul>"
    },
    rovo_prompt_button_catch_up: {
        id: "fabric.linking.rovo_prompt_button_catch_up",
        defaultMessage: "Catch up"
    },
    rovo_prompt_message_catch_up: {
        id: "fabric.linking.rovo_prompt_message_catch_up",
        defaultMessage: "<p>Catch me up on the latest {provider} conversations or channel activity in <a>{url}</a> from the last two weeks. If there's no activity in the past two weeks, expand the window to the most recent 30 days (or until meaningful activity is found). Summarize the most important updates, decisions, and discussions so the user can quickly understand what they missed. Focus on key changes, unresolved questions, and any action items or follow-ups. Prioritize recent messages with the most activity. Keep the response concise \u2014 ideally 80\u2013150 words or a short set of 3\u20135 key bullets.</p>"
    },
    rovo_prompt_button_salesforce_prep: {
        id: "fabric.linking.rovo_prompt_button_salesforce_prep",
        defaultMessage: "Prep"
    },
    rovo_prompt_message_salesforce_prep: {
        id: "fabric.linking.rovo_prompt_message_salesforce_prep",
        defaultMessage: "<p>Prep me for this Salesforce record <a>{url}</a>. What's the current state, what's the recent activity, what risks or opportunities should I be aware of, and what would be useful to know before a conversation about it?</p>"
    },
    // TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    pre_auth_block_social_proof_not_low: {
        id: "fabric.linking.pre_auth_block_social_proof_not_low",
        defaultMessage: "<b>{percentage}%</b> of your team sees <b>{provider}</b> previews."
    },
    pre_auth_block_social_proof_low: {
        id: "fabric.linking.pre_auth_block_social_proof_low",
        defaultMessage: "Your team sees richer <b>{provider}</b> previews."
    }
});
module.exports["messages"] = $262f8068420e66d2$export$defe85febe8b728c;

});

parcelRegister("9UcmI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::47222777a6ba79e023cc331ab4bf9f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7362ef8d49385666$var$_react = $7362ef8d49385666$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7362ef8d49385666$var$_baseNew = $7362ef8d49385666$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7362ef8d49385666$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7362ef8d49385666$var$AiSearchIcon = (props)=>/*#__PURE__*/ $7362ef8d49385666$var$_react.default.createElement($7362ef8d49385666$var$_baseNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$7362ef8d49385666$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $7362ef8d49385666$var$_default = module.exports.default = $7362ef8d49385666$var$AiSearchIcon;

});

parcelRegister("9udAq", function(module, exports) {

var $iO4QI = parcelRequire("iO4QI");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $db459ffdd61a3602$export$db1000b9ac08ce57(node, type) {
    return `Mark with the same name '${type}' already exists on a node: ${JSON.stringify(node)}`;
}


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dd5a7c5625fd53a6$export$5ec47a80d7cc0dfa(node, type) {
    if (node.marks && node.marks.some((mark)=>mark.type === type)) return true;
    return false;
}


function $5ed49a04b6ace6aa$export$50d34f59d07755a2(mark, maybeNode) {
    const node = typeof maybeNode === 'string' ? (0, $iO4QI.text)(maybeNode) : maybeNode;
    if ((0, $dd5a7c5625fd53a6$export$5ec47a80d7cc0dfa)(node, mark.type)) {
        // eslint-disable-next-line no-console
        console.error((0, $db459ffdd61a3602$export$db1000b9ac08ce57)(node, mark.type));
        return node;
    }
    node.marks = node.marks || [];
    node.marks.push(mark);
    return node;
}
module.exports["applyMark"] = $5ed49a04b6ace6aa$export$50d34f59d07755a2;

});

parcelRegister("iO4QI", function(module, exports) {
const $667b0ee657454655$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });
module.exports["text"] = $667b0ee657454655$export$6f093cfa640b7166;

});

parcelRegister("4AavA", function(module, exports) {
const $ecd3326e061f428d$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });
module.exports["doc"] = $ecd3326e061f428d$export$2a111da947c407d2;

});

parcelRegister("gHMgs", function(module, exports) {
const $bbd0c441fac38038$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });
module.exports["listItem"] = $bbd0c441fac38038$export$76c7e83ecc9cdf05;

});

parcelRegister("c8cGy", function(module, exports) {

var $iO4QI = parcelRequire("iO4QI");

function $2e92d69229df508d$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $iO4QI.text)(str) : str;
}


function $d137d6cacfa69045$export$3a269a5941b62f04(nodes) {
    return nodes.map((0, $2e92d69229df508d$export$72b9432ea0656b50));
}


const $1c823cc1d3b8a489$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $d137d6cacfa69045$export$3a269a5941b62f04)(content)
    });
module.exports["paragraph"] = $1c823cc1d3b8a489$export$9c206ddddb32a9b;

});

parcelRegister("hiX3M", function(module, exports) {
const $2392ba39a960c852$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
module.exports["extractAri"] = $2392ba39a960c852$export$be18a6294fd426ec;

});

parcelRegister("ahcye", function(module, exports) {

var $jdqmT = parcelRequire("jdqmT");

const $0fce5bbeb67c3d26$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = (0, $jdqmT.ufoExperiences)[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
module.exports["succeedUfoExperience"] = $0fce5bbeb67c3d26$export$c5a5cf072c836c0e;

});

parcelRegister("9H66G", function(module, exports) {

var $aSzLn = parcelRequire("aSzLn");


var $bI14T = parcelRequire("bI14T");

const $7612c145765cc46a$var$PENDING_STATE = {
    status: 'pending'
};
function $7612c145765cc46a$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const cardState = (0, $aSzLn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $7612c145765cc46a$var$PENDING_STATE;
}
module.exports["useSmartCardState"] = $7612c145765cc46a$export$b0444d00ba7313c6;

});

parcelRegister("gC0KQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7431dcc384fff9c6c35ed6e93ee3cd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c180c7d0bba24e36$var$_react = $c180c7d0bba24e36$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c180c7d0bba24e36$var$_baseNew = $c180c7d0bba24e36$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c180c7d0bba24e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/rovo
 * Usage guidance:
 * Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c180c7d0bba24e36$var$RovoIcon = (props)=>/*#__PURE__*/ $c180c7d0bba24e36$var$_react.default.createElement($c180c7d0bba24e36$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c180c7d0bba24e36$var$RovoIcon.displayName = 'RovoIcon';
var $c180c7d0bba24e36$var$_default = module.exports.default = $c180c7d0bba24e36$var$RovoIcon;

});

parcelRegister("kfxZm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $6Vsq4 = parcelRequire("6Vsq4");


var $e0XNb = parcelRequire("e0XNb");


var $6kVBl = parcelRequire("6kVBl");


var $12fG9 = parcelRequire("12fG9");


var $kSkO7 = parcelRequire("kSkO7");


var $ahcye = parcelRequire("ahcye");

const $619cc59e3e0a738d$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $619cc59e3e0a738d$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $cozmU.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, prompt: prompt, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, $03RpJ.default)();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        (0, $6kVBl.mark)(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $kSkO7.startUfoExperience)($619cc59e3e0a738d$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType,
                prompt: prompt
            });
            // Invoke action
            const result = await actionFn();
            (0, $6kVBl.mark)(markName, 'resolved');
            (0, $ahcye.succeedUfoExperience)($619cc59e3e0a738d$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: (0, $e0XNb.getMeasure)(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            (0, $6kVBl.mark)(markName, 'errored');
            (0, $12fG9.failUfoExperience)($619cc59e3e0a738d$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: (0, $e0XNb.getMeasure)(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $619cc59e3e0a738d$export$2e2bcd8739ae039 = $619cc59e3e0a738d$var$useInvokeClientAction;
module.exports["default"] = $619cc59e3e0a738d$export$2e2bcd8739ae039;

});

parcelRegister("e0XNb", function(module, exports) {

var $8dW1N = parcelRequire("8dW1N");


var $6gRyu = parcelRequire("6gRyu");

const $a70a1f44e55aec46$export$d6e97a903ae9a3aa = (id, status)=>{
    if (0, $6gRyu.hasPerformanceAPIAvailable) {
        const name = (0, $8dW1N.getMeasureName)(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
module.exports["getMeasure"] = $a70a1f44e55aec46$export$d6e97a903ae9a3aa;

});

parcelRegister("8dW1N", function(module, exports) {
const $39c2a8835324c4e9$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
module.exports["getMeasureName"] = $39c2a8835324c4e9$export$984df7f61dd7928f;

});

parcelRegister("6kVBl", function(module, exports) {

var $9mkmn = parcelRequire("9mkmn");


var $6gRyu = parcelRequire("6gRyu");

const $0558e3ba1490ad5c$export$bf7f2fce5c1cf636 = (id, status)=>{
    if (0, $6gRyu.hasPerformanceAPIAvailable) {
        const name = (0, $9mkmn.getMarkName)(id, status);
        performance.mark(name);
    }
};
module.exports["mark"] = $0558e3ba1490ad5c$export$bf7f2fce5c1cf636;

});

parcelRegister("9mkmn", function(module, exports) {
const $be2a2fa13a9faf2a$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
module.exports["getMarkName"] = $be2a2fa13a9faf2a$export$fcff3185c7ce7f2b;

});

parcelRegister("c7dFC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXJjm = parcelRequire("cXJjm");

const $72eb3fb9792f1abd$export$d08617a365fbe694 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (cardClient)=>{
    const $ = (0, $bDgLe.c)(3);
    cardClient?.baseUrlOverride;
    cardClient?.envKey;
    const t0 = cardClient?.envKey;
    const t1 = cardClient?.baseUrlOverride;
    let t2;
    if ($[0] !== t0 || $[1] !== t1) {
        t2 = (0, $cXJjm.getResolverUrl)(t0, t1);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : (cardClient)=>(0, $cozmU.useMemo)(()=>(0, $cXJjm.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $72eb3fb9792f1abd$export$d08617a365fbe694;

});

parcelRegister("cEvdy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kAdyG = parcelRequire("kAdyG");


var $bI14T = parcelRequire("bI14T");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $jdqmT = parcelRequire("jdqmT");

const $d1c070c4a1b47aa7$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    (0, $jdqmT.ufoExperiences)[experienceName].getInstance(id).addMetadata(properties);
};



var $2VZDL = parcelRequire("2VZDL");

const $39da6c58461ffd47$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $bI14T.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $2VZDL.default)();
    return (0, $cozmU.useCallback)(async (params)=>{
        const { url: url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, id: id = '', appearance: appearance } = params;
        const isOptimizedBlockRequest = appearance === 'block' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        const { details: details } = getState()[url] || {
            status: (0, $4yYAm.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $kAdyG.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest || isOptimizedBlockRequest) {
            // A reduced inline response can populate the shared resolver cache before an initial
            // block request completes, so every optimized block request must bypass that cache.
            const shouldForceFetch = isReloading || isOptimizedBlockRequest;
            const metadataStatus = appearance === 'inline' && !isMetadataRequest && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? 'pending' : undefined;
            return connections.client.fetchData(url, shouldForceFetch, appearance).then((response)=>handleResolvedLinkResponse(url, response, shouldForceFetch, isMetadataRequest, metadataStatus)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        } else (0, $d1c070c4a1b47aa7$export$4084c0df4a03a6af)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $39da6c58461ffd47$export$2e2bcd8739ae039 = $39da6c58461ffd47$var$useResolve;
module.exports["default"] = $39da6c58461ffd47$export$2e2bcd8739ae039;

});

parcelRegister("2VZDL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $bI14T = parcelRequire("bI14T");


var $fxYwc = parcelRequire("fxYwc");

var $ixC10 = parcelRequire("ixC10");

var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $4yYAm = parcelRequire("4yYAm");


var $8p295 = parcelRequire("8p295");

const $0ee536fadf0899e7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $8p295.emptyData)
        }
    });


const $7deabd932e788273$export$297c39c8b9bfca0 = 'resolving';
const $7deabd932e788273$export$b64a888338c24e0e = 'errored';
const $7deabd932e788273$export$677b6edfa0002c70 = 'fallback';
const $7deabd932e788273$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $7deabd932e788273$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $7deabd932e788273$export$338f7d9ccca1975d = 'Error resolving metadata.';


const $dbef6ca4ad6a877e$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $bI14T.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $cozmU.useCallback)((url, metadataStatus)=>{
        dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $cozmU.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $4yYAm.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RESOLVED), {
            url: url
        }, (0, $0ee536fadf0899e7$export$b9482e0f6d365cc7)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $cozmU.useCallback)((resourceUrl, response, isReloading, isMetadataRequest, metadataStatus = 'resolved')=>{
        // Some optimized resolves intentionally leave metadata pending so hover can fetch it.
        // Check response status before evaluating the feature gate so non-resolved responses
        // do not fire a gate exposure when the gate result would be ignored.
        const shouldUseProvidedMetadataStatus = (0, $ggGdk.getStatus)(response) === 'resolved' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization');
        setMetadataStatus(resourceUrl, shouldUseProvidedMetadataStatus ? metadataStatus : 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $fxYwc.cardAction)((0, $fxYwc.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $cozmU.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest, metadataStatus)=>{
        if (!resourceUrl) return;
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $ggGdk.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $ixC10.APIError)('fallback', hostname, (0, $7deabd932e788273$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $ixC10.APIError)('fatal', hostname, (0, $7deabd932e788273$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $ixC10.APIError)('error', hostname, (0, $7deabd932e788273$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $9kbTQ.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest, metadataStatus);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $cozmU.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $dbef6ca4ad6a877e$export$2e2bcd8739ae039 = $dbef6ca4ad6a877e$var$useResponse;
module.exports["default"] = $dbef6ca4ad6a877e$export$2e2bcd8739ae039;

});

parcelRegister("8p295", function(module, exports) {
const $0f790ef426385286$export$49de42a13d6e867c = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
module.exports["emptyData"] = $0f790ef426385286$export$49de42a13d6e867c;

});

parcelRegister("130CJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $hdBxM = parcelRequire("hdBxM");

const $3e1f6848e6a7fd46$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $3e1f6848e6a7fd46$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $3e1f6848e6a7fd46$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $3e1f6848e6a7fd46$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $3e1f6848e6a7fd46$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($3e1f6848e6a7fd46$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $3e1f6848e6a7fd46$var$allowedOrigins.includes(hostname));
};
const $3e1f6848e6a7fd46$export$e5e1a9c59c299631 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    let t0;
    let t1;
    if ($[0] !== publish) {
        t0 = ()=>{
            const handlerUnbind = (0, $cbY7C.bind)(window, {
                type: "message",
                listener: (event)=>{
                    if (!$3e1f6848e6a7fd46$export$c9fe6aef04e3544f(event.origin)) return;
                    if (event.data.eventType === $3e1f6848e6a7fd46$export$cabfb6cc8c48b099) {
                        const eventData = event.data;
                        const ackPayload = {
                            eventType: $3e1f6848e6a7fd46$export$25a11ea4740a334,
                            payloadId: eventData.payloadId
                        };
                        event.source?.postMessage(ackPayload, {
                            targetOrigin: "*"
                        });
                        publish(event.data.payload);
                    }
                }
            });
            return handlerUnbind;
        };
        t1 = [
            publish
        ];
        $[0] = publish;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return null;
} : ()=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        const handlerUnbind = (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$3e1f6848e6a7fd46$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $3e1f6848e6a7fd46$export$cabfb6cc8c48b099) {
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $3e1f6848e6a7fd46$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    event.source?.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $3e1f6848e6a7fd46$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $3e1f6848e6a7fd46$export$5340cc94dd0ecbea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const onAcknowledgeTimeoutTimeoutRef = (0, $cozmU.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const handlerUnbind = (0, $cbY7C.bind)(window, {
                type: "message",
                listener: (event)=>{
                    if (!$3e1f6848e6a7fd46$export$c9fe6aef04e3544f(event.origin)) return;
                    if (event.data.eventType !== $3e1f6848e6a7fd46$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                    const eventData = event.data;
                    if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                    clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                    onAcknowledgeTimeoutTimeoutRef.current = null;
                    setIsWaitingForAck(false);
                }
            });
            return handlerUnbind;
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (t3)=>{
            const { targetWindow: t4, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout } = t3;
            const targetWindow = t4 === undefined ? window.parent : t4;
            if (!targetWindow) return;
            const payloadId = Math.floor(Math.random() * 1000000).toString();
            targetWindow.postMessage({
                eventType: $3e1f6848e6a7fd46$export$cabfb6cc8c48b099,
                payload: payload,
                payloadId: payloadId
            }, "*");
            setIsWaitingForAck(true);
            const timeout = window.setTimeout(()=>{
                onAcknowledgeTimeout({
                    payload: payload
                });
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }, $3e1f6848e6a7fd46$var$TIMEOUT_WAIT_FOR_ACK);
            onAcknowledgeTimeoutTimeoutRef.current = {
                timeout: timeout,
                lastPayloadId: payloadId
            };
        };
        $[2] = t2;
    } else t2 = $[2];
    const publishWithPostMessage = t2;
    let t3;
    if ($[3] !== isWaitingForAck) {
        t3 = {
            publishWithPostMessage: publishWithPostMessage,
            isWaitingForAck: isWaitingForAck
        };
        $[3] = isWaitingForAck;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $cozmU.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const handlerUnbind = (0, $cbY7C.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$3e1f6848e6a7fd46$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $3e1f6848e6a7fd46$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $cozmU.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $3e1f6848e6a7fd46$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $3e1f6848e6a7fd46$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};
module.exports["ROVO_POST_MESSAGE_EVENT_TYPE"] = $3e1f6848e6a7fd46$export$cabfb6cc8c48b099;
module.exports["RovoPostMessagePubsubListener"] = $3e1f6848e6a7fd46$export$e5e1a9c59c299631;
module.exports["useRovoPostMessageToPubsub"] = $3e1f6848e6a7fd46$export$5340cc94dd0ecbea;

});

parcelRegister("aflIU", function(module, exports) {
const $1e705347cff25723$export$e9a534e68169723d = (rovoConfig)=>rovoConfig?.isRovoEnabled && rovoConfig?.isRovoLLMEnabled ? true : false;
module.exports["getIsRovoChatEnabled"] = $1e705347cff25723$export$e9a534e68169723d;

});

parcelRegister("aGLwK", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6Eovk = parcelRequire("6Eovk");


var $iDrrr = parcelRequire("iDrrr");


var $htZ7r = parcelRequire("htZ7r");

const $73386b9394e92de9$var$styles = {
    roundImg: "_0bjKvDS5Zs"
};
const $73386b9394e92de9$var$messages = (0, $kSwu1.defineMessages)({
    imageAltText: {
        id: "smart-link.image-icon.altText",
        defaultMessage: "Link Icon"
    }
});
const $73386b9394e92de9$var$ImageIcon = ({ label: label, defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // If url changes, reset state
    (0, $cozmU.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ $cozmU.createElement("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label?.trim() ?? '' : '',
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $hekY6.default)([
            appearance === 'round' && $73386b9394e92de9$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ $cozmU.createElement((0, $6Eovk.default), {
        src: url,
        loading: /*#__PURE__*/ $cozmU.createElement((0, $htZ7r.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ $cozmU.createElement("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label?.trim() ?? '' : formatMessage($73386b9394e92de9$var$messages.imageAltText),
            style: {
                width: width,
                height: height
            },
            className: (0, $hekY6.default)([
                appearance === 'round' && $73386b9394e92de9$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $73386b9394e92de9$export$2e2bcd8739ae039 = $73386b9394e92de9$var$ImageIcon;
module.exports["default"] = $73386b9394e92de9$export$2e2bcd8739ae039;

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $cozmU = parcelRequire("cozmU");


var $1BCyZ = parcelRequire("1BCyZ");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1BCyZ))), props);
}

});

parcelRegister("htZ7r", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $18f780449a03a2f6$var$animationNameStyles = null;
const $18f780449a03a2f6$var$loadingSkeletonStyle = null;
const $18f780449a03a2f6$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _20VacPYbGa _0KLXruaVjy _3CkH9ozuPt _2z4m57UZDI _3OqcjTLH3G _3iDTPbvbI6 _0nFVCGipXj _3Y6bKpgRhm _03m2nySHWH _1gBibyHvL7 _43vdfTHVQb"
        ])
    });
};
module.exports["LoadingSkeleton"] = $18f780449a03a2f6$export$44c18d210d5de37b;

});

parcelRegister("hSs5g", function(module, exports) {
$parcel$export(module.exports, "default", () => $57af1bd0c8b08ac5$export$2e2bcd8739ae039);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6nl31 = parcelRequire("6nl31");

var $as0eE = parcelRequire("as0eE");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $lUcpS = parcelRequire("lUcpS");


var $jp2Q3 = parcelRequire("jp2Q3");


var $ieeJu = parcelRequire("ieeJu");

const $5e76c2a3ae5f8e22$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $5e76c2a3ae5f8e22$export$2e2bcd8739ae039 = $5e76c2a3ae5f8e22$var$filterActions;





const $3d93ddf619b05487$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($3d93ddf619b05487$var$messages.label, {
        fullName: fullName
    }) : formatMessage($3d93ddf619b05487$var$messages.fallbackLabel);
};
const $3d93ddf619b05487$var$messages = (0, $kSwu1.defineMessages)({
    fallbackLabel: {
        id: "profilecard.user.trigger.fallback-aria-label",
        defaultMessage: "More information about this user"
    },
    label: {
        id: "profilecard.user.trigger.aria-label",
        defaultMessage: "More information about {fullName}"
    }
});
var $3d93ddf619b05487$export$2e2bcd8739ae039 = $3d93ddf619b05487$var$getLabelMessage;



var $jyWTZ = parcelRequire("jyWTZ");


var $cSSWJ = parcelRequire("cSSWJ");

const $173a9bcfac768aab$export$5b956b542f1bc1b3 = 800;
const $173a9bcfac768aab$export$89a9f35a94d7f196 = 200;



var $1GhPJ = parcelRequire("1GhPJ");


var $4PAHv = parcelRequire("4PAHv");


var $cHMfQ = parcelRequire("cHMfQ");














var $lfoFx = parcelRequire("lfoFx");










const $d60d63ca00a9acae$var$UserLoadingState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { fireAnalytics: fireAnalytics } = t0;
    let t1;
    let t2;
    if ($[0] !== fireAnalytics) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.spinner", {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            fireAnalytics
        ];
        $[0] = fireAnalytics;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.SpinnerContainer), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
        });
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ fireAnalytics: fireAnalytics })=>{
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.spinner', {
            firedAt: Math.round((0, $1GhPJ.getPageTime)()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
    });
};
var $d60d63ca00a9acae$export$2e2bcd8739ae039 = $d60d63ca00a9acae$var$UserLoadingState;


const $57af1bd0c8b08ac5$var$ProfileCardContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProfileCardContent(t0) {
    const $ = (0, $bDgLe.c)(19);
    const { profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, isRenderedInPortal: isRenderedInPortal, addFlag: addFlag, hideAgentMoreActions: hideAgentMoreActions, hideAiDisclaimer: hideAiDisclaimer } = t0;
    if (isAgent) {
        const t1 = agentActions?.onChatClick;
        const t2 = agentActions?.onConversationStartersClick;
        const t3 = !!hideAgentMoreActions;
        let t4;
        if ($[0] !== profilecardProps) {
            t4 = (0, $iDrrr.fg)("jira_ai_hide_conversation_starters_profilecard") && !!profilecardProps.hideAgentConversationStarters;
            $[0] = profilecardProps;
            $[1] = t4;
        } else t4 = $[1];
        let t5;
        if ($[2] !== addFlag || $[3] !== cloudId || $[4] !== hideAiDisclaimer || $[5] !== resourceClient || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== trigger || $[11] !== userId) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4PAHv.AgentProfileCardResourced), {
                accountId: userId,
                cloudId: cloudId,
                resourceClient: resourceClient,
                trigger: trigger,
                onChatClick: t1,
                onConversationStartersClick: t2,
                addFlag: addFlag,
                hideMoreActions: t3,
                hideConversationStarters: t4,
                hideAiDisclaimer: hideAiDisclaimer
            });
            $[2] = addFlag;
            $[3] = cloudId;
            $[4] = hideAiDisclaimer;
            $[5] = resourceClient;
            $[6] = t1;
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
            $[10] = trigger;
            $[11] = userId;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    } else {
        let t1;
        if ($[13] !== errorType || $[14] !== hasError || $[15] !== isRenderedInPortal || $[16] !== profileCardAction || $[17] !== profilecardProps) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cHMfQ.ProfileCardLazy), {
                    ...profilecardProps,
                    isRenderedInPortal: isRenderedInPortal,
                    actions: profileCardAction,
                    hasError: hasError,
                    errorType: errorType,
                    withoutElevation: true
                })
            });
            $[13] = errorType;
            $[14] = hasError;
            $[15] = isRenderedInPortal;
            $[16] = profileCardAction;
            $[17] = profilecardProps;
            $[18] = t1;
        } else t1 = $[18];
        const profileCard = t1;
        return profileCard;
    }
} : function ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, trigger: trigger, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, isRenderedInPortal: isRenderedInPortal, addFlag: addFlag, hideAgentMoreActions: hideAgentMoreActions, hideAiDisclaimer: hideAiDisclaimer }) {
    if (isAgent) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4PAHv.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: trigger,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag,
        hideMoreActions: !!hideAgentMoreActions,
        hideConversationStarters: (0, $iDrrr.fg)('jira_ai_hide_conversation_starters_profilecard') && !!profilecardProps.hideAgentConversationStarters,
        hideAiDisclaimer: hideAiDisclaimer
    });
    else {
        const profileCard = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cHMfQ.ProfileCardLazy), {
                ...profilecardProps,
                isRenderedInPortal: isRenderedInPortal,
                actions: profileCardAction,
                hasError: hasError,
                errorType: errorType,
                withoutElevation: true
            })
        });
        return profileCard;
    }
};
function $57af1bd0c8b08ac5$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, hideAgentMoreActions: hideAgentMoreActions, hideAiDisclaimer: hideAiDisclaimer, hideAgentConversationStarters: hideAgentConversationStarters, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, isRenderedInPortal: isRenderedInPortal, ssrPlaceholderId: ssrPlaceholderId, showDelay: customShowDelay, hideDelay: customHideDelay }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isMounted = (0, $cozmU.useRef)(false);
    const [visible, setVisible] = (0, $cozmU.useState)(false);
    const showTimer = (0, $cozmU.useRef)(0);
    const hideTimer = (0, $cozmU.useRef)(0);
    const isExternalControl = propsIsVisible !== undefined && propsIsVisible !== visible;
    // Skip delay entirely for click triggers.
    const shouldSkipDelay = trigger === 'click';
    // When externally controlled, use a short debounce to absorb rapid focus
    // changes from dropdown options settling after async load.
    const REDUCED_DELAY_MS = 100;
    const shouldReduceDelay = isExternalControl;
    let showDelay = customShowDelay ?? (0, $173a9bcfac768aab$export$5b956b542f1bc1b3);
    let hideDelay = customHideDelay ?? (0, $173a9bcfac768aab$export$89a9f35a94d7f196);
    if (shouldSkipDelay) {
        showDelay = 0;
        hideDelay = 0;
    } else if (shouldReduceDelay) {
        showDelay = REDUCED_DELAY_MS;
        hideDelay = REDUCED_DELAY_MS;
    }
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(undefined);
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [data, setData] = (0, $cozmU.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $cozmU.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $cozmU.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $cozmU.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $cozmU.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const triggerRef = (0, $cozmU.useRef)(null);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $cozmU.useCallback)((eventKey, ...attributes)=>{
        if (!isMounted.current) return;
        fireEvent(eventKey, ...attributes);
    }, [
        fireEvent
    ]);
    const hideProfilecard = (0, $cozmU.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $cozmU.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $cozmU.useCallback)((profileData, reportingLinesData_0, shouldShowGiveKudos_0, teamCentralBaseUrl_0)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData_0);
        setTeamCentralBaseUrl(teamCentralBaseUrl_0);
        setShouldShowGiveKudos(shouldShowGiveKudos_0);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $cozmU.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $cozmU.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err_0) {
            handleClientError(err_0);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $cozmU.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $cozmU.useCallback)((event_0)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event_0.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics('ui.profilecard.triggered', {
            method: 'click',
            firedAt: Math.round((0, $1GhPJ.getPageTime)()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics('ui.profilecard.triggered', {
            method: 'hover',
            firedAt: Math.round((0, $1GhPJ.getPageTime)()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $cozmU.useCallback)((event_1)=>{
        if (event_1.key === 'Enter' || event_1.key === ' ') {
            event_1.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics('ui.profilecard.triggered', {
                method: 'click',
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $cozmU.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $cozmU.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $cozmU.useCallback)(()=>{
        return (0, $5e76c2a3ae5f8e22$export$2e2bcd8739ae039)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $cozmU.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes,
        hideAgentConversationStarters: (0, $iDrrr.fg)('jira_ai_hide_conversation_starters_profilecard') && hideAgentConversationStarters
    };
    const ssrPlaceholderProp = ssrPlaceholderId ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
                isOpen: !!visible,
                onClose: (event_2)=>{
                    hideProfilecard();
                    handleKeyboardClose(event_2);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($57af1bd0c8b08ac5$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $8aG6j.jsx)($57af1bd0c8b08ac5$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag,
                            hideAgentMoreActions: hideAgentMoreActions,
                            hideAiDisclaimer: hideAiDisclaimer,
                            isRenderedInPortal: isRenderedInPortal
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $3d93ddf619b05487$export$2e2bcd8739ae039)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $jp2Q3.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: (0, $ieeJu.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true) ? isRenderedInPortal && isTriggeredUsingKeyboard ? false : autoFocus ?? trigger === 'click' : autoFocus ?? trigger === 'click'
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nl31.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $as0eE.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $57af1bd0c8b08ac5$var$LoadingView = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { fireAnalytics: fireAnalytics } = t0;
    let t1;
    if ($[0] !== fireAnalytics) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.CardWrapper), {
            testId: "profilecard.profilecardtrigger.loading",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d60d63ca00a9acae$export$2e2bcd8739ae039), {
                fireAnalytics: fireAnalytics
            })
        });
        $[0] = fireAnalytics;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jyWTZ.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d60d63ca00a9acae$export$2e2bcd8739ae039), {
            fireAnalytics: fireAnalytics
        })
    });

});

parcelRegister("6nl31", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a7b4f120cddcf96a$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dlVFb")));
module.exports["GiveKudosLauncherLazy"] = $a7b4f120cddcf96a$export$93fe397a02fe8b76;

});

parcelRegister("dlVFb", function(module, exports) {

let $9b89f73b1036f223$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9b89f73b1036f223$var$load("6wr18"),
    $9b89f73b1036f223$var$load("i0Zk0"),
    $9b89f73b1036f223$var$load("ffEVr"),
    $9b89f73b1036f223$var$load("hhss7"),
    $9b89f73b1036f223$var$load("8V3WU")
]).then(()=>parcelRequire('8nrG9'));

});

parcelRegister("as0eE", function(module, exports) {
var $d3343dab19413a59$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $d3343dab19413a59$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $d3343dab19413a59$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($d3343dab19413a59$export$d21f9befaa2961a).includes(value);
};
module.exports["KudosType"] = $d3343dab19413a59$export$4fa2020056771264;
module.exports["FlagEventType"] = $d3343dab19413a59$export$d21f9befaa2961a;
module.exports["isFlagEventTypeValue"] = $d3343dab19413a59$export$7a1fc1a1b0477464;

});

parcelRegister("jyWTZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $073269a9a169ec3d$var$styles = {
    cardWrapper: "_39xV02wBC3",
    spinnerContainer: "_0hPCNLDIqT _3iDTPbQ4SZ _0jFU0VJgOI _37wbyuDIqT _1mT5xdRAKS"
};
const $073269a9a169ec3d$export$6aa22a823032b784 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, role: role, testId: testId, labelledBy: labelledBy, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($073269a9a169ec3d$var$styles.cardWrapper);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== ariaLabel || $[2] !== children || $[3] !== labelledBy || $[4] !== role || $[5] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            backgroundColor: "elevation.surface.overlay",
            role: role,
            testId: testId,
            "aria-labelledby": labelledBy,
            "aria-label": ariaLabel,
            children: children
        });
        $[1] = ariaLabel;
        $[2] = children;
        $[3] = labelledBy;
        $[4] = role;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ children: children, role: role, testId: testId, labelledBy: labelledBy, ariaLabel: ariaLabel })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($073269a9a169ec3d$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        "aria-label": ariaLabel,
        children: children
    });
const $073269a9a169ec3d$export$a5e06607a5ac6158 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($073269a9a169ec3d$var$styles.spinnerContainer);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: t1,
            children: children
        });
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($073269a9a169ec3d$var$styles.spinnerContainer),
        children: children
    });
module.exports["CardWrapper"] = $073269a9a169ec3d$export$6aa22a823032b784;
module.exports["SpinnerContainer"] = $073269a9a169ec3d$export$a5e06607a5ac6158;

});

parcelRegister("1GhPJ", function(module, exports) {
const $b79121f0bdcafc37$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $b79121f0bdcafc37$var$performanceAvailable = $b79121f0bdcafc37$var$isPerformanceAvailable();
const $b79121f0bdcafc37$var$initialPageTime = Date.now();
const $b79121f0bdcafc37$export$e9faea7c41053334 = ()=>{
    if ($b79121f0bdcafc37$var$performanceAvailable) return performance.now();
    return Date.now() - $b79121f0bdcafc37$var$initialPageTime;
};
module.exports["getPageTime"] = $b79121f0bdcafc37$export$e9faea7c41053334;

});

parcelRegister("cHMfQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $dc9e2594e821ecd6$export$403d297463f226af = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aOYbM")));
module.exports["ProfileCardLazy"] = $dc9e2594e821ecd6$export$403d297463f226af;

});

parcelRegister("aOYbM", function(module, exports) {

let $7e0d432dbbb882b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e0d432dbbb882b1$var$load("cuMia"),
    $7e0d432dbbb882b1$var$load("6wr18"),
    $7e0d432dbbb882b1$var$load("8ZQ6W"),
    $7e0d432dbbb882b1$var$load("8H6bN"),
    $7e0d432dbbb882b1$var$load("4x9Jx"),
    $7e0d432dbbb882b1$var$load("ea3NB"),
    $7e0d432dbbb882b1$var$load("ffEVr"),
    $7e0d432dbbb882b1$var$load("7EorR"),
    $7e0d432dbbb882b1$var$load("hhss7"),
    $7e0d432dbbb882b1$var$load("Wowvf"),
    $7e0d432dbbb882b1$var$load("cleKV")
]).then(()=>parcelRequire('8R7JI'));

});

parcelRegister("hMCZS", function(module, exports) {

var $3AzLy = parcelRequire("3AzLy");

function $8838e760b5a08bae$export$82476f982757e71e(path, config, query = new URLSearchParams(), anchor) {
    return (0, $3AzLy.generateTeamsAppPath)(path, config, query, anchor);
}



var $gpeTJ = parcelRequire("gpeTJ");

const $7766a88bfa4c0f9b$export$7333db99aa99d383 = ()=>globalThis.location?.pathname;


function $6e01a6e73e89275c$export$a792d22ca73cc3ca() {
    const path = (0, $7766a88bfa4c0f9b$export$7333db99aa99d383)();
    if (path.startsWith('/wiki')) return 'confluence';
    if (path.startsWith('/jira')) return 'jira';
    if ((0, $gpeTJ.hostname)().startsWith('home')) return 'home';
    return undefined;
}


function $7886709068025f37$var$stripAriFromId(id) {
    // Return everything after the last slash
    return id.includes('/') ? id.split('/').pop() || '' : id;
}
function $7886709068025f37$export$b406f12e2156b3fe(action) {
    switch(action.type){
        case 'LANDING':
        case 'DIRECTORY':
            return {
                path: ''
            };
        case 'USER':
            // Safety check for undefined userId, just redirect to the landing page as the profile redirect will fail
            if (!action.payload?.userId) return {
                path: ''
            };
            return {
                path: `${$7886709068025f37$var$stripAriFromId(action.payload.userId)}`,
                anchor: action.payload.section
            };
        case 'TEAM':
            // Safety check for undefined teamId, just redirect to the landing page as the team redirect will fail
            if (!action.payload?.teamId) return {
                path: ''
            };
            return {
                path: `team/${$7886709068025f37$var$stripAriFromId(action.payload.teamId)}`
            };
        case 'AGENT':
            // Safety check for undefined agentId, just redirect to the landing page as the agent redirect will fail
            if (!action.payload?.agentId) return {
                path: ''
            };
            return {
                path: `agent/${$7886709068025f37$var$stripAriFromId(action.payload.agentId)}`
            };
        case 'KUDOS':
            // Safety check for undefined kudosId, just redirect to the landing page as the kudos redirect will fail
            if (!action.payload?.kudosId) return {
                path: ''
            };
            return {
                path: `kudos/${$7886709068025f37$var$stripAriFromId(action.payload.kudosId)}`
            };
        case 'TEAMS_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_TEAMS'
                })
            };
        case 'PEOPLE_DIRECTORY':
            return {
                path: '',
                query: new URLSearchParams({
                    screen: 'SEARCH_PEOPLE'
                })
            };
        case 'USER_WORK':
            return {
                path: `${$7886709068025f37$var$stripAriFromId(action.payload.userId)}/work`
            };
        case 'CURRENT_USER_PROFILE':
            return {
                path: 'me'
            };
        default:
            return {
                path: ''
            };
    }
}


const $1c14db77ba6dad09$export$9e52b10d57ddf9e3 = (url)=>window.open(url, '_blank', 'noopener noreferrer');


function $0db3ac64be13eece$export$89e12c5b50f7529d(url) {
    window.location.href = url;
}


const $c596cd5329ce05e1$export$39f25014273b0a58 = (href, config)=>(e)=>{
        if (e) e.preventDefault();
        if (config.shouldOpenInSameTab) {
            (0, $0db3ac64be13eece$export$89e12c5b50f7529d)(href);
            return;
        }
        (0, $1c14db77ba6dad09$export$9e52b10d57ddf9e3)(href);
    };


const $e29b58e5db68f55d$export$cd99a4ca8e852372 = (action)=>{
    const { hostProduct: hostProduct, shouldOpenInSameTab: shouldOpenInSameTab } = action;
    const actionWithDefaults = {
        ...action,
        /**
     * Default to opening in a new tab.
     */ shouldOpenInSameTab: shouldOpenInSameTab === undefined ? false : shouldOpenInSameTab,
        hostProduct: hostProduct || (0, $6e01a6e73e89275c$export$a792d22ca73cc3ca)()
    };
    const { path: path, query: query } = (0, $7886709068025f37$export$b406f12e2156b3fe)(actionWithDefaults);
    const href = (0, $8838e760b5a08bae$export$82476f982757e71e)(path, actionWithDefaults, query);
    const onNavigate = (0, $c596cd5329ce05e1$export$39f25014273b0a58)(href, actionWithDefaults);
    const result = {
        onNavigate: onNavigate,
        href: href,
        target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
    };
    return result;
};
module.exports["navigateToTeamsApp"] = $e29b58e5db68f55d$export$cd99a4ca8e852372;

});

parcelRegister("3AzLy", function(module, exports) {

var $c4iAx = parcelRequire("c4iAx");


var $9joJM = parcelRequire("9joJM");


var $jH9cM = parcelRequire("jH9cM");


var $i3S9F = parcelRequire("i3S9F");


var $1hQ0e = parcelRequire("1hQ0e");

const $b7dcf3539e4a339e$export$57570b1603cf6adb = ()=>{
    const browserDocument = (0, $1hQ0e.getDocument)();
    // @ts-expect-error
    return browserDocument?.querySelector('meta[name=ajs-environment]')?.content === 'staging' ? 'staging' : 'prod';
};



var $gpeTJ = parcelRequire("gpeTJ");

function $73b03ff02fdec461$export$a9f2c34176fff494() {
    const host = (0, $gpeTJ.hostname)();
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (host.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return true;
    // *.atlassian-stg-fedm.net
    if (host.match(/atlassian-stg-fedm\.net/)) return true;
    return false;
}


function $56733284f8710106$export$9665cb78fbba2c92(path, config, query = new URLSearchParams(), anchor) {
    if (config.cloudId) query.set('cloudId', config.cloudId);
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    const pathWithPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash : `/people${pathWithLeadingSlash}`;
    const pathWithoutPeoplePrefix = pathWithLeadingSlash.startsWith('/people') ? pathWithLeadingSlash.replace(/^\/people\//, '/') : pathWithLeadingSlash;
    // URLSearchParams.size doesn't work in jest
    const queryString = [
        ...new Set(query.keys())
    ].length > 0 ? `?${query.toString()}` : '';
    // Home & therefore the Teams app, is not deployed to FedRamp, instead we have deployed Standalone directory.
    // At some point, likely both Commercial & FedRamp will follow the same URL convention and we can remove this,
    // but for now, we need to generate a different URL for FedRamp.
    if ((0, $jH9cM.isFedRamp)()) // We can't use getATLContextUrl here as the URL doesn't yet exist in commercial. When it does, we should properly define it there.
    return `https://teams${(0, $73b03ff02fdec461$export$a9f2c34176fff494)() ? '.stg' : ''}.atlassian-us-gov-mod.com${pathWithoutPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    const orgIdString = config.orgId ? `/o/${config.orgId}` : '';
    if ((0, $i3S9F.isIsolatedCloud)()) return `${(0, $9joJM.getUrlForDomainInContext)('home', (0, $b7dcf3539e4a339e$export$57570b1603cf6adb)())}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
    return `${(0, $c4iAx.getATLContextUrl)('home')}${orgIdString}${pathWithPeoplePrefix}${anchor ? `#${anchor}` : ''}${queryString}`;
}
module.exports["generateTeamsAppPath"] = $56733284f8710106$export$9665cb78fbba2c92;

});

parcelRegister("c4iAx", function(module, exports) {

var $2VNj8 = parcelRequire("2VNj8");

function $f22c0bbcdeaae91a$export$45d6512913ef41b4(domain) {
    return `${globalThis.location?.protocol ?? 'https:'}//${(0, $2VNj8.getATLContextDomain)(domain)}`;
}
module.exports["getATLContextUrl"] = $f22c0bbcdeaae91a$export$45d6512913ef41b4;

});

parcelRegister("2VNj8", function(module, exports) {

var $giwdZ = parcelRequire("giwdZ");




const $df4444726b0d45e5$export$6836b090dbaa813a = {
    [(0, $giwdZ.COMMERCIAL)]: {
        [(0, $giwdZ.STAGING)]: 'stg.atlassian.com',
        [(0, $giwdZ.PRODUCTION)]: 'atlassian.com'
    },
    [(0, $giwdZ.FEDRAMP_FEDEX)]: {
        [(0, $giwdZ.STAGING)]: 'atlassian-fex.com'
    },
    [(0, $giwdZ.FEDRAMP_MODERATE)]: {
        [(0, $giwdZ.STAGING)]: 'stg.atlassian-us-gov-mod.com',
        [(0, $giwdZ.PRODUCTION)]: 'atlassian-us-gov-mod.com'
    }
};





const $5f7086aacbd4ee9b$export$4723232b625f823e = {
    analytics: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'analytics.atlassian.com'
        }
    },
    // Marketing site
    confluence: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'confluence.atlassian.com'
        }
    },
    // Atlassian design system documentation
    design: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'design.atlassian.com'
        }
    },
    // Old staff intranet (now hello.atlassian.net)
    extranet: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'extranet.atlassian.com'
        }
    },
    // Go links
    go: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'go.atlassian.com'
        }
    },
    my: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'my.atlassian.com'
        }
    },
    schema: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'schema.atlassian.com'
        }
    },
    start: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'start.atlassian.com',
            [(0, $giwdZ.STAGING)]: 'start.stg.atlassian.com'
        },
        [(0, $giwdZ.FEDRAMP_MODERATE)]: {
            [(0, $giwdZ.PRODUCTION)]: 'start.atlassian-us-gov-mod.com',
            [(0, $giwdZ.STAGING)]: 'start.stg.atlassian-us-gov-mod.com'
        }
    },
    surveys: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'surveys.atlassian.com'
        }
    },
    'wac-cdn': {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'wac-cdn.atlassian.com'
        }
    },
    integrations: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'integrations.atlassian.com'
        }
    },
    permalink: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'permalink.atlassian.com'
        }
    },
    id: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'id.atlassian.com',
            [(0, $giwdZ.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $giwdZ.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $giwdZ.FEDRAMP_MODERATE)]: {
            [(0, $giwdZ.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $giwdZ.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    },
    support: {
        [(0, $giwdZ.COMMERCIAL)]: {
            [(0, $giwdZ.PRODUCTION)]: 'support.atlassian.com'
        }
    }
};


const $cff12c75ac93b8ec$export$c6ab20d0ac4d06b2 = {};


/* *NOTE*: please ensure any changes made to Perimeter and DomainKey type is copied in typings/atl-context.globals.d.ts */ const $153a1f69bebe9ead$export$b450288891b9771b = [
    'admin',
    'analytics',
    'api',
    'api.media',
    'api-private',
    'as',
    'atl-global',
    'atlaskit',
    'auth',
    'automation',
    'cassi.internal',
    'cc-import-sources.services',
    'confluence',
    'confluence-chats-integr.services',
    'confluence-cloud-bamboo.internal',
    'confluence-questions.services',
    'data-portal.internal',
    'design',
    'developer',
    'extranet',
    'go',
    'id',
    'id-mail-assets',
    'integrations',
    'ja',
    'jira',
    'jsd-widget',
    'jsd-widget-staging',
    'marketplace',
    'my',
    'my-reminders.services',
    'partners',
    'permalink',
    'permalink.stg',
    'schema',
    'start',
    'support',
    'surveys',
    'team',
    'wac-cdn',
    'xxid',
    'home'
];





function $b9731c8ed71892a7$export$509d18a5fd824839() {
    const hostname = globalThis.location?.hostname;
    if (!hostname) // default if no location available
    return [
        (0, $giwdZ.PRODUCTION),
        (0, $giwdZ.COMMERCIAL)
    ];
    // *.atlassian-fex.com
    if (hostname.match(/atlassian-fex\.com/)) return [
        (0, $giwdZ.STAGING),
        (0, $giwdZ.FEDRAMP_FEDEX)
    ];
    // *.stg.atlassian-us-gov-mod.com OR *.stg.atlassian-us-gov-mod.net
    if (hostname.match(/stg\.atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $giwdZ.STAGING),
        (0, $giwdZ.FEDRAMP_MODERATE)
    ];
    // *.atlassian-stg-fedm.net
    if (hostname.match(/atlassian-stg-fedm\.net/)) return [
        (0, $giwdZ.STAGING),
        (0, $giwdZ.FEDRAMP_MODERATE)
    ];
    // *.atlassian-us-gov-mod.com OR *.atlassian-us-gov-mod.net
    if (hostname.match(/atlassian-us-gov-mod\.(com|net)/)) return [
        (0, $giwdZ.PRODUCTION),
        (0, $giwdZ.FEDRAMP_MODERATE)
    ];
    // *.stg.atlassian.com OR *.stg.internal.atlassian.com
    if (hostname.match(/stg(\.internal)?\.atlassian\.com/)) return [
        (0, $giwdZ.STAGING),
        (0, $giwdZ.COMMERCIAL)
    ];
    // *.jira-dev.com
    if (hostname.match(/jira-dev\.com/)) return [
        (0, $giwdZ.STAGING),
        (0, $giwdZ.COMMERCIAL)
    ];
    // default fallthrough
    return [
        (0, $giwdZ.PRODUCTION),
        (0, $giwdZ.COMMERCIAL)
    ];
}


function $8f1f6814dab6e26b$var$isValidDomainKey(domainKey) {
    if (!(0, $153a1f69bebe9ead$export$b450288891b9771b).includes(domainKey)) return false;
    return true;
}
function $8f1f6814dab6e26b$export$b5ce351acdc48c2a(domain, environment) {
    // Validate this is a valid domain
    if (!$8f1f6814dab6e26b$var$isValidDomainKey(domain)) throw new Error(`Domain ${domain} is not supported.
      Supported domains: ${(0, $153a1f69bebe9ead$export$b450288891b9771b).join(', ')}`);
    // First priority, always return the global context if the product has onboarded
    // @ts-ignore - This is causing ts errors when this package is being enrolled into jira local consumption so temporarily ts ignoring this line for now
    const data = globalThis.ATL_CONTEXT_DOMAIN;
    if (data) return data[domain];
    const [env, perimeter] = environment ?? (0, $b9731c8ed71892a7$export$509d18a5fd824839)();
    // Second priority, return if there is a full domain override
    const override = (0, $5f7086aacbd4ee9b$export$4723232b625f823e)[domain];
    if (override) return(// Exact match preferred
    override[perimeter]?.[env] ?? override[0, $giwdZ.COMMERCIAL][0, $giwdZ.PRODUCTION] // Fallback to mandatory commercial production
    );
    // Third priority, join the subdomain
    const tld = (0, $df4444726b0d45e5$export$6836b090dbaa813a)[perimeter]?.[env] ?? (0, $df4444726b0d45e5$export$6836b090dbaa813a)[0, $giwdZ.COMMERCIAL][0, $giwdZ.PRODUCTION];
    const subdomain = (0, $cff12c75ac93b8ec$export$c6ab20d0ac4d06b2)[domain] ?? domain;
    return `${subdomain}.${tld}`;
}
module.exports["getATLContextDomain"] = $8f1f6814dab6e26b$export$b5ce351acdc48c2a;

});

parcelRegister("9joJM", function(module, exports) {

var $6LNuT = parcelRequire("6LNuT");

function $9f7335448d4f3f38$export$c162de1e7fecc908(subdomain, envType) {
    const domain = (0, $6LNuT.getDomainInContext)(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location?.protocol ?? 'https:'}//${domain}`;
}
module.exports["getUrlForDomainInContext"] = $9f7335448d4f3f38$export$c162de1e7fecc908;

});

parcelRegister("6LNuT", function(module, exports) {

var $gWLpJ = parcelRequire("gWLpJ");




const $b97d2819749f32f8$export$4723232b625f823e = {
    id: {
        [(0, $gWLpJ.COMMERCIAL)]: {
            [(0, $gWLpJ.PRODUCTION)]: 'id.atlassian.com',
            [(0, $gWLpJ.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $gWLpJ.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $gWLpJ.FEDRAMP_MODERATE)]: {
            [(0, $gWLpJ.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $gWLpJ.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};


const $f9cd4957940716ab$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    // Atlassian design system documentation
    design: 'design.atlassian.com',
    // Atlassian design system documentation
    extranet: 'extranet.atlassian.com',
    // Old staff intranet (now hello.atlassian.net)
    go: 'go.atlassian.com',
    // Go links
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    // WAC CDN links
    integrations: 'integrations.atlassian.com',
    // Integrations links
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};






var $fwTbc = parcelRequire("fwTbc");


var $9BR1A = parcelRequire("9BR1A");

function $914d630342263b14$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext?.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $gWLpJ.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext?.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $gWLpJ.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $gWLpJ.COMMERCIAL)
    };
}
function $914d630342263b14$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $9BR1A.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $gWLpJ.COMMERCIAL)
    };
    const isIc = (0, $fwTbc.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $gWLpJ.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $gWLpJ.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $gWLpJ.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}
function $914d630342263b14$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $914d630342263b14$var$cloudEnvironmentSsrLookup();
    return $914d630342263b14$var$cloudEnvironmentCookieLookup();
}



var $8B1kb = parcelRequire("8B1kb");




const $c588028ca60f92ed$export$5860df3acd1ee020 = {
    [(0, $gWLpJ.COMMERCIAL)]: [
        'home',
        'team',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $c588028ca60f92ed$export$c6366754aee43afa = {
    [(0, $gWLpJ.COMMERCIAL)]: [
        'packages'
    ]
};
const $c588028ca60f92ed$export$ad1f7afdb45ad83 = {
    [(0, $gWLpJ.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $c588028ca60f92ed$export$c3b4bc58a05128d6 = {
    [(0, $gWLpJ.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $gWLpJ.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $gWLpJ.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $gWLpJ.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $gWLpJ.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $gWLpJ.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $gWLpJ.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};


function $7fb1919778a37b69$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $c588028ca60f92ed$export$ad1f7afdb45ad83)[perimeter];
    if ((0, $c588028ca60f92ed$export$5860df3acd1ee020)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $c588028ca60f92ed$export$c6366754aee43afa)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
function $7fb1919778a37b69$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $f9cd4957940716ab$export$cfd430a73d68f4bc)[subdomain]) return (0, $f9cd4957940716ab$export$cfd430a73d68f4bc)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $b97d2819749f32f8$export$4723232b625f823e)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $c588028ca60f92ed$export$c3b4bc58a05128d6)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $7fb1919778a37b69$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $914d630342263b14$export$9e04105551ffc5c4)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $8B1kb.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $7fb1919778a37b69$var$getDomainForIsolatedCloud(subdomain, (0, $gWLpJ.COMMERCIAL), domain);
    }
    return $7fb1919778a37b69$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
module.exports["getDomainInContext"] = $7fb1919778a37b69$export$3f82b86ecb947bf0;

});

parcelRegister("8B1kb", function(module, exports) {

var $9BR1A = parcelRequire("9BR1A");

function $28992368131188ad$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location?.hostname;
    const atlCtxCookieValues = (0, $9BR1A.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
module.exports["isolatedCloudDomain"] = $28992368131188ad$export$80638ee198476daf;

});

parcelRegister("5HApy", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => (parcelRequire("c2Doe")).SmartCardProvider);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $c2Doe = parcelRequire("c2Doe");


var $d32fb = parcelRequire("d32fb");

var /**
 * @deprecated Use `import { SmartCardProvider } from '@atlaskit/link-provider/smart-card-provider'` instead.
 */ $bb47cf592f495939$export$2e2bcd8739ae039 = (0, $c2Doe.SmartCardProvider);

});

parcelRegister("aIlZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ricL = parcelRequire("3ricL");


var $cbY7C = parcelRequire("cbY7C");


var $a4skX = parcelRequire("a4skX");


var $iDrrr = parcelRequire("iDrrr");


var $eGfU0 = parcelRequire("eGfU0");


var $iuvXK = parcelRequire("iuvXK");


var $7sdlM = parcelRequire("7sdlM");

// Decides whether the hook should be active for the current runtime.
function $01ce5c591038e3f3$var$computeIsEnabled() {
    const shouldDisable = (0, $iDrrr.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $3ricL.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $a4skX.isFedrampModerate)();
    return !shouldDisable;
}
// Module-level identity wrapper used when the hook is disabled. Stable
// identity avoids causing unnecessary re-renders / effect re-runs in
// downstream consumers.
const $01ce5c591038e3f3$var$identityUrlWrapper = (url)=>url;
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * - Lazy-initialises the session id from the client on the very first render,
 *   eliminating the post-mount re-render that re-generated the `xpis` query
 *   param.
 * - Returns a stable, memoised wrapper so consumer effects keyed on it do not
 *   re-run on unrelated re-renders.
 *
 * See PIRA-3829.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ const $01ce5c591038e3f3$var$useCrossProductUrl = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useCrossProductUrl(options) {
    const $ = (0, $bDgLe.c)(10);
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = $01ce5c591038e3f3$var$computeIsEnabled();
        $[0] = t0;
    } else t0 = $[0];
    const isEnabled = t0;
    let t1;
    if (isEnabled) {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = new (0, $eGfU0.default)();
            $[1] = t2;
        } else t2 = $[1];
        t1 = t2;
    } else t1 = null;
    const interactionSessionClient = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (isEnabled && interactionSessionClient) return interactionSessionClient.getCurrentInteractionSessionId() ?? "";
            return "";
        };
        $[2] = t2;
    } else t2 = $[2];
    const [interactionSessionId, setInteractionSessionId] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (interactionSessionClient && isEnabled) {
                const unbind = (0, $cbY7C.bind)(document, {
                    type: (0, $7sdlM.INTERACTION_SESSION_ID_UPDATED_EVENT),
                    listener: ()=>{
                        const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                        if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                    }
                });
                return unbind;
            }
            return $01ce5c591038e3f3$var$_temp;
        };
        t4 = [
            interactionSessionClient,
            isEnabled
        ];
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[5] !== bridge || $[6] !== interactionSessionId || $[7] !== product || $[8] !== subProduct) {
        t5 = (url)=>(0, $iuvXK.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
        $[5] = bridge;
        $[6] = interactionSessionId;
        $[7] = product;
        $[8] = subProduct;
        $[9] = t5;
    } else t5 = $[9];
    const wrapUrl = t5;
    if (!isEnabled) return $01ce5c591038e3f3$var$identityUrlWrapper;
    return wrapUrl;
} : function useCrossProductUrl(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = $01ce5c591038e3f3$var$computeIsEnabled();
    const interactionSessionClient = (0, $cozmU.useMemo)(()=>{
        if (isEnabled) return new (0, $eGfU0.default)();
        else return null;
    }, [
        isEnabled
    ]);
    const [interactionSessionId, setInteractionSessionId] = (0, $cozmU.useState)(()=>{
        if (isEnabled && interactionSessionClient) return interactionSessionClient.getCurrentInteractionSessionId() ?? '';
        return '';
    });
    (0, $cozmU.useEffect)(()=>{
        if (interactionSessionClient && isEnabled) {
            // The lazy useState initializer above already read the session id on the
            // very first render, so we do NOT re-read here — that would cause the
            // avoidable post-mount re-render this fix is removing.
            const unbind = (0, $cbY7C.bind)(document, {
                type: (0, $7sdlM.INTERACTION_SESSION_ID_UPDATED_EVENT),
                listener: ()=>{
                    const currentSessionId = interactionSessionClient.getCurrentInteractionSessionId();
                    if (currentSessionId) setInteractionSessionId((prev)=>prev === currentSessionId ? prev : currentSessionId);
                }
            });
            return unbind;
        }
        return ()=>{};
    }, [
        interactionSessionClient,
        isEnabled
    ]);
    const wrapUrl = (0, $cozmU.useCallback)((url)=>(0, $iuvXK.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct), [
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
    if (!isEnabled) return $01ce5c591038e3f3$var$identityUrlWrapper;
    return wrapUrl;
};
function $01ce5c591038e3f3$var$_temp() {}
var $01ce5c591038e3f3$export$2e2bcd8739ae039 = $01ce5c591038e3f3$var$useCrossProductUrl;
module.exports["default"] = $01ce5c591038e3f3$export$2e2bcd8739ae039;

});

parcelRegister("2tuSz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lxTPJ = parcelRequire("lxTPJ");

const $0e1964fab56b4af0$export$f7434a73419cbe6f = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $0e1964fab56b4af0$export$73b91fac7f27799f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamsAppAnalyticsContext(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { data: data, children: children } = t0;
    let t1;
    bb0: {
        if (typeof data === "object") {
            let t2;
            if ($[0] !== data) {
                t2 = {
                    ...$0e1964fab56b4af0$export$f7434a73419cbe6f,
                    ...data
                };
                $[0] = data;
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        t1 = $0e1964fab56b4af0$export$f7434a73419cbe6f;
    }
    const analyticsContextData = t1;
    let t2;
    if ($[2] !== analyticsContextData || $[3] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lxTPJ.PeopleTeamsAnalyticsContext), {
            data: analyticsContextData,
            children: children
        });
        $[2] = analyticsContextData;
        $[3] = children;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function TeamsAppAnalyticsContext({ data: data, children: children }) {
    const analyticsContextData = (0, $cozmU.useMemo)(()=>{
        if (typeof data === 'object') return {
            ...$0e1964fab56b4af0$export$f7434a73419cbe6f,
            ...data
        };
        return $0e1964fab56b4af0$export$f7434a73419cbe6f;
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lxTPJ.PeopleTeamsAnalyticsContext), {
        data: analyticsContextData,
        children: children
    });
};
module.exports["TeamsAppAnalyticsContext"] = $0e1964fab56b4af0$export$73b91fac7f27799f;

});

parcelRegister("cP7Ln", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $4nIKB = parcelRequire("4nIKB");


var $4n1IT = parcelRequire("4n1IT");


var $lfoFx = parcelRequire("lfoFx");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");





var $cbY7C = parcelRequire("cbY7C");




/**
 * Hook for managing delayed hover actions with timeout management.
 */ function $760322e9be90cd53$export$beb151954e0eb9fa(callback, delay) {
    const timeoutRef = (0, $cozmU.useRef)(null);
    const callbackRef = (0, $cozmU.useRef)(callback);
    (0, $cozmU.useEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    const schedule = (0, $cozmU.useCallback)(()=>{
        clear();
        timeoutRef.current = window.setTimeout(()=>{
            callbackRef.current();
        }, delay);
    }, [
        delay,
        clear
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clear();
    }, [
        clear
    ]);
    return {
        schedule: schedule,
        clear: clear
    };
}


/**
 * Type guard to check if an event has a relatedTarget property.
 */ function $3c9f1ae38e9f097e$export$63ce2e5e32c4f6a0(event) {
    return 'relatedTarget' in event;
}
/**
 * Checks if the mouse is moving to an atlaskit portal or kudos modal
 * where we should prevent the popup from closing
 */ function $3c9f1ae38e9f097e$export$386001e6036bddcf(relatedTarget) {
    if (!(relatedTarget instanceof HTMLElement)) return false;
    const iframe = relatedTarget.closest('.atlaskit-portal')?.querySelector('iframe') || relatedTarget.closest('iframe');
    return iframe instanceof HTMLIFrameElement && iframe.src.includes('give-kudos');
}
/**
 * Returns the child portal if mouse is moving to a portal controlled by the parent popup.
 */ function $3c9f1ae38e9f097e$export$a5fb0bbf4bb0e26a(relatedTarget, parentPopupElement) {
    if (!(relatedTarget instanceof HTMLElement) || !parentPopupElement) return null;
    const portal = relatedTarget.closest('.atlaskit-portal');
    if (!portal) return null;
    for (const trigger of Array.from(parentPopupElement.querySelectorAll('[aria-controls]'))){
        const controlsId = trigger.getAttribute('aria-controls');
        if (!controlsId) continue;
        const controlsChildInPortal = Array.from(portal.querySelectorAll('[id]')).some((element)=>element.id === controlsId);
        if (controlsChildInPortal) return portal;
    }
    return null;
}


const $e50e8414298f7d73$var$HOVER_OPEN_DELAY = 800;
const $e50e8414298f7d73$var$HOVER_CLOSE_DELAY = 200;
function $e50e8414298f7d73$export$b8df9ab832b125ac({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef, delays: delays = {} }) {
    const { hoverOpen: hoverOpen = $e50e8414298f7d73$var$HOVER_OPEN_DELAY, hoverClose: hoverClose = $e50e8414298f7d73$var$HOVER_CLOSE_DELAY } = delays;
    const triggerNodeRef = (0, $cozmU.useRef)(null);
    const triggerListeners = (0, $cozmU.useRef)([]);
    const contentNodeRef = (0, $cozmU.useRef)(null);
    const contentListeners = (0, $cozmU.useRef)(new Map());
    const isOpenRef = (0, $cozmU.useRef)(isOpen);
    (0, $cozmU.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const openDelay = (0, $760322e9be90cd53$export$beb151954e0eb9fa)(()=>{
        if (isOpenRef.current) return;
        if (openedByRef) openedByRef.current = 'hover';
        onOpen();
    }, hoverOpen);
    const closeDelay = (0, $760322e9be90cd53$export$beb151954e0eb9fa)(()=>{
        if (!isOpenRef.current) return;
        if (!openedByRef || openedByRef.current === 'hover') onClose?.();
    }, hoverClose);
    const openDelayRef = (0, $cozmU.useRef)(openDelay);
    const closeDelayRef = (0, $cozmU.useRef)(closeDelay);
    openDelayRef.current = openDelay;
    closeDelayRef.current = closeDelay;
    const handleTriggerEnter = (0, $cozmU.useCallback)(()=>{
        closeDelayRef.current.clear();
        openDelayRef.current.schedule();
    }, []);
    const handleTriggerLeave = (0, $cozmU.useCallback)(()=>{
        openDelayRef.current.clear();
        closeDelayRef.current.schedule();
    }, []);
    const triggerRef = (0, $cozmU.useCallback)((element)=>{
        if (element === triggerNodeRef.current) return;
        triggerListeners.current.forEach((unbind)=>unbind());
        triggerListeners.current = [];
        triggerNodeRef.current = element;
        if (element && !isDisabled) triggerListeners.current.push((0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: handleTriggerEnter
        }), (0, $cbY7C.bind)(element, {
            type: 'mouseleave',
            listener: handleTriggerLeave
        }));
    }, [
        handleTriggerEnter,
        handleTriggerLeave,
        isDisabled
    ]);
    const handleContentEnter = (0, $cozmU.useCallback)(()=>{
        closeDelayRef.current.clear();
    }, []);
    const cleanupContentListeners = (0, $cozmU.useCallback)(()=>{
        contentListeners.current.forEach((unbind)=>unbind());
        contentListeners.current.clear();
    }, []);
    const attachContentListeners = (0, $cozmU.useCallback)((element)=>{
        if (contentListeners.current.has(element)) return;
        const handleMouseLeave = (event)=>{
            if (!(0, $3c9f1ae38e9f097e$export$63ce2e5e32c4f6a0)(event)) return;
            const relatedTarget = event.relatedTarget;
            if ((0, $3c9f1ae38e9f097e$export$386001e6036bddcf)(relatedTarget)) return;
            const childPortal = (0, $3c9f1ae38e9f097e$export$a5fb0bbf4bb0e26a)(relatedTarget, contentNodeRef.current);
            if (childPortal) {
                attachContentListeners(childPortal);
                return;
            }
            closeDelayRef.current.schedule();
        };
        const unbindEnter = (0, $cbY7C.bind)(element, {
            type: 'mouseenter',
            listener: handleContentEnter
        });
        const unbindLeave = (0, $cbY7C.bind)(element, {
            type: 'mouseleave',
            listener: handleMouseLeave
        });
        contentListeners.current.set(element, ()=>{
            unbindEnter();
            unbindLeave();
        });
    }, [
        handleContentEnter
    ]);
    const contentRef = (0, $cozmU.useCallback)((element)=>{
        if (element === contentNodeRef.current) return;
        cleanupContentListeners();
        contentNodeRef.current = element;
        if (element && !isDisabled) attachContentListeners(element);
    }, [
        attachContentListeners,
        cleanupContentListeners,
        isDisabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        const listeners = contentListeners.current;
        const triggers = triggerListeners.current;
        return ()=>{
            openDelayRef.current.clear();
            closeDelayRef.current.clear();
            triggers.forEach((unbind)=>unbind());
            listeners.forEach((unbind)=>unbind());
        };
    }, []);
    return {
        triggerRef: triggerRef,
        contentRef: contentRef
    };
}








const $b0fb6a2ef82e7619$var$PRELOAD_MAX_AGE = 300000;
const $b0fb6a2ef82e7619$var$TIME_TO_INTENT = 200;
function $b0fb6a2ef82e7619$export$e0cecaf2b8cc8d36({ load: load, onLoad: onLoad }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const { loadAndOpen: loadAndOpen, preloadReference: preloadReference, cancelPreload: cancelPreload } = (0, $cozmU.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (request.preloadIntentTimeout != null) {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (request.preloadMaxAgeTimeout != null) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const loadAndOpen = ()=>{
            clearPreloadTimeouts();
            onLoad(loadReference());
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $b0fb6a2ef82e7619$var$PRELOAD_MAX_AGE);
            }, $b0fb6a2ef82e7619$var$TIME_TO_INTENT);
        };
        return {
            loadAndOpen: loadAndOpen,
            preloadReference: preloadReference,
            cancelPreload: cancelPreload
        };
    }, [
        load,
        onLoad
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
            }
            nodeRef.current = element;
        }
    }, [
        preloadReference,
        cancelPreload,
        addEventListener,
        cleanUpEventListeners
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return Object.assign(refCallback, {
        loadAndOpen: loadAndOpen
    });
}








function $513818609bf2a6a1$export$186b93979375b734({ onOpen: onOpen, onClose: onClose, isOpen: isOpen = false, isDisabled: isDisabled = false, openedByRef: openedByRef }) {
    const nodeRef = (0, $cozmU.useRef)(null);
    const eventListeners = (0, $cozmU.useRef)([]);
    const handleOpen = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose?.();
        else {
            if (openedByRef) openedByRef.current = 'click';
            onOpen();
        }
    }, [
        isOpen,
        onClose,
        openedByRef,
        onOpen
    ]);
    const keydownListener = (0, $cozmU.useCallback)((event)=>{
        if (event instanceof KeyboardEvent && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleOpen();
        }
    }, [
        handleOpen
    ]);
    const cleanUpEventListeners = (0, $cozmU.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $cozmU.useCallback)((element, type, callback)=>{
        const unbind = (0, $cbY7C.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $cozmU.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) cleanUpEventListeners();
            if (element) {
                if (!isDisabled) addEventListener(element, 'click', handleOpen);
                // Always attach keydown for keyboard accessibility
                addEventListener(element, 'keydown', keydownListener);
            }
            nodeRef.current = element;
        }
    }, [
        handleOpen,
        keydownListener,
        addEventListener,
        cleanUpEventListeners,
        isDisabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}


const $bef3642319d63141$var$emptyEntryPointParams = {};
const $bef3642319d63141$var$emptyEntryPointProps = {};
const $bef3642319d63141$var$FallbackComponent = ({ fallback: fallback, onUnmount: onUnmount })=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>onUnmount();
    }, [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: fallback || /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {})
    });
};
function $bef3642319d63141$export$afca832e0d04586a({ trigger: trigger, triggerMode: triggerMode = 'click', entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onOpen: onOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const updateRef = (0, $cozmU.useRef)(null);
    const openedByRef = (0, $cozmU.useRef)(null);
    const isOpenRef = (0, $cozmU.useRef)(isOpen);
    const triggers = Array.isArray(triggerMode) ? triggerMode : [
        triggerMode
    ];
    (0, $cozmU.useLayoutEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    const handleOpen = (0, $cozmU.useCallback)((method)=>{
        setIsOpen(true);
        if (method) onOpen?.(method);
    }, [
        onOpen
    ]);
    const handleClose = (0, $cozmU.useCallback)((event, currentLevel)=>{
        setIsOpen(false);
        onClose?.(event ?? null, currentLevel);
    }, [
        onClose
    ]);
    const load = (0, $cozmU.useCallback)(()=>(0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $bef3642319d63141$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        if (isOpenRef.current) return;
        handleOpen(openedByRef.current);
        setContent(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)($bef3642319d63141$var$FallbackComponent, {
                fallback: fallback,
                onUnmount: ()=>updateRef.current?.()
            }),
            errorFallback: errorFallback,
            runtimeProps: {
                ...entryPointProps ?? $bef3642319d63141$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose
            },
            onError: onError,
            forcedError: forcedReportErrorUFO
        }));
    }, [
        setContent,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        handleOpen,
        onError,
        handleClose
    ]);
    const preloadRef = (0, $b0fb6a2ef82e7619$export$e0cecaf2b8cc8d36)({
        load: load,
        onLoad: onLoad
    });
    const pressableRef = (0, $513818609bf2a6a1$export$186b93979375b734)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('click'),
        openedByRef: openedByRef
    });
    const { triggerRef: hoverTriggerRef, contentRef: hoverContentRef } = (0, $e50e8414298f7d73$export$b8df9ab832b125ac)({
        onOpen: preloadRef.loadAndOpen,
        onClose: handleClose,
        isOpen: isOpen,
        isDisabled: !triggers.includes('hover'),
        openedByRef: openedByRef
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) openedByRef.current = null;
    }, [
        isOpen
    ]);
    const popupTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4nIKB.mergeRefs)([
            preloadRef,
            pressableRef,
            hoverTriggerRef,
            triggerProps.ref
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        preloadRef,
        pressableRef,
        hoverTriggerRef
    ]);
    const popupContent = (0, $cozmU.useCallback)(({ update: update })=>{
        updateRef.current = update;
        return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: hoverContentRef,
            role: "none",
            children: content
        });
    }, [
        content,
        hoverContentRef
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
        ...popupProps,
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
module.exports["PopupTriggerWithHover"] = $bef3642319d63141$export$afca832e0d04586a;

});

parcelRegister("5hJlu", function(module, exports) {

var $c4iAx = parcelRequire("c4iAx");

const $84d251becd713238$export$f84bd70098573c5c = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};



var $jH9cM = parcelRequire("jH9cM");


var $iDrrr = parcelRequire("iDrrr");


var $goaLH = parcelRequire("goaLH");

const $40a318d29c56f37f$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });



var $fTVW6 = parcelRequire("fTVW6");


var $2yfJH = parcelRequire("2yfJH");

const $1d036d6c862db9f3$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $2yfJH.DirectoryGraphQLErrors)(errors, traceId);
};



var $aoQrH = parcelRequire("aoQrH");

async function $2527d6ea6af61f00$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = (0, $aoQrH.id)) {
    return (0, $fTVW6.graphQLQuery)(serviceUrl, query, processHeaders, (0, $1d036d6c862db9f3$export$7642af465ceb7f05));
}



var $45IUg = parcelRequire("45IUg");

const $9944f613ca604c52$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $9944f613ca604c52$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $9944f613ca604c52$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $9944f613ca604c52$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $45IUg.AGGQuery)(url, query, $9944f613ca604c52$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}


const $d630f36426607e03$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $d630f36426607e03$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $d630f36426607e03$var$orgIdPromiseCache = new Map();
const $d630f36426607e03$var$workspaceExistsWithTypePromiseCache = new Map();
class $d630f36426607e03$var$TeamCentralCardClient extends (0, $goaLH.default) {
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $d630f36426607e03$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $d630f36426607e03$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
             * Reporting lines aren't part of the critical path of profile card.
             * Just resolve with empty values instead of bubbling up the error.
             */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
   * `public` so that mock client can override it; do not use it otherwise!
   */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = (0, $40a318d29c56f37f$export$1862ef0c3880ca8d)(userId);
        const response = await (0, $2527d6ea6af61f00$export$a5b5995619d4fe36)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $iDrrr.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $d630f36426607e03$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $d630f36426607e03$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $iDrrr.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $d630f36426607e03$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return workspaceType;
            }
            return undefined;
        } catch (err) {
            return undefined;
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $d630f36426607e03$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $9944f613ca604c52$export$d38a536fd806c68f)(gatewayGraphqlUrl, cloudId);
        $d630f36426607e03$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
    constructor(options){
        super(options);
        this.options = void 0;
        /**
     * Simple circuit breaker to avoid making unnecessary calls to Team Central on auth failures
     * This is to handle the case where products may have provided teamCentralUrl, but the site itself
     * doesn't actually have any TC product.
     *
     * There's currently no way to reset this circuit breaker, but that's fine. This is meant to
     * catch a pretty specific edge case.
     */ this.bypassOnFailure = void 0;
        this.orgContainsAnyWorkspacePromise = void 0;
        this.orgIdPromise = void 0;
        this.workspaceExistsWithTypePromise = void 0;
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
}
var $d630f36426607e03$export$2e2bcd8739ae039 = $d630f36426607e03$var$TeamCentralCardClient;


function $8ca8cf5ad5e69eb3$export$2dc0c655cef9a377(config, clients) {
    if ((0, $jH9cM.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $d630f36426607e03$export$2e2bcd8739ae039)({
        ...config
    }) : undefined;
}



var $cXtTj = parcelRequire("cXtTj");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $dRAjC = parcelRequire("dRAjC");





var $dSW04 = parcelRequire("dSW04");





var $knvOX = parcelRequire("knvOX");


var $lPEt0 = parcelRequire("lPEt0");

const $0e922c460acdfb54$var$SHARED_CACHE_SIZE = 50;
const $0e922c460acdfb54$export$815222107f6bee54 = 300000; // 5 minutes
const $0e922c460acdfb54$export$d0bf8b40238c05cd = new (0, $lPEt0.LRUMap)($0e922c460acdfb54$var$SHARED_CACHE_SIZE);


const $7eb6fbaa97f76140$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($id: ID!, $cloudId: String!) {
			agentStudio_agentByIdentityAccountId(cloudId: $cloudId, id: $id) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            id: identityAccountId.startsWith((0, $dRAjC.USER_ARI_PREFIX)) ? identityAccountId : `${0, $dRAjC.USER_ARI_PREFIX}${identityAccountId}`,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $7eb6fbaa97f76140$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    basePath() {
        return '/gateway/api/assist/rovo/v1/agents';
    }
    sharedCacheKey(idValue) {
        return `${this.options.cloudId ?? ''}:${idValue}`;
    }
    getCachedProfile(idValue) {
        const key = this.sharedCacheKey(idValue);
        const cached = (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).get(key);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).delete(key);
            return null;
        }
        return cached.profile;
    }
    setCachedProfile(idValue, profile) {
        (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).set(this.sharedCacheKey(idValue), {
            expire: Date.now() + (this.config.cacheMaxAge || (0, $0e922c460acdfb54$export$815222107f6bee54)),
            profile: profile
        });
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $45IUg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $45IUg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $45IUg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new (0, $dSW04.AgentForbiddenError)();
            return response.json();
        });
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) throw new (0, $dSW04.AgentForbiddenError)();
            return response.json();
        });
        const aggStartTime = (0, $1GhPJ.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $knvOX.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $1GhPJ.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                this.syncFavouriteToCache(agentId, isFavourite);
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    /**
   * Keeps the shared agent profile cache in sync with the favourite state
   */ syncFavouriteToCache(agentId, isFavourite) {
        const prefix = `${this.options.cloudId ?? ''}:`;
        const keysToUpdate = [];
        (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).forEach((cached, key)=>{
            if (key.startsWith(prefix) && cached.profile?.restData?.id === agentId) keysToUpdate.push(key);
        });
        keysToUpdate.forEach((key)=>{
            const cached = (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).get(key);
            if (!cached) return;
            const { restData: restData } = cached.profile;
            const wasFavourite = restData.favourite;
            const currentCount = restData.favourite_count ?? 0;
            const favouriteCount = isFavourite ? currentCount + (wasFavourite ? 0 : 1) : Math.max(0, currentCount - (wasFavourite ? 1 : 0));
            (0, $0e922c460acdfb54$export$d0bf8b40238c05cd).set(key, {
                ...cached,
                profile: {
                    ...cached.profile,
                    restData: {
                        ...restData,
                        favourite: isFavourite,
                        favourite_count: favouriteCount
                    }
                }
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}














/// <reference types="node" />
// for typing `process`



/// <reference types="node" />
// for typing `process`
const $7c185f5a3ad27ce0$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};


/// <reference types="node" />
// for typing `process`
// indented so it's
const $6f19988cf9eb5d4b$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
	  state
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $6f19988cf9eb5d4b$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$6f19988cf9eb5d4b$var$TEAM_FRAGMENT}
    }
  }
}`;


/// <reference types="node" />
// for typing `process`
const $8d852b1256bc6577$export$e33271562ca4c847 = 'ari:cloud:identity::team/';


/// <reference types="node" />
// for typing `process`
/**
 * @deprecated Use idToAriSafe instead
 */ const $161f161b931f6378$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};


const $9ae4ce007d40218e$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith((0, $8d852b1256bc6577$export$e33271562ca4c847)) ? teamIdOrTeamAri : (0, $161f161b931f6378$export$681597d03c8a0fd2)(teamIdOrTeamAri);


const $280b5cd7b6cff5d1$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: (0, $6f19988cf9eb5d4b$export$4968f4e0119a5d9c),
        variables: {
            teamId: (0, $9ae4ce007d40218e$export$7878e28c136af76)(teamId),
            siteId: siteId || 'None'
        }
    });


/// <reference types="node" />
// for typing `process`

var $l4RNd = parcelRequire("l4RNd");

const $a225870fac06e521$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: (0, $l4RNd.extractIdFromAri)(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};


async function $d2e7a2e50aa8e58a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = (0, $280b5cd7b6cff5d1$export$695d743d1401e038)({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $45IUg.AGGQuery)(url, query, (0, $7c185f5a3ad27ce0$export$1229c72526c01df2));
    return (0, $a225870fac06e521$export$fce1abb40bf8db94)(Team);
}


class $e69a6f3cdb85ec09$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $d2e7a2e50aa8e58a$export$26a8aad0c7182dd6)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.teamProfileCard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics('operational.teamProfileCard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.teamProfileCard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}



var $34knR = parcelRequire("34knR");

class $8cdb07af7cecff83$export$6f953fd54975f229 {
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $c4iAx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $c4iAx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
    constructor(config, clients){
        this.userClient = void 0;
        this.teamClient = void 0;
        this.tcClient = void 0;
        this.rovoAgentClient = void 0;
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...(0, $84d251becd713238$export$f84bd70098573c5c),
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? (0, $84d251becd713238$export$f84bd70098573c5c).gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $34knR.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $e69a6f3cdb85ec09$export$2e2bcd8739ae039)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $7eb6fbaa97f76140$export$2e2bcd8739ae039)(withDefaultConfig);
        this.tcClient = (0, $8ca8cf5ad5e69eb3$export$2dc0c655cef9a377)(withDefaultConfig, clients);
    }
}
var $8cdb07af7cecff83$export$2e2bcd8739ae039 = $8cdb07af7cecff83$export$6f953fd54975f229;
module.exports["ProfileClient"] = $8cdb07af7cecff83$export$6f953fd54975f229;
module.exports["default"] = $8cdb07af7cecff83$export$2e2bcd8739ae039;

});

parcelRegister("l4RNd", function(module, exports) {
/// <reference types="node" />
// for typing `process`
const $23aa4f1357cb1365$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
module.exports["extractIdFromAri"] = $23aa4f1357cb1365$export$5816a09dbb711691;

});

parcelRegister("34knR", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cSSWJ = parcelRequire("cSSWJ");

parcelRequire("8qyRg");
var $7B2o3 = parcelRequire("7B2o3");

const $1af8aabcedc8e224$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $7B2o3.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};



var $1GhPJ = parcelRequire("1GhPJ");


var $45IUg = parcelRequire("45IUg");


var $goaLH = parcelRequire("goaLH");


var $lBj2m = parcelRequire("lBj2m");


var $knvOX = parcelRequire("knvOX");


const $23d347c46c0bc977$var$buildScopedProfileAtlAttributionHeader = (cloudId)=>JSON.stringify({
        tenantId: `ari:cloud:townsquare::site/${cloudId}`,
        product: 'Atlassian Home',
        service: 'townsquare-frontend'
    });
const $23d347c46c0bc977$var$queryAGGUser = async (url, userId, cloudId)=>{
    const query = (0, $lBj2m.buildAggUserQuery)(userId);
    const { user: user } = await (0, $45IUg.AGGQuery)(url, query, cloudId ? (headers)=>{
        // Temporary atl-attribution for scoped profiles until AGG attribution is handled upstream.
        headers.append('atl-attribution', $23d347c46c0bc977$var$buildScopedProfileAtlAttributionHeader(cloudId));
        return headers;
    } : undefined);
    return user;
};
class $23d347c46c0bc977$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $23d347c46c0bc977$var$queryAGGUser(urlWithOperationName, userId, cloudId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = 'h:mmaaa';
        if (user.zoneinfo) {
            if ((0, $1af8aabcedc8e224$export$f0dfd716e7b023cd)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $1af8aabcedc8e224$export$f0dfd716e7b023cd)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $1af8aabcedc8e224$export$f0dfd716e7b023cd)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.profilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics('operational.profilecard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.profilecard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $knvOX.getErrorAttributes)(error),
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["default"] = $23d347c46c0bc977$export$2e2bcd8739ae039;

});

parcelRegister("8qyRg", function(module, exports) {
$parcel$export(module.exports, "format", () => (parcelRequire("dRT1d")).default);
$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("7B2o3")).default);
$parcel$export(module.exports, "getTimezoneOffset", () => (parcelRequire("9q5hY")).default);
$parcel$export(module.exports, "toDate", () => (parcelRequire("cx14W")).default);
$parcel$export(module.exports, "utcToZonedTime", () => (parcelRequire("5K52A")).default);
$parcel$export(module.exports, "zonedTimeToUtc", () => (parcelRequire("1t17e")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $dRT1d = parcelRequire("dRT1d");


var $7B2o3 = parcelRequire("7B2o3");


var $9q5hY = parcelRequire("9q5hY");


var $cx14W = parcelRequire("cx14W");


var $5K52A = parcelRequire("5K52A");


var $1t17e = parcelRequire("1t17e");


});

parcelRegister("4hHJG", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $31eaad00469a0528$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $31eaad00469a0528$var$format;

var $31eaad00469a0528$var$_index = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("bMOda")));

var $31eaad00469a0528$var$_index2 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("30qsY")));

var $31eaad00469a0528$var$_index3 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $31eaad00469a0528$var$_index4 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("gHpPW")));

var $31eaad00469a0528$var$_index5 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("1D3qA")));

var $31eaad00469a0528$var$_index6 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("7EvI6")));

var $hjGNX = parcelRequire("hjGNX");


var $31eaad00469a0528$var$_index8 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("55p4v")));

var $31eaad00469a0528$var$_index9 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $9xLsj = parcelRequire("9xLsj");


var $31eaad00469a0528$var$_index11 = $31eaad00469a0528$require$_interopRequireDefault((parcelRequire("3zI7l")));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $31eaad00469a0528$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $31eaad00469a0528$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $31eaad00469a0528$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $31eaad00469a0528$var$doubleQuoteRegExp = /''/g;
var $31eaad00469a0528$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $31eaad00469a0528$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $31eaad00469a0528$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9xLsj.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $31eaad00469a0528$var$_index11.default;
    var firstWeekContainsDate = (0, $31eaad00469a0528$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $31eaad00469a0528$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $31eaad00469a0528$var$_index3.default)(dirtyDate);
    if (!(0, $31eaad00469a0528$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $31eaad00469a0528$var$_index6.default)(originalDate);
    var utcDate = (0, $31eaad00469a0528$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($31eaad00469a0528$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $31eaad00469a0528$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($31eaad00469a0528$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $31eaad00469a0528$var$cleanEscapedString(substring);
        var formatter = $31eaad00469a0528$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $hjGNX.isProtectedWeekYearToken)(substring)) (0, $hjGNX.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $hjGNX.isProtectedDayOfYearToken)(substring)) (0, $hjGNX.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($31eaad00469a0528$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $31eaad00469a0528$var$cleanEscapedString(input) {
    var matched = input.match($31eaad00469a0528$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($31eaad00469a0528$var$doubleQuoteRegExp, "'");
}
module.exports = module.exports.default;

});

parcelRegister("bMOda", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $894b205001af8b4f$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $894b205001af8b4f$var$isValid;

var $894b205001af8b4f$var$_index = $894b205001af8b4f$require$_interopRequireDefault((parcelRequire("9YQys")));

var $894b205001af8b4f$var$_index2 = $894b205001af8b4f$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $894b205001af8b4f$var$_index3 = $894b205001af8b4f$require$_interopRequireDefault((parcelRequire("25Eoi")));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $894b205001af8b4f$var$isValid(dirtyDate) {
    (0, $894b205001af8b4f$var$_index3.default)(1, arguments);
    if (!(0, $894b205001af8b4f$var$_index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $894b205001af8b4f$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});

parcelRegister("9YQys", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $01e00a41c89cf2cf$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01e00a41c89cf2cf$var$isDate;

var $01e00a41c89cf2cf$var$_typeof2 = $01e00a41c89cf2cf$require$_interopRequireDefault((parcelRequire("cdkbZ")));

var $01e00a41c89cf2cf$var$_index = $01e00a41c89cf2cf$require$_interopRequireDefault((parcelRequire("25Eoi")));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $01e00a41c89cf2cf$var$isDate(value) {
    (0, $01e00a41c89cf2cf$var$_index.default)(1, arguments);
    return value instanceof Date || (0, $01e00a41c89cf2cf$var$_typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = module.exports.default;

});

parcelRegister("25Eoi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $185b61298442cc4c$var$requiredArgs;
function $185b61298442cc4c$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});

parcelRegister("1P5eg", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $153e9c3d9319407a$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $153e9c3d9319407a$var$toDate;

var $153e9c3d9319407a$var$_typeof2 = $153e9c3d9319407a$require$_interopRequireDefault((parcelRequire("cdkbZ")));

var $153e9c3d9319407a$var$_index = $153e9c3d9319407a$require$_interopRequireDefault((parcelRequire("25Eoi")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $153e9c3d9319407a$var$toDate(argument) {
    (0, $153e9c3d9319407a$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $153e9c3d9319407a$var$_typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});

parcelRegister("30qsY", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $2305e6d29780829d$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2305e6d29780829d$var$subMilliseconds;

var $2305e6d29780829d$var$_index = $2305e6d29780829d$require$_interopRequireDefault((parcelRequire("engq8")));

var $2305e6d29780829d$var$_index2 = $2305e6d29780829d$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $2305e6d29780829d$var$_index3 = $2305e6d29780829d$require$_interopRequireDefault((parcelRequire("55p4v")));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $2305e6d29780829d$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $2305e6d29780829d$var$_index2.default)(2, arguments);
    var amount = (0, $2305e6d29780829d$var$_index3.default)(dirtyAmount);
    return (0, $2305e6d29780829d$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});

parcelRegister("engq8", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $a76ff378ec6a9e95$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a76ff378ec6a9e95$var$addMilliseconds;

var $a76ff378ec6a9e95$var$_index = $a76ff378ec6a9e95$require$_interopRequireDefault((parcelRequire("55p4v")));

var $a76ff378ec6a9e95$var$_index2 = $a76ff378ec6a9e95$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $a76ff378ec6a9e95$var$_index3 = $a76ff378ec6a9e95$require$_interopRequireDefault((parcelRequire("25Eoi")));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $a76ff378ec6a9e95$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $a76ff378ec6a9e95$var$_index3.default)(2, arguments);
    var timestamp = (0, $a76ff378ec6a9e95$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $a76ff378ec6a9e95$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});

parcelRegister("55p4v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b40de14dc29d69c$var$toInteger;
function $3b40de14dc29d69c$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});

parcelRegister("gHpPW", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $c284b427e159ae6b$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c284b427e159ae6b$var$_index = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("9SrCW")));

var $c284b427e159ae6b$var$_index2 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("1kRHR")));

var $c284b427e159ae6b$var$_index3 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("lkETc")));

var $c284b427e159ae6b$var$_index4 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("bWx66")));

var $c284b427e159ae6b$var$_index5 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("7RMxt")));

var $c284b427e159ae6b$var$_index6 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("izi2T")));

var $c284b427e159ae6b$var$_index7 = $c284b427e159ae6b$require$_interopRequireDefault((parcelRequire("f92qG")));
var $c284b427e159ae6b$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $c284b427e159ae6b$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $c284b427e159ae6b$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $c284b427e159ae6b$var$_index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $c284b427e159ae6b$var$_index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $c284b427e159ae6b$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $c284b427e159ae6b$var$_index3.default)(date);
        // Padding
        return (0, $c284b427e159ae6b$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $c284b427e159ae6b$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $c284b427e159ae6b$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $c284b427e159ae6b$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $c284b427e159ae6b$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $c284b427e159ae6b$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c284b427e159ae6b$var$_index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $c284b427e159ae6b$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $c284b427e159ae6b$var$_index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $c284b427e159ae6b$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $c284b427e159ae6b$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $c284b427e159ae6b$var$_index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $c284b427e159ae6b$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $c284b427e159ae6b$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $c284b427e159ae6b$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $c284b427e159ae6b$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $c284b427e159ae6b$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $c284b427e159ae6b$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $c284b427e159ae6b$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $c284b427e159ae6b$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $c284b427e159ae6b$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $c284b427e159ae6b$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $c284b427e159ae6b$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $c284b427e159ae6b$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $c284b427e159ae6b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $c284b427e159ae6b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $c284b427e159ae6b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $c284b427e159ae6b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $c284b427e159ae6b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $c284b427e159ae6b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $c284b427e159ae6b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $c284b427e159ae6b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $c284b427e159ae6b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $c284b427e159ae6b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $c284b427e159ae6b$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $c284b427e159ae6b$var$_index6.default)(timestamp, token.length);
    }
};
function $c284b427e159ae6b$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $c284b427e159ae6b$var$_index6.default)(minutes, 2);
}
function $c284b427e159ae6b$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $c284b427e159ae6b$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $c284b427e159ae6b$var$formatTimezone(offset, dirtyDelimiter);
}
function $c284b427e159ae6b$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $c284b427e159ae6b$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $c284b427e159ae6b$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $c284b427e159ae6b$var$_default = $c284b427e159ae6b$var$formatters;
module.exports.default = $c284b427e159ae6b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("9SrCW", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $730e965a22b5e9f7$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $730e965a22b5e9f7$var$getUTCDayOfYear;

var $730e965a22b5e9f7$var$_index = $730e965a22b5e9f7$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $730e965a22b5e9f7$var$_index2 = $730e965a22b5e9f7$require$_interopRequireDefault((parcelRequire("25Eoi")));
var $730e965a22b5e9f7$var$MILLISECONDS_IN_DAY = 86400000;
function $730e965a22b5e9f7$var$getUTCDayOfYear(dirtyDate) {
    (0, $730e965a22b5e9f7$var$_index2.default)(1, arguments);
    var date = (0, $730e965a22b5e9f7$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $730e965a22b5e9f7$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("1kRHR", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $0f9151abb3bbb8c7$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f9151abb3bbb8c7$var$getUTCISOWeek;

var $0f9151abb3bbb8c7$var$_index = $0f9151abb3bbb8c7$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $0f9151abb3bbb8c7$var$_index2 = $0f9151abb3bbb8c7$require$_interopRequireDefault((parcelRequire("gFH63")));

var $0f9151abb3bbb8c7$var$_index3 = $0f9151abb3bbb8c7$require$_interopRequireDefault((parcelRequire("dsuJS")));

var $0f9151abb3bbb8c7$var$_index4 = $0f9151abb3bbb8c7$require$_interopRequireDefault((parcelRequire("25Eoi")));
var $0f9151abb3bbb8c7$var$MILLISECONDS_IN_WEEK = 604800000;
function $0f9151abb3bbb8c7$var$getUTCISOWeek(dirtyDate) {
    (0, $0f9151abb3bbb8c7$var$_index4.default)(1, arguments);
    var date = (0, $0f9151abb3bbb8c7$var$_index.default)(dirtyDate);
    var diff = (0, $0f9151abb3bbb8c7$var$_index2.default)(date).getTime() - (0, $0f9151abb3bbb8c7$var$_index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0f9151abb3bbb8c7$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("gFH63", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $c231e7ca9145bef4$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c231e7ca9145bef4$var$startOfUTCISOWeek;

var $c231e7ca9145bef4$var$_index = $c231e7ca9145bef4$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $c231e7ca9145bef4$var$_index2 = $c231e7ca9145bef4$require$_interopRequireDefault((parcelRequire("25Eoi")));
function $c231e7ca9145bef4$var$startOfUTCISOWeek(dirtyDate) {
    (0, $c231e7ca9145bef4$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $c231e7ca9145bef4$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("dsuJS", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $9cc5bc037f347536$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9cc5bc037f347536$var$startOfUTCISOWeekYear;

var $9cc5bc037f347536$var$_index = $9cc5bc037f347536$require$_interopRequireDefault((parcelRequire("lkETc")));

var $9cc5bc037f347536$var$_index2 = $9cc5bc037f347536$require$_interopRequireDefault((parcelRequire("gFH63")));

var $9cc5bc037f347536$var$_index3 = $9cc5bc037f347536$require$_interopRequireDefault((parcelRequire("25Eoi")));
function $9cc5bc037f347536$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $9cc5bc037f347536$var$_index3.default)(1, arguments);
    var year = (0, $9cc5bc037f347536$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $9cc5bc037f347536$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("lkETc", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $f87b2efa729f6239$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f87b2efa729f6239$var$getUTCISOWeekYear;

var $f87b2efa729f6239$var$_index = $f87b2efa729f6239$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $f87b2efa729f6239$var$_index2 = $f87b2efa729f6239$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $f87b2efa729f6239$var$_index3 = $f87b2efa729f6239$require$_interopRequireDefault((parcelRequire("gFH63")));
function $f87b2efa729f6239$var$getUTCISOWeekYear(dirtyDate) {
    (0, $f87b2efa729f6239$var$_index2.default)(1, arguments);
    var date = (0, $f87b2efa729f6239$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f87b2efa729f6239$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f87b2efa729f6239$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});

parcelRegister("bWx66", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $8b1ec8f09812024d$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b1ec8f09812024d$var$getUTCWeek;

var $8b1ec8f09812024d$var$_index = $8b1ec8f09812024d$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $8b1ec8f09812024d$var$_index2 = $8b1ec8f09812024d$require$_interopRequireDefault((parcelRequire("413za")));

var $8b1ec8f09812024d$var$_index3 = $8b1ec8f09812024d$require$_interopRequireDefault((parcelRequire("9bKPd")));

var $8b1ec8f09812024d$var$_index4 = $8b1ec8f09812024d$require$_interopRequireDefault((parcelRequire("25Eoi")));
var $8b1ec8f09812024d$var$MILLISECONDS_IN_WEEK = 604800000;
function $8b1ec8f09812024d$var$getUTCWeek(dirtyDate, options) {
    (0, $8b1ec8f09812024d$var$_index4.default)(1, arguments);
    var date = (0, $8b1ec8f09812024d$var$_index.default)(dirtyDate);
    var diff = (0, $8b1ec8f09812024d$var$_index2.default)(date, options).getTime() - (0, $8b1ec8f09812024d$var$_index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8b1ec8f09812024d$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("413za", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $2eca059652951ba8$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2eca059652951ba8$var$startOfUTCWeek;

var $2eca059652951ba8$var$_index = $2eca059652951ba8$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $2eca059652951ba8$var$_index2 = $2eca059652951ba8$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $2eca059652951ba8$var$_index3 = $2eca059652951ba8$require$_interopRequireDefault((parcelRequire("55p4v")));

var $9xLsj = parcelRequire("9xLsj");

function $2eca059652951ba8$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $2eca059652951ba8$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $9xLsj.getDefaultOptions)();
    var weekStartsOn = (0, $2eca059652951ba8$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $2eca059652951ba8$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("9bKPd", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $6b09769f223fbbae$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b09769f223fbbae$var$startOfUTCWeekYear;

var $6b09769f223fbbae$var$_index = $6b09769f223fbbae$require$_interopRequireDefault((parcelRequire("7RMxt")));

var $6b09769f223fbbae$var$_index2 = $6b09769f223fbbae$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $6b09769f223fbbae$var$_index3 = $6b09769f223fbbae$require$_interopRequireDefault((parcelRequire("413za")));

var $6b09769f223fbbae$var$_index4 = $6b09769f223fbbae$require$_interopRequireDefault((parcelRequire("55p4v")));

var $9xLsj = parcelRequire("9xLsj");

function $6b09769f223fbbae$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6b09769f223fbbae$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $9xLsj.getDefaultOptions)();
    var firstWeekContainsDate = (0, $6b09769f223fbbae$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $6b09769f223fbbae$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $6b09769f223fbbae$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("7RMxt", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $5ba32273e7f0c874$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5ba32273e7f0c874$var$getUTCWeekYear;

var $5ba32273e7f0c874$var$_index = $5ba32273e7f0c874$require$_interopRequireDefault((parcelRequire("1P5eg")));

var $5ba32273e7f0c874$var$_index2 = $5ba32273e7f0c874$require$_interopRequireDefault((parcelRequire("25Eoi")));

var $5ba32273e7f0c874$var$_index3 = $5ba32273e7f0c874$require$_interopRequireDefault((parcelRequire("413za")));

var $5ba32273e7f0c874$var$_index4 = $5ba32273e7f0c874$require$_interopRequireDefault((parcelRequire("55p4v")));

var $9xLsj = parcelRequire("9xLsj");

function $5ba32273e7f0c874$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $5ba32273e7f0c874$var$_index2.default)(1, arguments);
    var date = (0, $5ba32273e7f0c874$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9xLsj.getDefaultOptions)();
    var firstWeekContainsDate = (0, $5ba32273e7f0c874$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5ba32273e7f0c874$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5ba32273e7f0c874$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});

parcelRegister("izi2T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8497e5b5d1cf6c3$var$addLeadingZeros;
function $d8497e5b5d1cf6c3$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("f92qG", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $b06994b630d7feb7$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b06994b630d7feb7$var$_index = $b06994b630d7feb7$require$_interopRequireDefault((parcelRequire("izi2T")));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $b06994b630d7feb7$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $b06994b630d7feb7$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $b06994b630d7feb7$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $b06994b630d7feb7$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $b06994b630d7feb7$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $b06994b630d7feb7$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $b06994b630d7feb7$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $b06994b630d7feb7$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $b06994b630d7feb7$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $b06994b630d7feb7$var$_default = $b06994b630d7feb7$var$formatters;
module.exports.default = $b06994b630d7feb7$var$_default;
module.exports = module.exports.default;

});

parcelRegister("1D3qA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $12fc17a3c7f3297b$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $12fc17a3c7f3297b$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $12fc17a3c7f3297b$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $12fc17a3c7f3297b$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $12fc17a3c7f3297b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $12fc17a3c7f3297b$var$timeLongFormatter(timePattern, formatLong));
};
var $12fc17a3c7f3297b$var$longFormatters = {
    p: $12fc17a3c7f3297b$var$timeLongFormatter,
    P: $12fc17a3c7f3297b$var$dateTimeLongFormatter
};
var $12fc17a3c7f3297b$var$_default = $12fc17a3c7f3297b$var$longFormatters;
module.exports.default = $12fc17a3c7f3297b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("7EvI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5924dddc041b3d5c$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $5924dddc041b3d5c$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("3zI7l", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $29a6dcc5035edb99$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29a6dcc5035edb99$var$_index = $29a6dcc5035edb99$require$_interopRequireDefault((parcelRequire("ggEXl")));
var $29a6dcc5035edb99$var$_default = $29a6dcc5035edb99$var$_index.default;
module.exports.default = $29a6dcc5035edb99$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ggEXl", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $bd7de90541fb8a96$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd7de90541fb8a96$var$_index = $bd7de90541fb8a96$require$_interopRequireDefault((parcelRequire("ejI6g")));

var $bd7de90541fb8a96$var$_index2 = $bd7de90541fb8a96$require$_interopRequireDefault((parcelRequire("b8WAx")));

var $bd7de90541fb8a96$var$_index3 = $bd7de90541fb8a96$require$_interopRequireDefault((parcelRequire("34Ut1")));

var $bd7de90541fb8a96$var$_index4 = $bd7de90541fb8a96$require$_interopRequireDefault((parcelRequire("aqGt7")));

var $bd7de90541fb8a96$var$_index5 = $bd7de90541fb8a96$require$_interopRequireDefault((parcelRequire("gkLPN")));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $bd7de90541fb8a96$var$locale = {
    code: 'en-US',
    formatDistance: $bd7de90541fb8a96$var$_index.default,
    formatLong: $bd7de90541fb8a96$var$_index2.default,
    formatRelative: $bd7de90541fb8a96$var$_index3.default,
    localize: $bd7de90541fb8a96$var$_index4.default,
    match: $bd7de90541fb8a96$var$_index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bd7de90541fb8a96$var$_default = $bd7de90541fb8a96$var$locale;
module.exports.default = $bd7de90541fb8a96$var$_default;
module.exports = module.exports.default;

});

parcelRegister("ejI6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a6c50c6480befc3e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $a6c50c6480befc3e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a6c50c6480befc3e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $a6c50c6480befc3e$var$_default = $a6c50c6480befc3e$var$formatDistance;
module.exports.default = $a6c50c6480befc3e$var$_default;
module.exports = module.exports.default;

});

parcelRegister("b8WAx", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $81cde37d85b329d7$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81cde37d85b329d7$var$_index = $81cde37d85b329d7$require$_interopRequireDefault((parcelRequire("3Ias2")));
var $81cde37d85b329d7$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $81cde37d85b329d7$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $81cde37d85b329d7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $81cde37d85b329d7$var$formatLong = {
    date: (0, $81cde37d85b329d7$var$_index.default)({
        formats: $81cde37d85b329d7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $81cde37d85b329d7$var$_index.default)({
        formats: $81cde37d85b329d7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $81cde37d85b329d7$var$_index.default)({
        formats: $81cde37d85b329d7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $81cde37d85b329d7$var$_default = $81cde37d85b329d7$var$formatLong;
module.exports.default = $81cde37d85b329d7$var$_default;
module.exports = module.exports.default;

});

parcelRegister("3Ias2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b3d968958831c0a$var$buildFormatLongFn;
function $2b3d968958831c0a$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});

parcelRegister("34Ut1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $23dd8bfc71a2aad6$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $23dd8bfc71a2aad6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $23dd8bfc71a2aad6$var$formatRelativeLocale[token];
};
var $23dd8bfc71a2aad6$var$_default = $23dd8bfc71a2aad6$var$formatRelative;
module.exports.default = $23dd8bfc71a2aad6$var$_default;
module.exports = module.exports.default;

});

parcelRegister("aqGt7", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $797d467eb8e8182d$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $797d467eb8e8182d$var$_index = $797d467eb8e8182d$require$_interopRequireDefault((parcelRequire("bbdk3")));
var $797d467eb8e8182d$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $797d467eb8e8182d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $797d467eb8e8182d$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $797d467eb8e8182d$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $797d467eb8e8182d$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $797d467eb8e8182d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $797d467eb8e8182d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $797d467eb8e8182d$var$localize = {
    ordinalNumber: $797d467eb8e8182d$var$ordinalNumber,
    era: (0, $797d467eb8e8182d$var$_index.default)({
        values: $797d467eb8e8182d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $797d467eb8e8182d$var$_index.default)({
        values: $797d467eb8e8182d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $797d467eb8e8182d$var$_index.default)({
        values: $797d467eb8e8182d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $797d467eb8e8182d$var$_index.default)({
        values: $797d467eb8e8182d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $797d467eb8e8182d$var$_index.default)({
        values: $797d467eb8e8182d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $797d467eb8e8182d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $797d467eb8e8182d$var$_default = $797d467eb8e8182d$var$localize;
module.exports.default = $797d467eb8e8182d$var$_default;
module.exports = module.exports.default;

});

parcelRegister("bbdk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $823b0e60149a327f$var$buildLocalizeFn;
function $823b0e60149a327f$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});

parcelRegister("gkLPN", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $be439e8a9cc00378$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be439e8a9cc00378$var$_index = $be439e8a9cc00378$require$_interopRequireDefault((parcelRequire("kRMM7")));

var $be439e8a9cc00378$var$_index2 = $be439e8a9cc00378$require$_interopRequireDefault((parcelRequire("81HD9")));
var $be439e8a9cc00378$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $be439e8a9cc00378$var$parseOrdinalNumberPattern = /\d+/i;
var $be439e8a9cc00378$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $be439e8a9cc00378$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $be439e8a9cc00378$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $be439e8a9cc00378$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $be439e8a9cc00378$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $be439e8a9cc00378$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $be439e8a9cc00378$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $be439e8a9cc00378$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $be439e8a9cc00378$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $be439e8a9cc00378$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $be439e8a9cc00378$var$match = {
    ordinalNumber: (0, $be439e8a9cc00378$var$_index2.default)({
        matchPattern: $be439e8a9cc00378$var$matchOrdinalNumberPattern,
        parsePattern: $be439e8a9cc00378$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $be439e8a9cc00378$var$_index.default)({
        matchPatterns: $be439e8a9cc00378$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $be439e8a9cc00378$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $be439e8a9cc00378$var$_index.default)({
        matchPatterns: $be439e8a9cc00378$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $be439e8a9cc00378$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $be439e8a9cc00378$var$_index.default)({
        matchPatterns: $be439e8a9cc00378$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $be439e8a9cc00378$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $be439e8a9cc00378$var$_index.default)({
        matchPatterns: $be439e8a9cc00378$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $be439e8a9cc00378$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $be439e8a9cc00378$var$_index.default)({
        matchPatterns: $be439e8a9cc00378$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $be439e8a9cc00378$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $be439e8a9cc00378$var$_default = $be439e8a9cc00378$var$match;
module.exports.default = $be439e8a9cc00378$var$_default;
module.exports = module.exports.default;

});

parcelRegister("kRMM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f30e979812f62f59$var$buildMatchFn;
function $f30e979812f62f59$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f30e979812f62f59$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f30e979812f62f59$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f30e979812f62f59$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f30e979812f62f59$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("81HD9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d8042d92b920e8e$var$buildMatchPatternFn;
function $5d8042d92b920e8e$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});

parcelRegister("7B2o3", function(module, exports) {
$parcel$export(module.exports, "default", () => $587dd71ddc99276f$export$2e2bcd8739ae039);

var $jNWGj = parcelRequire("jNWGj");


var $dRT1d = parcelRequire("dRT1d");


var $5K52A = parcelRequire("5K52A");

function $587dd71ddc99276f$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jNWGj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $dRT1d.default)((0, $5K52A.default)(date, timeZone), formatStr, extendedOptions);
}

});

parcelRegister("jNWGj", function(module, exports) {
"use strict";

var $5r8BJ = parcelRequire("5r8BJ");

var $e6b01cd10efecc58$require$_interopRequireDefault = $5r8BJ.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6b01cd10efecc58$var$cloneObject;

var $e6b01cd10efecc58$var$_index = $e6b01cd10efecc58$require$_interopRequireDefault((parcelRequire("7Xpmg")));
function $e6b01cd10efecc58$var$cloneObject(object) {
    return (0, $e6b01cd10efecc58$var$_index.default)({}, object);
}
module.exports = module.exports.default;

});

parcelRegister("7Xpmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5cb1b6b130e4e1d3$var$assign;
function $5cb1b6b130e4e1d3$var$assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("buHp0", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $6ca334a381038421$export$f182130953438e47 = ({ tags: tags, destinationApp: destinationApp, createAnalyticsEvent: createAnalyticsEvent, analyticsEventFireName: analyticsEventFireName, bridge: bridge, source: source, actionSubjectId: actionSubjectId })=>{
    const consolidatedCrossAppExperience = (0, $iDrrr.fg)('platform-consolidated-cross-app-mau-experience');
    if (consolidatedCrossAppExperience) {
        const analyticsEvent = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'customCrossAppExperience',
            eventType: 'ui',
            tags: [
                'navigationExperiences'
            ],
            attributes: {
                bridge: bridge,
                source: source,
                destinationApp: destinationApp
            }
        });
        // consolidate under one singular product. Had tried navigationExperiences but events weren't firing, hence, navigation
        analyticsEvent.fire('navigation');
        return;
    }
    const analyticsEvent = createAnalyticsEvent({
        action: 'customCrossAppExperience',
        actionSubject: 'viewed',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        tags: tags,
        attributes: {
            bridge: bridge,
            source: source,
            destinationApp: destinationApp
        }
    });
    analyticsEvent.fire(analyticsEventFireName);
};
module.exports["fireCustomCrossAppAnalytic"] = $6ca334a381038421$export$f182130953438e47;

});

parcelRegister("3jT9F", function(module, exports) {

var $9JsfF = parcelRequire("9JsfF");


var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


var $3P7Ao = parcelRequire("3P7Ao");

function $13071ff81ef7f67c$var$resolveQueryVariables(params) {
    if ('identityAccountId' in params) {
        const identityAccountId = params.identityAccountId.startsWith('ari:cloud:identity::user/') ? params.identityAccountId : `ari:cloud:identity::user/${params.identityAccountId}`;
        return {
            agentAri: '',
            identityAccountId: identityAccountId,
            cloudId: params.cloudId,
            fetchByIdentity: true
        };
    }
    const agentAri = 'agentAri' in params ? params.agentAri : (0, $9JsfF.RovoAgentAri).create({
        activationId: params.activationId,
        agentId: params.agentId
    }).toString();
    return {
        agentAri: agentAri,
        identityAccountId: '',
        cloudId: '',
        fetchByIdentity: false
    };
}

const $13071ff81ef7f67c$export$cf39f5e5e131a6dd = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7RYzl")), {
        moduleId: "dc6e5a58",
        moduleName: "AgentProfileCardContainer",
        priority: "interaction",
        moduleId: 'conversation-assistant-agent_agent-profile-card'
    }),
    getPreloadProps: (params)=>{
        const queryVariables = $13071ff81ef7f67c$var$resolveQueryVariables(params);
        return {
            queries: {
                agentProfileCardQuery: {
                    parameters: (0, $3P7Ao.default),
                    variables: queryVariables,
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        };
    }
});
module.exports["agentProfileCardEntryPoint"] = $13071ff81ef7f67c$export$cf39f5e5e131a6dd;

});

parcelRegister("3P7Ao", function(module, exports) {
/**
 * @generated SignedSource<<44c292346f22c43228b71daa22e1bc4d>>
 * @relayHash 89c3db6f08f38ab8e7c0f8ff0efa27d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da
const $cfa90136d687f07f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "agentAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchByIdentity"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "identityAccountId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "agentAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "AgentProfileCard_agentRef"
                            }
                        ],
                        "type": "AgentStudioAssistant"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "AgentProfileCard_agentRef"
                }
            ],
            "type": "AgentStudioAssistant"
        }
    ], v9 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "identityAccountId"
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "description"
                },
                {
                    "kind": "ScalarField",
                    "name": "icon"
                },
                {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                },
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                },
                {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorType"
                },
                {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                },
                {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accountStatus"
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "profileUrl"
                        },
                        v6 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "AgentStudioAgentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canDelete"
                        }
                    ]
                }
            ],
            "type": "AgentStudioAssistant"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                v6 /*: any*/ 
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AgentProfileCardContainerQuery",
            "selections": [
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentById",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "fetchByIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "agentStudio_agentByIdentityAccountId",
                            "plural": false,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "be6d5d4905180f46e0aa18144e23657fa272f344fb4b17eedbf817cd2879e5da",
            "metadata": {},
            "name": "AgentProfileCardContainerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cfa90136d687f07f$var$node.hash = "7f56b7d6645b9220c953a6792948a3ba";
var $cfa90136d687f07f$export$2e2bcd8739ae039 = $cfa90136d687f07f$var$node;
module.exports["default"] = $cfa90136d687f07f$export$2e2bcd8739ae039;

});

parcelRegister("7RYzl", function(module, exports) {

let $5bac776c025a284b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5bac776c025a284b$var$load("4ROh6"),
    $5bac776c025a284b$var$load("3R4oU"),
    $5bac776c025a284b$var$load("cuMia"),
    $5bac776c025a284b$var$load("6wr18"),
    $5bac776c025a284b$var$load("1cQg7"),
    $5bac776c025a284b$var$load("VXbA1"),
    $5bac776c025a284b$var$load("fe1dp"),
    $5bac776c025a284b$var$load("h4UiS"),
    $5bac776c025a284b$var$load("7EorR"),
    $5bac776c025a284b$var$load("jqoep"),
    $5bac776c025a284b$var$load("ffEVr"),
    $5bac776c025a284b$var$load("hhss7"),
    $5bac776c025a284b$var$load("8jBNC")
]).then(()=>parcelRequire('kzpDl'));

});

parcelRegister("fWkhK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");

const $fd925b40062fea78$var$styles = {
    cardDefiniteWidth: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _39xV029zBZ _0KLXruoI2d",
    body: "_0Of8r2Va5s _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW5zaO"
};
const $fd925b40062fea78$export$406245d651cacfa7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "96px",
            borderRadius: 0
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $fd925b40062fea78$var$styles.body,
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "160px",
            height: "20px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "120px",
            height: "16px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "48px"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "100%",
            height: "32px"
        })));
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd925b40062fea78$var$styles.cardDefiniteWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "96px",
        borderRadius: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fd925b40062fea78$var$styles.body,
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "160px",
        height: "20px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "120px",
        height: "16px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "48px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "32px"
    })));
};
module.exports["AgentProfileCardSkeleton"] = $fd925b40062fea78$export$406245d651cacfa7;

});

parcelRegister("dyU9d", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $7PdwS = parcelRequire("7PdwS");


var $bB0i2 = parcelRequire("bB0i2");


var $bR8ZK = parcelRequire("bR8ZK");


var $iDrrr = parcelRequire("iDrrr");


var $bJzbV = parcelRequire("bJzbV");


var $5P7QE = parcelRequire("5P7QE");


var $3VgML = parcelRequire("3VgML");


var $dTp7m = parcelRequire("dTp7m");


var $HK9KM = parcelRequire("HK9KM");

// Enable Relay Resolvers globally for this module
(0, $eqEJl.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $aea8d0ec47f38c12$var$createNetwork(networkOptions) {
    return (0, $eqEJl.Network).create((request, variables, cacheConfig)=>(0, $5P7QE.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $HK9KM.createSubscribeFn)(networkOptions) : undefined);
}
/**
 * Brand attached to every environment produced by {@link createRelayEnvironment}.
 *
 * We use `Symbol.for` (the global symbol registry) rather than a module-local `Symbol()` so the
 * brand stays stable even if this module ends up duplicated across bundles/realms — the guard in a
 * consumer will still recognise an environment created by another copy of this package.
 */ const $aea8d0ec47f38c12$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND = Symbol.for('@atlassian/relay-environment.AtlassianRelayEnvironment');
function $aea8d0ec47f38c12$var$brandEnvironment(environment) {
    Object.defineProperty(environment, $aea8d0ec47f38c12$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND, {
        value: true,
        enumerable: false,
        configurable: false,
        writable: false
    });
    return environment;
}
function $aea8d0ec47f38c12$export$56db1ec1ca8ef90c(environment) {
    return environment != null && (typeof environment === 'object' || typeof environment === 'function') && environment[$aea8d0ec47f38c12$var$ATLASSIAN_RELAY_ENVIRONMENT_BRAND] === true;
}
/**
 * Relay calls `environment.UNSTABLE_getDefaultRenderPolicy()` on every `QueryResource.prepare`, so
 * this allows overriding it dynamically (and not during module scope evaluation).
 */ class $aea8d0ec47f38c12$var$DynamicRenderPolicyEnvironment extends (0, $eqEJl.Environment) {
    /**
   * Note: currently missing from @types/relay-runtime (version 20.1.1) but DOES exist at runtime.
   */ UNSTABLE_getDefaultRenderPolicy() {
        return this.getRenderPolicy();
    }
    constructor(config, getRenderPolicy){
        super(config);
        this.getRenderPolicy = void 0;
        this.getRenderPolicy = getRenderPolicy;
    }
}
const $aea8d0ec47f38c12$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($7PdwS)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $aea8d0ec47f38c12$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $eqEJl.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $aea8d0ec47f38c12$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $bB0i2.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $bR8ZK.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $aea8d0ec47f38c12$var$deleteNode(connection, id);
            }
        });
    }
};
function $aea8d0ec47f38c12$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $aea8d0ec47f38c12$var$DeleteEdgeHandler;
        default:
            return (0, $eqEJl.DefaultHandlerProvider)(handle);
    }
}
function $aea8d0ec47f38c12$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID, getDefaultRenderPolicy: getDefaultRenderPolicy }) {
    if ((0, $iDrrr.fg)('platform_relay_enable_activity_compatibility_flag')) (0, $eqEJl.RelayFeatureFlags).ENABLE_ACTIVITY_COMPATIBILITY = true;
    const config = {
        configName: 'Atlassian Shared Graphql Gateway',
        network: $aea8d0ec47f38c12$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $aea8d0ec47f38c12$var$createStore(new (0, $eqEJl.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $bJzbV.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $bJzbV.default),
        scheduler: (0, $dTp7m.default),
        missingFieldHandlers: (0, $3VgML.default),
        handlerProvider: $aea8d0ec47f38c12$var$HandlerProvider
    };
    const environment = getDefaultRenderPolicy ? new $aea8d0ec47f38c12$var$DynamicRenderPolicyEnvironment(config, getDefaultRenderPolicy) : new (0, $eqEJl.Environment)(config);
    return $aea8d0ec47f38c12$var$brandEnvironment(environment);
}
module.exports["isAtlassianRelayEnvironment"] = $aea8d0ec47f38c12$export$56db1ec1ca8ef90c;
module.exports["createRelayEnvironment"] = $aea8d0ec47f38c12$export$7afaa9c867644497;

});

parcelRegister("662WV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4705974be54c0dec$export$2e2bcd8739ae039);

var $lDcU7 = parcelRequire("lDcU7");


var $bp04u = parcelRequire("bp04u");

var $4705974be54c0dec$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $4705974be54c0dec$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($4705974be54c0dec$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $lDcU7.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $4705974be54c0dec$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $bp04u.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $4705974be54c0dec$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $bp04u.default] = observable, _ref2;
}
module.exports["ActionTypes"] = $4705974be54c0dec$export$1385d81a6c6bbcd4;

});

parcelRegister("jqaRm", function(module, exports) {

var $662WV = parcelRequire("662WV");


var $lDcU7 = parcelRequire("lDcU7");

parcelRequire("kil0h");

function $e238de8d98ea5294$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $e238de8d98ea5294$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $662WV.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $lDcU7.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $e238de8d98ea5294$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $662WV.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $662WV.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $e238de8d98ea5294$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $e238de8d98ea5294$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $e238de8d98ea5294$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});

parcelRegister("e6HAR", function(module, exports) {
function $a4537100ab206663$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $a4537100ab206663$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $a4537100ab206663$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $a4537100ab206663$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("k0XkQ", function(module, exports) {

var $eahqf = parcelRequire("eahqf");

var $e921d57bf0e013ec$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e921d57bf0e013ec$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $eahqf.default).apply(undefined, chain)(store.dispatch);
            return $e921d57bf0e013ec$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});

parcelRegister("eahqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4ff8394050c9837$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $a4ff8394050c9837$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("jdqmT", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $9809852f82fd3daa$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
};
const $9809852f82fd3daa$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
};
const $9809852f82fd3daa$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
};
const $9809852f82fd3daa$export$615f888019c45765 = {
    'smart-link-rendered': new (0, $fh15z.ConcurrentExperience)('smart-link-rendered', $9809852f82fd3daa$var$renderExperience),
    'smart-link-authenticated': new (0, $fh15z.ConcurrentExperience)('smart-link-authenticated', $9809852f82fd3daa$var$inlineExperience),
    'smart-link-action-invocation': new (0, $fh15z.ConcurrentExperience)('smart-link-action-invocation', $9809852f82fd3daa$var$inlineExperience),
    'smart-link-ai-summary': new (0, $fh15z.ConcurrentExperience)('smart-link-ai-summary', $9809852f82fd3daa$var$aiExperience)
};
module.exports["ufoExperiences"] = $9809852f82fd3daa$export$615f888019c45765;

});

parcelRegister("1BCyZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $12b7290360a397a8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $cozmU = parcelRequire("cozmU");

var $12b7290360a397a8$var$React = $12b7290360a397a8$var$_interopRequireWildcard($cozmU);
function $12b7290360a397a8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $12b7290360a397a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $12b7290360a397a8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $12b7290360a397a8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $12b7290360a397a8$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $12b7290360a397a8$var$loaded() {
    return {
        isLoaded: true
    };
}
function $12b7290360a397a8$var$errored() {
    return {
        isErrored: true
    };
}
function $12b7290360a397a8$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $12b7290360a397a8$var$ImageRenderer = function(_React$Component) {
    $12b7290360a397a8$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $12b7290360a397a8$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $12b7290360a397a8$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($12b7290360a397a8$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($12b7290360a397a8$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $12b7290360a397a8$var$_possibleConstructorReturn(_this, _ret);
    }
    $12b7290360a397a8$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($12b7290360a397a8$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($12b7290360a397a8$var$hasPropsChanged(this.props, nextProps)) this.setState($12b7290360a397a8$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($12b7290360a397a8$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($12b7290360a397a8$var$React.Component);
module.exports.default = $12b7290360a397a8$var$ImageRenderer;

});

parcelRegister("gpeTJ", function(module, exports) {
const $9145c66bc07bb1c2$export$640106f6dc7d2706 = ()=>globalThis.location?.hostname;
module.exports["hostname"] = $9145c66bc07bb1c2$export$640106f6dc7d2706;

});

parcelRegister("45IUg", function(module, exports) {

var $fTVW6 = parcelRequire("fTVW6");


var $et0rs = parcelRequire("et0rs");


var $aoQrH = parcelRequire("aoQrH");

async function $0f946731673bdafb$export$a14afb5f82fe705(serviceUrl, query, processHeaders = (0, $aoQrH.id)) {
    return (0, $fTVW6.graphQLQuery)(serviceUrl, query, processHeaders, (0, $et0rs.handleAGGErrors));
}
module.exports["AGGQuery"] = $0f946731673bdafb$export$a14afb5f82fe705;

});

parcelRegister("goaLH", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

class $796bf3f876369ae9$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $lPEt0.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $796bf3f876369ae9$export$2e2bcd8739ae039;

});

parcelRegister("lBj2m", function(module, exports) {

var $bPh6H = parcelRequire("bPh6H");


var $iDrrr = parcelRequire("iDrrr");


var $iLX84 = parcelRequire("iLX84");

const $34687db3e738019a$export$7b7129a1e3014268 = (0, $iLX84.default)`query user($userId:ID!){user(accountId:$userId){id name picture accountStatus __typename ...on AtlassianAccountUser{email nickname zoneinfo extendedProfile{jobTitle organization location closedDate inactiveDate}}...on CustomerUser{email zoneinfo}...on AppUser{appType}}}`;


const $05c23cde61f8c691$export$33ed471cf1a2aa14 = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;


const $e9b42704bc11b4e2$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $iDrrr.fg)('platform_agg_user_query_doc_change') ? (0, $bPh6H.print)((0, $34687db3e738019a$export$7b7129a1e3014268)) : (0, $05c23cde61f8c691$export$33ed471cf1a2aa14),
        variables: {
            userId: userId
        }
    });
module.exports["buildAggUserQuery"] = $e9b42704bc11b4e2$export$8230f28f7ae567ea;

});

parcelRegister("knvOX", function(module, exports) {

var $4dZa0 = parcelRequire("4dZa0");


var $1ArlK = parcelRequire("1ArlK");


var $gUrTw = parcelRequire("gUrTw");


var $2yfJH = parcelRequire("2yfJH");

const $7642aa922e9e7fa6$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $7642aa922e9e7fa6$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $7642aa922e9e7fa6$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $7642aa922e9e7fa6$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $gUrTw.DirectoryGraphQLError)) return !!error && $7642aa922e9e7fa6$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $4dZa0.AGGError)) return !!error.errorType && $7642aa922e9e7fa6$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $7642aa922e9e7fa6$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $7642aa922e9e7fa6$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $2yfJH.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($7642aa922e9e7fa6$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($7642aa922e9e7fa6$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $gUrTw.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$7642aa922e9e7fa6$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $1ArlK.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($7642aa922e9e7fa6$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($7642aa922e9e7fa6$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $4dZa0.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$7642aa922e9e7fa6$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $2yfJH.DirectoryGraphQLErrors) || causeError instanceof (0, $1ArlK.AGGErrors)) return $7642aa922e9e7fa6$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
module.exports["getErrorAttributes"] = $7642aa922e9e7fa6$export$6ad9e7706a4ee0f8;

});

parcelRegister("dRT1d", function(module, exports) {
$parcel$export(module.exports, "default", () => $a18ae7274cf37aab$export$2e2bcd8739ae039);

var $4hHJG = parcelRequire("4hHJG");

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a7b743732b1e612c$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a7b743732b1e612c$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a7b743732b1e612c$var$partsTimeZone(dtf, date) : $a7b743732b1e612c$var$hackyTimeZone(dtf, date);
}
function $a7b743732b1e612c$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a7b743732b1e612c$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a7b743732b1e612c$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}



var $84uSy = parcelRequire("84uSy");

var $b07f105b7e1a205e$var$MILLISECONDS_IN_MINUTE = 60000;
var $b07f105b7e1a205e$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $b07f105b7e1a205e$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b07f105b7e1a205e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $b07f105b7e1a205e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b07f105b7e1a205e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $b07f105b7e1a205e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b07f105b7e1a205e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $b07f105b7e1a205e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b07f105b7e1a205e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $b07f105b7e1a205e$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b07f105b7e1a205e$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b07f105b7e1a205e$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $a7b743732b1e612c$export$2e2bcd8739ae039)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $a7b743732b1e612c$export$2e2bcd8739ae039)('long', date, options);
        }
    }
};
function $b07f105b7e1a205e$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $84uSy.default)(timeZone, originalDate, true) / $b07f105b7e1a205e$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $b07f105b7e1a205e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $b07f105b7e1a205e$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $b07f105b7e1a205e$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b07f105b7e1a205e$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $b07f105b7e1a205e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $b07f105b7e1a205e$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b07f105b7e1a205e$var$formatTimezone(offset, dirtyDelimeter);
}
function $b07f105b7e1a205e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $b07f105b7e1a205e$var$addLeadingZeros(minutes, 2);
}
var $b07f105b7e1a205e$export$2e2bcd8739ae039 = $b07f105b7e1a205e$var$formatters;



var $cx14W = parcelRequire("cx14W");

var $a18ae7274cf37aab$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $a18ae7274cf37aab$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($a18ae7274cf37aab$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $cx14W.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $b07f105b7e1a205e$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4hHJG)))(dirtyDate, formatStr, options);
}

});

parcelRegister("9q5hY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dbaa504fcdcb0ad$export$2e2bcd8739ae039);

var $84uSy = parcelRequire("84uSy");

function $6dbaa504fcdcb0ad$export$2e2bcd8739ae039(timeZone, date) {
    return -(0, $84uSy.default)(timeZone, date);
}

});

parcelRegister("cx14W", function(module, exports) {
$parcel$export(module.exports, "default", () => $91f9674c1793f20c$export$2e2bcd8739ae039);

var $55p4v = parcelRequire("55p4v");


var $7EvI6 = parcelRequire("7EvI6");


var $84uSy = parcelRequire("84uSy");


var $c50mt = parcelRequire("c50mt");

var $91f9674c1793f20c$var$MILLISECONDS_IN_HOUR = 3600000;
var $91f9674c1793f20c$var$MILLISECONDS_IN_MINUTE = 60000;
var $91f9674c1793f20c$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $91f9674c1793f20c$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $c50mt.default)
};
function $91f9674c1793f20c$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $91f9674c1793f20c$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($55p4v)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $91f9674c1793f20c$var$splitDateString(argument);
    var parseYearResult = $91f9674c1793f20c$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $91f9674c1793f20c$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $91f9674c1793f20c$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $84uSy.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($7EvI6)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($7EvI6)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $91f9674c1793f20c$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $91f9674c1793f20c$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $91f9674c1793f20c$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $91f9674c1793f20c$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $91f9674c1793f20c$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $91f9674c1793f20c$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $91f9674c1793f20c$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $91f9674c1793f20c$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $91f9674c1793f20c$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $91f9674c1793f20c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $91f9674c1793f20c$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$91f9674c1793f20c$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $91f9674c1793f20c$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$91f9674c1793f20c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $91f9674c1793f20c$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$91f9674c1793f20c$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $91f9674c1793f20c$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$91f9674c1793f20c$var$validateWeekDate(year, week)) return new Date(NaN);
        return $91f9674c1793f20c$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $91f9674c1793f20c$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$91f9674c1793f20c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $91f9674c1793f20c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $91f9674c1793f20c$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $91f9674c1793f20c$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$91f9674c1793f20c$var$validateTime(hours)) return NaN;
        return hours % 24 * $91f9674c1793f20c$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $91f9674c1793f20c$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$91f9674c1793f20c$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $91f9674c1793f20c$var$MILLISECONDS_IN_HOUR + minutes * $91f9674c1793f20c$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $91f9674c1793f20c$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$91f9674c1793f20c$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $91f9674c1793f20c$var$MILLISECONDS_IN_HOUR + minutes * $91f9674c1793f20c$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $91f9674c1793f20c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $91f9674c1793f20c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $91f9674c1793f20c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $91f9674c1793f20c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $91f9674c1793f20c$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $91f9674c1793f20c$var$isLeapYearIndex(year);
        if (isLeapYear && date > $91f9674c1793f20c$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $91f9674c1793f20c$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $91f9674c1793f20c$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $91f9674c1793f20c$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $91f9674c1793f20c$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $91f9674c1793f20c$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});

parcelRegister("5K52A", function(module, exports) {
$parcel$export(module.exports, "default", () => $42e5289722314b56$export$2e2bcd8739ae039);

var $84uSy = parcelRequire("84uSy");


var $cx14W = parcelRequire("cx14W");

function $42e5289722314b56$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $cx14W.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $84uSy.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});

parcelRegister("1t17e", function(module, exports) {
$parcel$export(module.exports, "default", () => $11195d71eeb41ede$export$2e2bcd8739ae039);

var $jNWGj = parcelRequire("jNWGj");


var $cx14W = parcelRequire("cx14W");


var $c50mt = parcelRequire("c50mt");


var $84uSy = parcelRequire("84uSy");


var $l3PTn = parcelRequire("l3PTn");

function $11195d71eeb41ede$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $c50mt.default))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jNWGj)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $cx14W.default)(date, extendedOptions);
    }
    var d = (0, $cx14W.default)(date, options);
    var utc = (0, $l3PTn.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $84uSy.default)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

});

parcelRegister("hjGNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isProtectedDayOfYearToken = $c9b56a2c78265acb$var$isProtectedDayOfYearToken;
module.exports.isProtectedWeekYearToken = $c9b56a2c78265acb$var$isProtectedWeekYearToken;
module.exports.throwProtectedError = $c9b56a2c78265acb$var$throwProtectedError;
var $c9b56a2c78265acb$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $c9b56a2c78265acb$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $c9b56a2c78265acb$var$isProtectedDayOfYearToken(token) {
    return $c9b56a2c78265acb$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $c9b56a2c78265acb$var$isProtectedWeekYearToken(token) {
    return $c9b56a2c78265acb$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $c9b56a2c78265acb$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("9xLsj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $6f2c01d3ee64850e$var$getDefaultOptions;
module.exports.setDefaultOptions = $6f2c01d3ee64850e$var$setDefaultOptions;
var $6f2c01d3ee64850e$var$defaultOptions = {};
function $6f2c01d3ee64850e$var$getDefaultOptions() {
    return $6f2c01d3ee64850e$var$defaultOptions;
}
function $6f2c01d3ee64850e$var$setDefaultOptions(newOptions) {
    $6f2c01d3ee64850e$var$defaultOptions = newOptions;
}

});

parcelRegister("5P7QE", function(module, exports) {

var $88RF3 = parcelRequire("88RF3");


var $eqEJl = parcelRequire("eqEJl");


var $iDrrr = parcelRequire("iDrrr");


var $dOgct = parcelRequire("dOgct");


var $fT0GI = parcelRequire("fT0GI");


var $4hXjM = parcelRequire("4hXjM");


var $6qzJ0 = parcelRequire("6qzJ0");


var $iWp2w = parcelRequire("iWp2w");


var $FC3by = parcelRequire("FC3by");


var $90GLm = parcelRequire("90GLm");


var $cT93W = parcelRequire("cT93W");


var $96WbW = parcelRequire("96WbW");


var $a3vkq = parcelRequire("a3vkq");


var $fjbT2 = parcelRequire("fjbT2");


var $17hVF = parcelRequire("17hVF");

const $4dcbac950a0d67f5$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $4dcbac950a0d67f5$var$moduleID = 'relay-fetch';
const $4dcbac950a0d67f5$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    if (dependencies?.didPreflightAuthenticationCheckTriggerRedirect?.(request, variables, cacheConfig) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
    // while the redirect takes over instead of starting a fetch with a stale auth state.
    return (0, $eqEJl.Observable).from(new Promise(()=>{}));
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    // Per-query opt-in (cacheConfig.metadata.captureErrors) to forward this operation's response to
    // the product's capture callback, if one is provided. Whether to actually capture (feature gates,
    // etc.) is a product concern owned by the callback itself, not by this platform code.
    const shouldCaptureErrors = cacheConfig?.metadata?.captureErrors === true && !dependencies?.isServer;
    let responseHeaders;
    function augmentResponse(response) {
        const traceIdFromHeader = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $iDrrr.fg)('platform_relay_fetch_traceid_header_fallback') && responseHeaders ? responseHeaders.get('atl-traceid') ?? undefined : undefined;
        (0, $6qzJ0.addTraceId)(queryName, (0, $17hVF.getTraceIdFromExtensions)(response) ?? traceIdFromHeader);
        (0, $dOgct.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $eqEJl.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$4dcbac950a0d67f5$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $fT0GI.getAggEndpoint)(request, cacheConfig);
                const body = (0, $fT0GI.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $90GLm.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $cT93W.processMultipartPromise)(()=>(0, $a3vkq.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $fjbT2.shouldRetry),
                        retryAttempts: (0, $96WbW.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }), dependencies?.onFetchError, (headers)=>{
                    responseHeaders = headers;
                });
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $4dcbac950a0d67f5$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $4hXjM.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $4hXjM.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $4hXjM.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $4dcbac950a0d67f5$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $FC3by.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (shouldCaptureErrors && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $4dcbac950a0d67f5$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($88RF3)))(ssrCache)) {
                    // The cached payload is seeded into Relay below without passing through
                    // validateResponse, so capture its errors here instead.
                    if (shouldCaptureErrors && !Array.isArray(ssrCache) && typeof dependencies?.captureResponseErrors === 'function') dependencies.captureResponseErrors(request, ssrCache);
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($4dcbac950a0d67f5$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $iWp2w.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $iWp2w.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
module.exports["fetch"] = $4dcbac950a0d67f5$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("HK9KM", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $i4fnE = parcelRequire("i4fnE");

var $apLc2 = parcelRequire("apLc2");

const $3b3b0361bb57f9c7$var$channels = new Map();
// Order-independent so two callers with the same channel produce the same key
// regardless of property insertion order.
function $3b3b0361bb57f9c7$var$stableStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value) ?? 'null';
    if (Array.isArray(value)) return `[${value.map($3b3b0361bb57f9c7$var$stableStringify).join(',')}]`;
    const obj = value;
    const keys = Object.keys(obj).sort();
    return `{${keys.map((k)=>`${JSON.stringify(k)}:${$3b3b0361bb57f9c7$var$stableStringify(obj[k])}`).join(',')}}`;
}
function $3b3b0361bb57f9c7$var$channelKey(payload) {
    return $3b3b0361bb57f9c7$var$stableStringify({
        pq: payload.extensions?.pq ?? null,
        operationName: payload.operationName ?? null,
        variables: payload.variables ?? null,
        extensions: payload.extensions ?? null
    });
}
let $3b3b0361bb57f9c7$var$cachedDefaultSubscribe;
function $3b3b0361bb57f9c7$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $3b3b0361bb57f9c7$var$cachedDefaultSubscribe !== 'undefined') return $3b3b0361bb57f9c7$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $eqEJl.Observable).create((sink)=>{
            const client = (0, $i4fnE.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayExtensions
                }
            };
            subscribeOptions?.onSubscribeTrigger?.(payload);
            // Share one upstream subscription per channel across all observers.
            const key = $3b3b0361bb57f9c7$var$channelKey(payload);
            const localSink = {
                next: (value)=>{
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (err, requestId)=>{
                    sink.error(err);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId
                    });
                },
                complete: ()=>sink.complete?.()
            };
            const existingChannel = $3b3b0361bb57f9c7$var$channels.get(key);
            if (!existingChannel) {
                // First observer for this channel: open the single upstream sub.
                // The handlers below close over `newChannel`, so it must exist before
                // client.subscribe runs; but we only register it in the map after its
                // real `dispose` is assigned, so a dispose can never hit a no-op
                // placeholder (and never leak the upstream subscription).
                const newChannel = {
                    sinks: new Set([
                        localSink
                    ]),
                    dispose: ()=>{},
                    lastRequestId: null
                };
                newChannel.dispose = client.subscribe(payload, {
                    next: (value)=>{
                        // @ts-expect-error agg prop is missing on generic "extensions" type
                        const aggRequestId = value?.extensions?.gateway?.request_id;
                        if (aggRequestId) newChannel.lastRequestId = aggRequestId;
                        // Snapshot so a sink unsubscribing during dispatch doesn't
                        // mutate the set we're iterating.
                        for (const s of Array.from(newChannel.sinks))try {
                            s.next(value);
                        } catch  {
                        // Isolate sinks: a buggy consumer must not starve siblings.
                        }
                    },
                    error: (sinkError)=>{
                        const errorInfo = (0, $apLc2.getSinkError)(sinkError);
                        // Snapshot the sinks and the last gateway request id before
                        // dropping the channel, so a sink that resubscribes inside its
                        // error handler opens a fresh upstream while still receiving the
                        // request id from the failed subscription.
                        const sinks = Array.from(newChannel.sinks);
                        const { lastRequestId: lastRequestId } = newChannel;
                        $3b3b0361bb57f9c7$var$channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.error(errorInfo, lastRequestId);
                        } catch  {
                        /* isolate sinks */ }
                    },
                    complete: ()=>{
                        const sinks = Array.from(newChannel.sinks);
                        $3b3b0361bb57f9c7$var$channels.delete(key);
                        newChannel.sinks.clear();
                        for (const s of sinks)try {
                            s.complete?.();
                        } catch  {
                        /* isolate sinks */ }
                    }
                });
                // Register only now that dispose is set (see note above).
                $3b3b0361bb57f9c7$var$channels.set(key, newChannel);
            } else // Subsequent observers for the same channel just attach their sink.
            existingChannel.sinks.add(localSink);
            // Relay dispose: drop this observer; only tear down the upstream when
            // the last observer for the channel goes away.
            return ()=>{
                const c = $3b3b0361bb57f9c7$var$channels.get(key);
                if (!c) return;
                c.sinks.delete(localSink);
                if (c.sinks.size === 0) {
                    $3b3b0361bb57f9c7$var$channels.delete(key);
                    try {
                        c.dispose();
                    } catch  {
                    /* upstream dispose errors must not break Relay teardown */ }
                }
            };
        });
    if (typeof subscribeOptions === 'undefined') $3b3b0361bb57f9c7$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $3b3b0361bb57f9c7$export$ec068583843480e7 = $3b3b0361bb57f9c7$export$10f5a0700f263f11();
module.exports["createSubscribeFn"] = $3b3b0361bb57f9c7$export$10f5a0700f263f11;

});

parcelRegister("lDcU7", function(module, exports) {

var $024FG = parcelRequire("024FG");


var $iSseG = parcelRequire("iSseG");


var $4nXqj = parcelRequire("4nXqj");

/** `Object#toString` result references. */ var $fbf73ff6264f4dbe$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $fbf73ff6264f4dbe$var$funcProto = Function.prototype, $fbf73ff6264f4dbe$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $fbf73ff6264f4dbe$var$funcToString = $fbf73ff6264f4dbe$var$funcProto.toString;
/** Used to check objects for own properties. */ var $fbf73ff6264f4dbe$var$hasOwnProperty = $fbf73ff6264f4dbe$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $fbf73ff6264f4dbe$var$objectCtorString = $fbf73ff6264f4dbe$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $fbf73ff6264f4dbe$var$isPlainObject(value) {
    if (!(0, $4nXqj.default)(value) || (0, $024FG.default)(value) != $fbf73ff6264f4dbe$var$objectTag) return false;
    var proto = (0, $iSseG.default)(value);
    if (proto === null) return true;
    var Ctor = $fbf73ff6264f4dbe$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $fbf73ff6264f4dbe$var$funcToString.call(Ctor) == $fbf73ff6264f4dbe$var$objectCtorString;
}
var $fbf73ff6264f4dbe$export$2e2bcd8739ae039 = $fbf73ff6264f4dbe$var$isPlainObject;
module.exports["default"] = $fbf73ff6264f4dbe$export$2e2bcd8739ae039;

});

parcelRegister("kil0h", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ec65c7ef5c8f7b24$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});

parcelRegister("fTVW6", function(module, exports) {

var $gw8Y0 = parcelRequire("gw8Y0");


var $lphM5 = parcelRequire("lphM5");


var $aoQrH = parcelRequire("aoQrH");

async function $13c0dc7d50e57e67$export$247d31b1ac37202a(serviceUrl, query, processHeaders = (0, $aoQrH.id), handleErrors) {
    const headers = processHeaders((0, $lphM5.buildHeaders)());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $gw8Y0.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["graphQLQuery"] = $13c0dc7d50e57e67$export$247d31b1ac37202a;

});

parcelRegister("et0rs", function(module, exports) {

var $1ArlK = parcelRequire("1ArlK");

const $21339207dbb49216$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $1ArlK.AGGErrors)(errors, traceId);
};
module.exports["handleAGGErrors"] = $21339207dbb49216$export$d9ad65d422ee3f8c;

});

parcelRegister("aoQrH", function(module, exports) {
const $398a93b0742a4b07$export$d560c7e4a29451c2 = (headers)=>headers;
module.exports["id"] = $398a93b0742a4b07$export$d560c7e4a29451c2;

});

parcelRegister("4dZa0", function(module, exports) {
class $86329d6f8fdc92cd$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
module.exports["AGGError"] = $86329d6f8fdc92cd$export$4a696f048dcc929;

});

parcelRegister("1ArlK", function(module, exports) {

var $4dZa0 = parcelRequire("4dZa0");

class $2d000193d36ae621$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new (0, $4dZa0.AGGError)(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["AGGErrors"] = $2d000193d36ae621$export$60d8267243755b9c;

});

parcelRegister("gUrTw", function(module, exports) {
class $decf91ca965c8cd0$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
module.exports["DirectoryGraphQLError"] = $decf91ca965c8cd0$export$c1e4d0de940c06a2;

});

parcelRegister("2yfJH", function(module, exports) {

var $gUrTw = parcelRequire("gUrTw");

class $8fa978852141d601$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new (0, $gUrTw.DirectoryGraphQLError)(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["DirectoryGraphQLErrors"] = $8fa978852141d601$export$5a5fbfed34a590a1;

});

parcelRegister("84uSy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e06a660a9490097$export$2e2bcd8739ae039);

var $gqYEI = parcelRequire("gqYEI");


var $l3PTn = parcelRequire("l3PTn");

var $5e06a660a9490097$var$MILLISECONDS_IN_HOUR = 3600000;
var $5e06a660a9490097$var$MILLISECONDS_IN_MINUTE = 60000;
var $5e06a660a9490097$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $5e06a660a9490097$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $5e06a660a9490097$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $5e06a660a9490097$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$5e06a660a9490097$var$validateTimezone(hours)) return NaN;
        return -(hours * $5e06a660a9490097$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $5e06a660a9490097$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$5e06a660a9490097$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $5e06a660a9490097$var$MILLISECONDS_IN_HOUR + minutes * $5e06a660a9490097$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($5e06a660a9490097$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $5e06a660a9490097$var$toUtcDate(date);
        var offset = $5e06a660a9490097$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $5e06a660a9490097$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $5e06a660a9490097$var$toUtcDate(date) {
    return (0, $l3PTn.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $5e06a660a9490097$var$calcOffset(date, timezoneString) {
    var tokens = (0, $gqYEI.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $l3PTn.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $5e06a660a9490097$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $5e06a660a9490097$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $5e06a660a9490097$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $5e06a660a9490097$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $5e06a660a9490097$var$validIANATimezoneCache = {};
function $5e06a660a9490097$var$isValidTimezoneIANAString(timeZoneString) {
    if ($5e06a660a9490097$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $5e06a660a9490097$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});

parcelRegister("c50mt", function(module, exports) {
/** Regex to identify the presence of a time zone specifier in a date string */ var $8cb63b744528b365$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $8cb63b744528b365$export$2e2bcd8739ae039 = $8cb63b744528b365$var$tzPattern;
module.exports["default"] = $8cb63b744528b365$export$2e2bcd8739ae039;

});

parcelRegister("l3PTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f552217fd5d0b83b$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $f552217fd5d0b83b$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});

parcelRegister("fT0GI", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

const $b76be158634f7a78$var$branchSlug = typeof $1P2f3 !== 'undefined' && $1P2f3.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $b76be158634f7a78$var$serviceOverrides = typeof $1P2f3 !== 'undefined' && $1P2f3.env ? undefined : undefined;
const $b76be158634f7a78$export$8f8c52ac77845a86 = `/gateway/api/graphql${$b76be158634f7a78$var$branchSlug ? `/${$b76be158634f7a78$var$branchSlug}/graphql` : ''}`;
const $b76be158634f7a78$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    let endpoint = $b76be158634f7a78$export$8f8c52ac77845a86;
    if (cacheConfig.metadata?.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($b76be158634f7a78$var$serviceOverrides) url = `${url}&serviceOverride=${$b76be158634f7a78$var$serviceOverrides}`;
    return url;
};
const $b76be158634f7a78$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};
module.exports["getAggEndpoint"] = $b76be158634f7a78$export$fd126d8de571b77d;
module.exports["getRequestBody"] = $b76be158634f7a78$export$55bce18df99af758;

});

parcelRegister("4hXjM", function(module, exports) {
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $d01b74e356d901dc$export$607b80f5bc6e396d = new Map();
const $d01b74e356d901dc$export$cdadce6ed6361a2c = new Map();
module.exports["QueryPromisesMap"] = $d01b74e356d901dc$export$607b80f5bc6e396d;
module.exports["CompletedQueryPromisesMap"] = $d01b74e356d901dc$export$cdadce6ed6361a2c;

});

parcelRegister("iWp2w", function(module, exports) {

var $gzvF9 = parcelRequire("gzvF9");

const $51214c99cc2b1d26$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $51214c99cc2b1d26$var$dispatcher;
const $51214c99cc2b1d26$export$5bb012cf9b3a5452 = ()=>{
    if (!$51214c99cc2b1d26$var$dispatcher) {
        $51214c99cc2b1d26$var$dispatcher = new (0, $gzvF9.ClientDispatcher)();
        // Handle the server hangup scenarios
        $51214c99cc2b1d26$var$dispatcher.register($51214c99cc2b1d26$export$eb5d9c90d65c7fea, $51214c99cc2b1d26$var$dispatcher._abort.bind($51214c99cc2b1d26$var$dispatcher));
    }
    return $51214c99cc2b1d26$var$dispatcher;
};
module.exports["getClientDispatcher"] = $51214c99cc2b1d26$export$5bb012cf9b3a5452;

});

parcelRegister("FC3by", function(module, exports) {
const $967d84ea7340569d$var$events = [];
const $967d84ea7340569d$export$bd50bc4cd3c601ee = (event)=>{
    $967d84ea7340569d$var$events.push(event);
};
const $967d84ea7340569d$export$3c7145db84d4587c = ()=>{
    return $967d84ea7340569d$var$events.splice(0, $967d84ea7340569d$var$events.length);
};
module.exports["registerEvent"] = $967d84ea7340569d$export$bd50bc4cd3c601ee;

});

parcelRegister("90GLm", function(module, exports) {

var $lYpJw = parcelRequire("lYpJw");


var $hbyFU = parcelRequire("hbyFU");


var $btd1v = parcelRequire("btd1v");


var $2NsNv = parcelRequire("2NsNv");

const $857f3e6bd4bd6f1d$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
function $857f3e6bd4bd6f1d$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $857f3e6bd4bd6f1d$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $hbyFU.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = (0, $2NsNv.shouldUseGetMethod)({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = (0, $btd1v.buildGetUrl)(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}
module.exports["buildGraphqlSmartFetch"] = $857f3e6bd4bd6f1d$export$33c9c992c7855d86;

});

parcelRegister("cT93W", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iDrrr = parcelRequire("iDrrr");


var $aYNQr = parcelRequire("aYNQr");

const $7320eae2fecd1610$var$NO_CONTENT = 204;
function $7320eae2fecd1610$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $7320eae2fecd1610$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $7320eae2fecd1610$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $7320eae2fecd1610$var$getBoundary(contentType || '');
    if (!boundary) {
        $7320eae2fecd1610$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        (0, $aYNQr.processStream)(streamReader(), boundary, observer).catch((error)=>$7320eae2fecd1610$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $7320eae2fecd1610$var$emitError(observer, error, response, onFetchError);
    }
}
function $7320eae2fecd1610$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$7320eae2fecd1610$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $7320eae2fecd1610$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        let traceId = '';
        if ((0, $iDrrr.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response?.headers?.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $7320eae2fecd1610$var$emitError(observer, error, response, onFetchError);
    });
}
function $7320eae2fecd1610$export$f76505a7f2969e4e(source, onFetchError, onResponseHeaders) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $eqEJl.Observable).create((observer)=>{
        result.then((response)=>{
            // Expose the response headers via a side-channel so the consumer can
            // read values such as `atl-traceid` without changing the payload emission shape.
            if ((0, $iDrrr.fg)('platform_relay_fetch_traceid_header_fallback')) onResponseHeaders?.(response.headers);
            if (response.status === $7320eae2fecd1610$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $7320eae2fecd1610$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $7320eae2fecd1610$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $7320eae2fecd1610$var$handleMultipartResponse(response, observer, onFetchError);
            else $7320eae2fecd1610$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$7320eae2fecd1610$var$emitError(observer, error, undefined, onFetchError));
    });
}
module.exports["processMultipartPromise"] = $7320eae2fecd1610$export$f76505a7f2969e4e;

});

parcelRegister("96WbW", function(module, exports) {

var $3JBV7 = parcelRequire("3JBV7");

const $6717168701b0a8f3$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return 0, $3JBV7.RETRY_ATTEMPTS_LIMIT;
    return 0;
};
module.exports["getRetryAttemptsForQuery"] = $6717168701b0a8f3$export$9dec0f42cc67f6ab;

});

parcelRegister("a3vkq", function(module, exports) {

var $3JBV7 = parcelRequire("3JBV7");

const $11f49a9af0d2fb0a$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = (0, $3JBV7.RETRY_ATTEMPTS_LIMIT), onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > (0, $3JBV7.RETRY_ATTEMPTS_LIMIT) ? (0, $3JBV7.RETRY_ATTEMPTS_LIMIT) : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
module.exports["retryOnError"] = $11f49a9af0d2fb0a$export$f859c88bfac2cf2c;

});

parcelRegister("fjbT2", function(module, exports) {
const $922f9b2690f5bf91$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
module.exports["shouldRetry"] = $922f9b2690f5bf91$export$7bfea3c3d460ecd8;

});

parcelRegister("17hVF", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $008d1ced95f38f3f$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions == null || extensions.gateway == null) return undefined;
    if ((0, $iDrrr.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};
module.exports["getTraceIdFromExtensions"] = $008d1ced95f38f3f$export$eefb7f54c3b07211;

});

parcelRegister("i4fnE", function(module, exports) {

var $7qSpV = parcelRequire("7qSpV");


var $hbyFU = parcelRequire("hbyFU");


var $8qPlF = parcelRequire("8qPlF");


var $3iJiV = parcelRequire("3iJiV");

let $31490981a56fcdb3$var$client;
const $31490981a56fcdb3$export$6bb76d6eba7e258c = ()=>{
    if ((0, $3iJiV.isSSR)()) return null;
    if (!$31490981a56fcdb3$var$client) $31490981a56fcdb3$var$client = (0, $7qSpV.createClient)({
        url: (0, $3iJiV.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $8qPlF.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $8qPlF.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $hbyFU.getRelayExperimentalApis)().join(',')
        }
    });
    return $31490981a56fcdb3$var$client;
};
const $31490981a56fcdb3$export$2f0afd443356d36f = ()=>{
    $31490981a56fcdb3$var$client = null;
};
module.exports["getClient"] = $31490981a56fcdb3$export$6bb76d6eba7e258c;

});

parcelRegister("apLc2", function(module, exports) {
const $efb00a5b61b27294$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
module.exports["getSinkError"] = $efb00a5b61b27294$export$ece4736473c28965;

});

parcelRegister("gw8Y0", function(module, exports) {
class $5a0d2e8f1f265af7$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
module.exports["HttpError"] = $5a0d2e8f1f265af7$export$65bd6083489bd8bb;

});

parcelRegister("lphM5", function(module, exports) {
const $e48961b98cad7218$export$7d6ed858a91629c3 = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
module.exports["buildHeaders"] = $e48961b98cad7218$export$7d6ed858a91629c3;

});

parcelRegister("gqYEI", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf6e1ffd52f08344$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $bf6e1ffd52f08344$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $bf6e1ffd52f08344$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $bf6e1ffd52f08344$var$partsOffset(dtf, date) : $bf6e1ffd52f08344$var$hackyOffset(dtf, date);
}
var $bf6e1ffd52f08344$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $bf6e1ffd52f08344$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $bf6e1ffd52f08344$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $bf6e1ffd52f08344$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $bf6e1ffd52f08344$var$dtfCache = {};
function $bf6e1ffd52f08344$var$getDateTimeFormat(timeZone) {
    if (!$bf6e1ffd52f08344$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $bf6e1ffd52f08344$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $bf6e1ffd52f08344$var$dtfCache[timeZone];
}

});

parcelRegister("gzvF9", function(module, exports) {
class $1c0fea79468f5804$export$3f5ba18eb97af725 {
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
    constructor(){
        this.handlers = void 0;
        this.queuedPayloads = void 0;
        this.abortReason = void 0;
        this.abortHandlers = void 0;
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
}
module.exports["ClientDispatcher"] = $1c0fea79468f5804$export$3f5ba18eb97af725;

});

parcelRegister("btd1v", function(module, exports) {
function $d10c8fc86093c599$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
module.exports["buildGetUrl"] = $d10c8fc86093c599$export$28ae0033b80c6303;

});

parcelRegister("2NsNv", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $btd1v = parcelRequire("btd1v");


var $2KNo7 = parcelRequire("2KNo7");

const $207d5e1e54100856$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $207d5e1e54100856$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
function $207d5e1e54100856$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $iDrrr.fg)('hot-302159-relay-get-killswitch')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = (0, $btd1v.buildGetUrl)(baseUrl, variables).length;
    const headersSize = (0, $2KNo7.calculateHeadersSize)(headers || {});
    return queryLength <= $207d5e1e54100856$var$MAX_QUERY_LENGTH && headersSize <= $207d5e1e54100856$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
module.exports["shouldUseGetMethod"] = $207d5e1e54100856$export$5ad31d96a9271d42;

});

parcelRegister("aYNQr", function(module, exports) {

var $3EelF = parcelRequire("3EelF");

async function $e351b434d7517805$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = (0, $3EelF.processChunk)(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) (0, $3EelF.processChunk)(incompleteChunk, boundaryString, observer);
    observer.complete();
}
module.exports["processStream"] = $e351b434d7517805$export$efb69f1fe7577739;

});

parcelRegister("3JBV7", function(module, exports) {
const $e18976bd97b24d7a$export$81189edc9b923717 = 1;
module.exports["RETRY_ATTEMPTS_LIMIT"] = $e18976bd97b24d7a$export$81189edc9b923717;

});

parcelRegister("8qPlF", function(module, exports) {
const $50c4b80eab2518de$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $50c4b80eab2518de$export$bf6cd96e19b2987f = 100;
const $50c4b80eab2518de$export$1ad8434180c5936c = 300000; // 5m
module.exports["WS_CLIENT_KEEP_ALIVE"] = $50c4b80eab2518de$export$8b012b965402e06a;
module.exports["WS_CLIENT_RETRIES"] = $50c4b80eab2518de$export$bf6cd96e19b2987f;

});

parcelRegister("3iJiV", function(module, exports) {
const $264d8ff9343adf35$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $264d8ff9343adf35$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
module.exports["isSSR"] = $264d8ff9343adf35$export$48d7c418edadb60c;
module.exports["getAggSubscriptionEndpoint"] = $264d8ff9343adf35$export$29a72e89601dfc59;

});

parcelRegister("2KNo7", function(module, exports) {
// Calculate the size of the headers
function $c44df7643039027d$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
module.exports["calculateHeadersSize"] = $c44df7643039027d$export$dd754c3ef60c6999;

});

parcelRegister("3EelF", function(module, exports) {
function $9d750636a3cbd436$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
module.exports["processChunk"] = $9d750636a3cbd436$export$701544522b0c6c99;

});


$parcel$global.rlb("cuMia")
//# sourceMappingURL=blockSubscription.5ce3f514.js.map
